import { toast, growl } from "/WebInterface/new-ui/modules/toast.js";
import { Prompt, Confirm } from "/WebInterface/new-ui/modules/alert.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import ActivityTracking from "/WebInterface/new-ui/modules/activity-tracking/activity-tracking.js";
import ContextMenu from "/WebInterface/new-ui/modules/contextmenu/contextmenu.js";
import VirtualScroller from "/WebInterface/new-ui/modules/virtualscroll.js";
import FileTooltip from "/WebInterface/new-ui/modules/file-tooltip/file-tooltip.js";
import Tooltip from "/WebInterface/new-ui/modules/tooltip/tooltip.js";
import QuickViewSlider from "/WebInterface/new-ui/modules/quick-view-slider/quick-view-slider.js";
import Dropdown from "/WebInterface/new-ui/modules/dropdown/dropdown.js";
import { applySkeletonStyles } from "/WebInterface/new-ui/assets/js/utils/skeleton-styles.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import SessionChecker from "/WebInterface/new-ui/modules/session-checker.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import HashListener from "/WebInterface/new-ui/modules/hash-listener.js";
import DragDrop from "/WebInterface/new-ui/modules/drag-and-drop/drag-and-drop.js";
import MouseSelection from "/WebInterface/new-ui/modules/mouse-selection/mouse-selection.js";
import { applyCustomizations } from "/WebInterface/new-ui/modules/customizations/customizations.js";
import {
  downloadFileCardTemplate,
  noFilesAvailableTemplate,
  globalFileCardTemplate,
} from "/WebInterface/new-ui/modules/advanced-download/template.js";
import downloadingQueue from "/WebInterface/new-ui/modules/advanced-download/downloading-queue.js";
import { applyUserCustomizationOption } from "/WebInterface/new-ui/modules/customizations/customizations.js";
import { setLanguage } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import Slideshow from "/WebInterface/new-ui/modules/slideshow/slideshow.js";
import {
  initAdvancedDownload,
  advancedDownloadSubscribeEvents,
} from "/WebInterface/new-ui/modules/advanced-download/advanced-download.js";
import { initTwoFactorAuthForceModal } from "/WebInterface/new-ui/modules/modals/two-factor-auth-force/two-factor-auth-force.js";
import store from "/WebInterface/new-ui/store/index.js";
import C from "/WebInterface/new-ui/assets/js/utils/log.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import breadcrumbs from "/WebInterface/new-ui/assets/js/app/components/breadcrumbs.js";
import menubar from "/WebInterface/new-ui/assets/js/app/components/menubar.js";
import userActions from "/WebInterface/new-ui/assets/js/app/user-actions.js";
import ListingTemplates from "/WebInterface/new-ui/assets/js/app/templates/listing.js";
import ListingTemplatesBasket from "/WebInterface/new-ui/assets/js/app/templates/basket.js";
import resizableTemplate from "/WebInterface/new-ui/assets/js/app/templates/resizable.js";
import RenderWelcomeForm from "/WebInterface/new-ui/modules/modals/welcome-form/welcome-form.js";
import {
  LoggedInInfoTemplate,
  LoggedInInfoTriggerButtonTemplate,
} from "/WebInterface/new-ui/assets/js/app/templates/loggedInInfo.js";
import CustomThemeTemplate from "/WebInterface/new-ui/assets/js/app/templates/custom-theme.js";
import FilterSectionTemplate, {
  searchFilterResultTemplate,
} from "/WebInterface/new-ui/assets/js/app/templates/filter-section.js";
import uploadBarSectionTemplate from "/WebInterface/new-ui/assets/js/app/templates/upload-bar.js";
import {
  fileTypes,
  sortingOrder,
  filesViewTypes,
  sortingFields,
  operationStatus,
  selectFileTypes,
  defaultThemeColors,
  defaultFileListingColumnsOrder,
  slideShowAllowedFilesExtensions,
  mediaTypes,
  defaultContextMenuItems,
} from "/WebInterface/new-ui/assets/js/constants.js";
import {
  apiCall,
  getUserInfo,
  isLoggedIn,
  getListingFromPath,
  doLogout,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { showGetUserInfoErrorModal } from "/WebInterface/new-ui/modules/getUserInfo-error-modal.js";
import {
  loadNewUploadIFrameMiddleWare,
  showUploadModalAndListFiles,
} from "/WebInterface/new-ui/upload/js/middleware.js";
import versionData from "/WebInterface/new-ui//version.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";
import {
  applyCSSThemeVariables,
  generateCSSThemeSnippet,
} from "/WebInterface/new-ui/assets/js/utils/common.js";
import { initListingColumnArrangement } from "/WebInterface/new-ui/modules/modals/file-listing-column-arrangement/file-listing-column-arrangement.js";
import {
  fetchReverseNotificationDataAndStoreInRedux,
  manageSubscribedEventsStoreSubscribeEvents,
} from "/WebInterface/new-ui/modules/modals/manage-subscribed-events/manage-subscribed-events.js";
import {
  getFilePreviewGrid,
  getFilePreviewList,
  getAudioPreviewGrid,
  getAudioPreviewList,
  getVFSIcon,
  ColumnsMapping,
  FilterSectionTexts,
  DownloadFileCardTemplateTexts,
  LoggedInInfoTexts,
  isExtensionIncluded,
} from "/WebInterface/new-ui/assets/js/app/file-listing/file-listing.common.js";

C.setEnvironment("dev");
C.setSaveLogs(true);
C.success("Starting the application, Logs initiated");
C.warn("Warn check");
C.error("Error check");
C.log("Log check");

// Global module variables
let tooltipForDashboardFileListing;
let tooltipForBasketFileListing;
let quickViewSlider;
let contextMenu;
let hashListener;
let virtualScroller;
let virtualScrollerBasket;
let virtualScrollerDownload;
let activityTracking;
let basket;
let sessionChecker;
let _defaultThemeColors = defaultThemeColors;
let _customThemePreviewActive = false;

const applyCustomThemePreview = () => {
  if (!_customThemePreviewActive) {
    return;
  }

  applyCSSThemeVariables(_defaultThemeColors);

  const themeMessage = {
    key: "applyTemporaryTheme",
    value: _defaultThemeColors,
  };

  _$("#fileUploadIframe").el()?.contentWindow?.postMessage(themeMessage);
  _$("#manageShareIframe").el()?.contentWindow?.postMessage(themeMessage);
  _$("#revisionsIframe").el()?.contentWindow?.postMessage(themeMessage);
};

window.addEventListener("themeChanged", applyCustomThemePreview);
let searchFilterRequest;
let lastSelectedFileID = null;
let lastFocusedElementIDTreeView = null;
let lastRangedFocusedElementIDTreeView = null;
let buttonsTooltip;
let welcomFormSubmitCallback;
let appliedFilterFromQuery = false;

// Global Variables
let canRemoveFocusedFiles = false;
let sessionReviveIntervalId;
let selectedPage = 1;
let itemsPerPage = 100;
let totalPagesForPagination = 1;

const expandedFolderSet = new Set();

// Max column width for sanity clamping (exact pixel column resize)
const MAX_COLUMN_WIDTH_PX = 4000;
const DEFAULT_MIN_COLUMN_WIDTH_PX = 50;

// Exact pixel width for columns: clamp to [minW, MAX_COLUMN_WIDTH_PX], no rounding to steps
const exactColumnWidth = (width, minW = DEFAULT_MIN_COLUMN_WIDTH_PX) => {
  const n = typeof width === "number" ? width : parseFloat(width) || 0;
  return Math.round(Math.max(minW, Math.min(MAX_COLUMN_WIDTH_PX, n)));
};

// Helper function to remove a folder and all its child folders from expandedFolderSet
const removeExpandedFolderAndChildren = (folderPath) => {
  const pathsToRemove = [];

  // Find all paths that start with the current folder path
  for (const path of expandedFolderSet) {
    if (path.startsWith(folderPath)) {
      pathsToRemove.push(path);
    }
  }

  // Remove all found paths
  pathsToRemove.forEach((path) => expandedFolderSet.delete(path));
};

const applyTreeIndentation = (rowElement) => {
  const nameCell = rowElement?.querySelector("[data-padding-left]");
  if (!nameCell) return;

  const paddingLeft = parseInt(nameCell.getAttribute("data-padding-left"), 10);
  if (Number.isNaN(paddingLeft)) return;

  _$(nameCell).css("padding-left", `${Math.max(0, paddingLeft)}px`);
};

const checkAndToggleExpandedFolder = async (path = "/", currentElementId) => {
  const { files } = store;
  let _files = utils.deepCopy(files);
  const currentPath = path.endsWith("/") ? path : path + "/";

  const isCurrentFile = (file) => {
    if (currentElementId) {
      return file.id === currentElementId;
    }
    const fileHrefPath = file.href_path;
    const hrefPath = fileHrefPath.endsWith("/")
      ? fileHrefPath
      : fileHrefPath + "/";
    return hrefPath === currentPath;
  };

  const currentClickedItem = _files.find(isCurrentFile);
  const selectedFileIndex = _files.findIndex(isCurrentFile);

  if (!currentClickedItem || selectedFileIndex === -1) {
    expandedFolderSet.delete(currentPath);
    return;
  }

  let paddingLeft = 12;
  if (currentClickedItem.paddingLeft) {
    paddingLeft = parseInt(currentClickedItem.paddingLeft, 10) + 20;
  }

  const dataTreeId = currentClickedItem.treeIds;

  let isChecked = false;
  if (_files[selectedFileIndex].isChecked) isChecked = true;

  let element = _files[selectedFileIndex];
  element.ariaExpanded = true;

  const loading = new Loader({ parentElement: "#dashboard-files-section" });
  expandedFolderSet.add(currentPath);

  try {
    const data = await getListingFromPath(utils.encodeURILocal(currentPath));
    const error_msg = data?.error_msg;
    if (error_msg) {
      growl(
        "",
        error_msg === "string"
          ? error_msg
          : t("somethingWentWrongWithFileListing"),
        5000,
        true
      );
    }
    const { listing, privs } = data;

    if (listing) {
      _files[selectedFileIndex].ariaExpanded = true;

      const manipulatedList = listing.map((item, index) => {
        const id = utils.getUId();
        return {
          ...item,
          privs: item.privs || privs,
          preview: parseInt(item.preview),
          mediaInfo: utils.isMedia(item.name),
          id: `${id}`,
          treeIds: `${id}-${dataTreeId}`,
          paddingLeft,
          ariaExpanded: false,
          isChecked,
        };
      });

      const _manipulatedList = utils.checkOptionsAndSort(manipulatedList, true);

      _files[selectedFileIndex].isDataAdded = true;
      _files.splice(selectedFileIndex + 1, 0, ..._manipulatedList);
      store.dispatch("updateFileListing", _files);
    }
  } catch (error) {
    growl("", t("somethingWentWrongWithFileListing"), 5000, true);
  } finally {
    loading.deleteLoader();
  }
};

//* Method Collections
const profileInfo = () => {
  const browserNameElement = _$("#browserName");
  const hostURLElement = _$("#hostURL");
  const hostNameElement = _$("#hostName");

  browserNameElement.text(utils.getBrowserName());
  hostURLElement.text(location.href);
  hostNameElement.text(location.hostname);
};

const focusElement = (element, preventScroll = false) => {
  if (element) {
    element.focus({ preventScroll });
    _$(element).addClass("focused");
  }
};

const checkFilePreviewAvailable = (file) => {
  return (
    file.preview > 0 ||
    file.mediaInfo.type === mediaTypes.VIDEO ||
    file.mediaInfo.type === mediaTypes.AUDIO ||
    slideShowAllowedFilesExtensions.includes(utils.getFileExtension(file))
  );
};

const updatePaginationColumns = (selected = 3, total = 0) => {
  if (!total || total === 1) {
    _$("#listing-pagination").addClass("is-hidden");
    return;
  }

  _$("#listing-pagination").removeClass("is-hidden");
  _$("#listing-pagination .pagination-link.is-current").removeClass(
    "is-current"
  );
  _$("#listing-pagination .pagination-ellipsis").removeClass("is-hidden");

  const prev = selected - 1;
  const next = selected + 1;

  let start = prev;

  if (prev === 1 || selected === 1) {
    _$("#listing-pagination .pagination-ellipsis.left").addClass("is-hidden");
    start = 2;
  }

  if (next === total || selected === total) {
    _$("#listing-pagination .pagination-ellipsis.right").addClass("is-hidden");
    start = total - 3;
  }

  if (total <= 5) {
    _$("#listing-pagination .pagination-ellipsis").addClass("is-hidden");
  }

  const paginations = _$("#listing-pagination .pagination-link").sel();

  const updateSelectedPage = (item, page) => {
    if (page === selected) {
      _$(item).addClass("is-current");
    }
  };

  paginations.forEach((item, index) => {
    _$(item).removeClass("is-hidden");

    if (index === 0) {
      updateSelectedPage(item, 1);
      return;
    }

    if (index === paginations.length - 1) {
      updateSelectedPage(item, total);
      _$(item).text(total);
      return;
    }

    const page = start + index - 1;

    if (page <= 1 || page >= total) {
      _$(item).addClass("is-hidden");
    }

    updateSelectedPage(item, page);
    _$(item).text(page);
  });
};

const updatePaginationSelectedInfo = (filesList) => {
  const selectedFilesLabel = _$("#pagination-file-selection-info");
  const selectedFilesLabelInfo = _$("#pagination-file-selected-info");

  if (!selectedFilesLabel.el() || !selectedFilesLabelInfo.el()) {
    return;
  }

  const startIndex = (selectedPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filesList.length);

  let selectedFoldersLength = 0;
  let selectedFilesLength = 0;
  let totalFoldersLength = 0;
  let totalFilesLength = 0;

  for (let i = startIndex; i < endIndex; i++) {
    const file = filesList[i];

    if (file.type === fileTypes.FILE) {
      totalFilesLength++;

      if (file.isChecked) {
        selectedFilesLength++;
      }
    } else {
      totalFoldersLength++;

      if (file.isChecked) {
        selectedFoldersLength++;
      }
    }
  }

  const totalSelectedFilesFolderLength =
    selectedFoldersLength + selectedFilesLength;
  const totalFilesFolder = endIndex - startIndex;

  const elementToEnableOnFilesSelection = _$(
    ".pagination-selected-file-enable"
  );
  elementToEnableOnFilesSelection.toggleClass(
    "is-hidden",
    totalSelectedFilesFolderLength === 0
  );

  selectedFilesLabelInfo.attr(
    "data-i18n-opt",
    JSON.stringify({
      totalSelectedFilesFolder: totalSelectedFilesFolderLength,
      selectedFolder: selectedFoldersLength,
      selectedFiles: selectedFilesLength,
    })
  );

  selectedFilesLabel.attr(
    "data-i18n-opt",
    JSON.stringify({
      totalFilesFolder: totalFilesFolder,
      totalFolder: totalFoldersLength,
      totalFiles: totalFilesLength,
    })
  );

  selectedFilesLabelInfo.text(
    t("footerSelectedFileInfo", {
      totalSelectedFilesFolder: totalSelectedFilesFolderLength,
      selectedFolder: selectedFoldersLength,
      selectedFiles: selectedFilesLength,
    })
  );

  selectedFilesLabel.text(
    t("footerFileSelectionInfo", {
      totalFilesFolder: totalFilesFolder,
      totalFolder: totalFoldersLength,
      totalFiles: totalFilesLength,
    })
  );
};

const filterPaginationFiles = (files) => {
  const paginationAfterCount = utils.getUserCustomizationValue(
    "paginationAfterCount",
    true
  );

  if (!paginationAfterCount || files.length < Number(paginationAfterCount)) {
    _$("#listing-pagination-wrapper").addClass("is-hidden");
    return files;
  } else {
    _$("#listing-pagination-wrapper").removeClass("is-hidden");
  }

  if (itemsPerPage === -1) {
    itemsPerPage = files.length;
  }

  totalPagesForPagination = Math.ceil(files.length / itemsPerPage);
  if (totalPagesForPagination < selectedPage) {
    selectedPage = 1;
  }
  updatePaginationColumns(selectedPage, totalPagesForPagination);
  updatePaginationSelectedInfo(files);

  const startIndex = (selectedPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return files.slice(startIndex, endIndex);
};

const getFileByID = (id) => {
  const files = utils.deepCopy(store.files);
  return files?.find((file) => file.id === id) || null;
};

// Handling Mobile Menu
const handleMobileMenu = () => {
  _$(".user-buttons-section").toggleClass("is-flex").el();

  const showMobileMenuButton = _$("#show-mobile-menu");
  const iconReorder = showMobileMenuButton.find(".icon-reorder").el();
  const iconRemove = showMobileMenuButton.find(".icon-remove").el();

  if (iconReorder) {
    iconReorder.className = "icon-remove text-primaryMain";
  }
  if (iconRemove) {
    iconRemove.className = "icon-reorder text-primaryMain";
  }
};

const resizeBasket = () => {
  const gridItemContainer = _$("#basket-grid-container").el();
  const vHeight = _$("#modal_UI_Basket").el().offsetHeight;
  const height = utils.getFitHeight(gridItemContainer, vHeight, 42, false);
  if (height) _$(gridItemContainer).css("height", height);
};

const refreshListing = () => {
  const curPath = hashListener.getPath();
  if (curPath) {
    const scrollTopBeforeRerender = virtualScroller?.container?.scrollTop || 0;
    fetchListingFromPath(curPath, false, scrollTopBeforeRerender);
  } else {
    hashListener.setPath("/", true);
  }
};

const handleFilesSort = (type, from) => {
  utils.clearRangeSelection();

  if (from === "BASKET") {
    store.dispatch("setBasketItemsOnSort", { action: type });
    return;
  }

  const sortingStatus = JSON.parse(utils.storage.get("sortingStatus")) || {};
  const sortingType =
    sortingStatus[type] === sortingOrder.ASC
      ? sortingOrder.DES
      : sortingOrder.ASC;

  utils.storage.set(
    "sortingStatus",
    JSON.stringify({
      ...sortingStatus,
      active: type,
      [type]: sortingType,
    })
  );

  store.dispatch("setFileListingOnSort");
};

const bindSortEvents = (sortFields, context = "") => {
  sortFields.forEach((sortField) => {
    sortField.element.on("click", () => {
      handleFilesSort(sortField.field, context);
    });
  });
};

const bindSortEventsForList = () => {
  const sortListFields = [
    { element: _$("#dashboard-name-sort-list"), field: sortingFields.NAME },
    {
      element: _$("#dashboard-root_dir-sort-list"),
      field: sortingFields.ROOT_DIR,
    },
    { element: _$("#dashboard-size-sort-list"), field: sortingFields.SIZE },
    {
      element: _$("#dashboard-keywords-sort-list"),
      field: sortingFields.KEYWORDS,
    },
    {
      element: _$("#dashboard-created-sort-list"),
      field: sortingFields.CREATED,
    },
    {
      element: _$("#dashboard-modified-sort-list"),
      field: sortingFields.LAST_MODIFIED,
    },
  ];

  bindSortEvents(sortListFields);
};

const bindSortEventsGrid = () => {
  const sortGridFields = [
    { element: _$("#dashboard-name-sort-grid"), field: sortingFields.NAME },
    { element: _$("#dashboard-size-sort-grid"), field: sortingFields.SIZE },
    {
      element: _$("#dashboard-modified-sort-grid"),
      field: sortingFields.LAST_MODIFIED,
    },
    {
      element: _$("#dashboard-keywords-sort-grid"),
      field: sortingFields.KEYWORDS,
    },
  ];

  bindSortEvents(sortGridFields);
};

const bindSortEventsBasket = () => {
  const sortFields = [
    { element: _$("#basket-name-sort-list"), field: sortingFields.NAME },
    { element: _$("#basket-size-sort-list"), field: sortingFields.SIZE },
    {
      element: _$("#basket-keywords-sort-list"),
      field: sortingFields.KEYWORDS,
    },
    {
      element: _$("#basket-created-sort-list"),
      field: sortingFields.CREATED,
    },
    {
      element: _$("#basket-modified-sort-list"),
      field: sortingFields.LAST_MODIFIED,
    },
    {
      element: _$("#basket-root_dir-sort-list"),
      field: sortingFields.ROOT_DIR,
    },
  ];

  bindSortEvents(sortFields, "BASKET");
};

const bindSortEventsBasketGrid = () => {
  const sortBasketGridFields = [
    { element: _$("#basket-name-sort-grid"), field: sortingFields.NAME },
    { element: _$("#basket-size-sort-grid"), field: sortingFields.SIZE },
    {
      element: _$("#basket-modified-sort-grid"),
      field: sortingFields.LAST_MODIFIED,
    },
    {
      element: _$("#basket-keywords-sort-grid"),
      field: sortingFields.KEYWORDS,
    },
  ];

  bindSortEvents(sortBasketGridFields, "BASKET");
};

const bindPaginationListener = () => {
  const paginationAfterCount = utils.getUserCustomizationValue(
    "paginationAfterCount",
    true
  );

  if (!paginationAfterCount) {
    _$("#listing-pagination-wrapper").remove();
    return;
  }

  _$("#listing-pagination-wrapper").removeClass("is-hidden");

  const itemsPerPageDropdown = _$(
    ".listing-pagination-wrapper select.items-per-page-dropdown"
  );

  const itemsPerPageDropdownWrapper = _$(
    ".listing-pagination-wrapper .items-per-page-dropdown-wrapper"
  );

  const paginationShowPageSizeSelector = utils.getUserCustomizationValue(
    "paginationShowPageSizeSelector"
  );

  const hidePageSizeSelectionLink = utils.getUserCustomizationValue(
    "hidePageSizeSelectionLink"
  );

  if (!paginationShowPageSizeSelector || hidePageSizeSelectionLink) {
    itemsPerPageDropdownWrapper.remove();
  }

  const defaultItemsPerPage = utils.getUserCustomizationValue(
    "defaultItemsPerPage",
    true
  );

  if (defaultItemsPerPage) {
    const value = parseInt(defaultItemsPerPage);
    if (!isNaN(value)) {
      itemsPerPage = value;
      const option = _$("<option>");
      option.text(defaultItemsPerPage);
      option.val(defaultItemsPerPage);
      option.attr("hidden", true);
      option.attr("selected", true);
      itemsPerPageDropdown.el().appendChild(option.el());
    }
  }

  itemsPerPageDropdown.on("change", () => {
    itemsPerPage = Number(itemsPerPageDropdown.val());
    renderFiles({ hasUpdates: false });
  });

  _$("#listing-pagination .pagination-link").on("click", (e) => {
    const curItem = _$(e.currentTarget);
    if (selectedPage === Number(curItem.text())) {
      return;
    }

    selectedPage = Number(curItem.text());
    renderFiles({ hasUpdates: false });
  });

  _$("#listing-pagination .pagination-previous").on("click", (e) => {
    if (selectedPage <= 1) {
      return;
    }
    selectedPage--;
    renderFiles({ hasUpdates: false });
  });

  _$("#listing-pagination .pagination-next").on("click", (e) => {
    if (selectedPage >= totalPagesForPagination) {
      return;
    }
    selectedPage++;
    renderFiles({ hasUpdates: false });
  });
};

const clearHighlight = (folders) =>
  folders.forEach((curFolder) => curFolder?.classList?.remove("focused"));

const bindDnDInteractivity = (draggable, droppable, type) => {
  const isList = type === filesViewTypes.LIST;
  let dragDrop = new DragDrop({
    draggable: draggable,
    droppable: droppable,
    generateTooltip: (element) => {
      const curPath = hashListener.getPath();
      const selectedItems = utils.getSelectedItems(store.files, curPath);
      const selectedPaths = [];
      selectedItems.map((selectedItem) =>
        selectedPaths.push(selectedItem.href_path)
      );
      const tip = utils.generateHTML([
        {
          type: "div",
          children: [
            {
              type: "label.label",
              text: "Selected files:",
            },
            {
              type: "pre.scroll",
              text:
                selectedPaths.length === 0
                  ? isList
                    ? element.querySelector(".name").innerText
                    : element.innerText
                  : selectedPaths.length > 5
                    ? selectedPaths.slice(0, 5).join("\r\n") +
                      `\r\n(and ${selectedPaths.length - 5} more...)`
                    : selectedPaths.join("\r\n"),
            },
          ],
        },
      ]);
      return tip.innerHTML;
    },
    onDragStart: (evt, target) => {
      _$("#dragTopInfo-notification").removeClass("is-hidden");
      _$("#dragTopInfo-notification").addClass("is-flex");

      const curPath = hashListener.getPath();
      tooltipForDashboardFileListing.removeTooltip(evt);

      if (evt.ctrlKey || evt.metaKey) {
        dragDrop.hideTooltip();
        const selectedItems = utils.getSelectedItems(store.files, curPath);
        const targetedFile = getFileByID(target.getAttribute("data-uid"));

        const files = [targetedFile, ...selectedItems];
        const { protocol, port, hostname } = location;
        const link = `${protocol}//${hostname}:${port}`;
        const c2f = utils.cookie.get("currentAuth");

        const defaultZipNameWhileDownloading = utils.getUserCustomizationValue(
          "defaultZipNameWhileDownloading",
          true
        );

        let downloadName = defaultZipNameWhileDownloading || "archive";

        if (files.length === 1) {
          const [file] = files;

          if (file.type === fileTypes.DIR) {
            downloadName = file.name;
          }

          if (file.type === fileTypes.FILE) {
            const url = `application/octet-stream:${file.name}:${link}${file.href_path}`;
            evt.dataTransfer.setData("DownloadURL", url);
            return;
          }
        }

        let paths = "";
        files.forEach((file) => {
          paths += `${file.href_path}:`;
        });

        const url = `application/octet-stream:${downloadName}.zip:${link}?command=downloadAsZip&zipName=${downloadName}.zip&path=${paths}&paths=${paths}&c2f=${c2f}`;
        evt.dataTransfer.setData("DownloadURL", url);
        return;
      }

      dragDrop.setDragPreview(evt);

      const dt = evt.dataTransfer;
      dt.effectAllowed = "move";
      dt.dropEffect = "move";
      dt.setData("text/plain", target.getAttribute("data-uid"));
    },
    onDragEnd: () => {
      clearHighlight(droppable);
      _$("#dragTopInfo-notification").removeClass("is-flex");
      _$("#dragTopInfo-notification").addClass("is-hidden");
    },
    onDragEnter: (evt, target) => {
      if (target.id === "dashboard-files-section") return;

      clearHighlight(droppable);
      target.classList.add("focused");
    },
    onDrop: (evt, target) => {
      evt.stopPropagation();
      const fileId = evt.dataTransfer.getData("text/plain");

      if (!fileId) return;

      if (target.id === "dashboard-files-section") {
        growl(t("cantMoveItemsToSameFolder"), "", 5000, true);
        return;
      }

      clearHighlight(droppable);
      target.classList.remove("focused");

      const curPath = hashListener.getPath();
      const selectedFile = getFileByID(fileId);
      const isBasketDrop =
        _$(target).selfOrParent("#basket_icon") ||
        _$(target).selfOrParent("#modal_UI_Basket");
      if (isBasketDrop) {
        userActions.invoke({
          name: "addToBasket",
          curPath,
          context: selectedFile,
        });
      } else {
        const targetElm = isList
          ? _$(target).selfOrParent("tr").el()
          : _$(target).selfOrParent(".folder").el();

        const selectedItems = utils.getSelectedItems(store.files, curPath);
        const targetedFile = getFileByID(target.getAttribute("data-uid"));

        const files = [targetedFile, ...selectedItems];

        if (targetElm) {
          const targetId = targetElm.getAttribute("data-uid");
          const targetItem = getFileByID(targetId);
          const path = targetItem.href_path;

          if (targetItem) {
            const destinationName = targetItem.name;
            const movingItems = selectedItems.length > 0 ? selectedItems : [selectedFile];
            const itemCount = movingItems.filter(Boolean).length;
            const confirmBody = itemCount > 1
              ? t("areYouSureYouWantToMoveItemsTo")
                  .replace("{count}", itemCount)
                  .replace("{destination}", destinationName)
              : t("areYouSureYouWantToMoveItemTo")
                  .replace("{itemName}", selectedFile?.name || "")
                  .replace("{destination}", destinationName);

            Confirm({
              title: t("confirm"),
              body: confirmBody,
              confirm: t("yes"),
              cancel: t("no"),
            }).then((res) => {
              if (res === null) return;

              userActions.invoke({
                name: "performAction('cut')",
                curPath,
                context: selectedFile,
              });
              setTimeout(() => {
                if (files.length > 1) {
                  userActions.invoke({
                    name: "performAction('paste')",
                    curPath:
                      targetItem.type.toLowerCase() === "dir"
                        ? targetItem.href_path
                        : targetItem.root_dir,
                    skipRename: true,
                  });
                  return;
                }

                const loader = new Loader({});
                ajax
                  .call({
                    data: {
                      command: "getXMLListing",
                      format: "JSONOBJ",
                      path: utils.encodeURILocal(
                        path.endsWith("/") ? path : path + "/"
                      ),
                    },
                    timeout: 10000000,
                  })
                  .then((result) => {
                    if (result) {
                      const { listing } = result;
                      if (!listing) {
                        return;
                      }
                      const foundSameItem = listing.find(
                        (item) => item.name === selectedFile.name
                      );

                      if (!foundSameItem) {
                        userActions.invoke({
                          name: "performAction('paste')",
                          curPath:
                            targetItem.type.toLowerCase() === "dir"
                              ? targetItem.href_path
                              : targetItem.root_dir,
                          skipRename: true,
                        });
                        return;
                      }

                      const promptForName = () => {
                        Prompt({
                          title: t(
                            "folderWithTheSameNameAlreadyExistsPleaseSelectDifferentName"
                          ),
                          confirm: t("Rename"),
                          placeholder: "File name",
                          cancel: t("cancel"),
                          closable: true,
                          inputAttrs: {
                            value: selectedFile.name,
                          },
                        }).then((res) => {
                          if (res === null) return;
                          userActions.invoke({
                            name: "performAction('paste')",
                            newName: res?.value,
                            curPath:
                              targetItem.type.toLowerCase() === "dir"
                                ? targetItem.href_path
                                : targetItem.root_dir,
                            skipRename: true,
                          });
                        });
                      };
                      promptForName();
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  })
                  .always(() => {
                    loader.deleteLoader();
                  });
              }, 100);
            });
          }
        }
      }
    },
  });
};

const renderSortIcon = (suffixId, source) => {
  let sortingStatus;
  if (source === "dashboard") {
    sortingStatus = JSON.parse(utils.storage.get("sortingStatus"));
  } else if (source === "basket") {
    sortingStatus = utils.deepCopy(store.basketDetails);
  }

  const activeSort = sortingStatus?.active;

  if (sortingStatus) {
    const sortingTypes = Object.entries(sortingStatus)
      .filter(
        ([key]) =>
          key !== (source === "dashboard" ? "active" : "keepDirectoryOnTop")
      )
      .map(([sortingType, type]) => ({
        id: `${source}-${sortingType}-sort-${suffixId}`,
        type,
        show: sortingType === activeSort,
      }));

    utils.renderSortIconFromID(sortingTypes);
  }
};

const showSkeleton = () => {
  const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;

  if (gridType === filesViewTypes.LIST) {
    const listSkeletonContainer = utils.generateHTML([
      {
        type: "div",
        attrs: {
          class: "skeleton skeleton-list",
          "data-lines": "11",
          "data-c-w": "100%",
          "data-l-h": "22px",
          "data-bg": "var(--bg-skeleton)",
        },
      },
    ]);
    _$("#dashboard-files-section").empty().append(listSkeletonContainer);
    // Apply CSS custom properties from data attributes (CSP-compliant via setProperty)
    applySkeletonStyles(listSkeletonContainer);
  } else {
    const gridSkeletonContainer = utils.generateHTML([
      {
        type: "div",
        attrs: {
          class:
            gridType === filesViewTypes.GRID
              ? "grid-container"
              : gridType === filesViewTypes.MEDIUM_GRID
                ? "grid-container medium-grid-container"
                : "grid-container large-grid-container",
        },
      },
    ]);
    for (let j = 0; j < 15; j++) {
      const gridSkeleton = utils.generateHTML([
        {
          type: "div",
          attrs: {
            class: "skeleton skeleton-rect",
            "data-rect-h": "100px",
            "data-c-w": "100%",
            "data-bg": "var(--bg-skeleton)",
          },
        },
      ]);
      const skeletonChild = gridSkeleton.firstElementChild;
      gridSkeletonContainer.children[0].append(skeletonChild || gridSkeleton);
    }
    // Apply CSS custom properties from data attributes (CSP-compliant via setProperty)
    applySkeletonStyles(gridSkeletonContainer);
    _$("#dashboard-files-section").empty().append(gridSkeletonContainer);
  }

  // Create a wrapper container specifically for skeletons with no-wrap styling
  const buttonSkeletonContainer = utils.generateHTML([
    {
      type: "div",
      attrs: {
        class: "is-flex is-flex-wrap-nowrap w-full gap-1 skeleton-container",
      },
    },
  ]);
  // Show only one line of skeletons (6 skeletons) - equal width, no wrap
  for (let j = 0; j < 6; j++) {
    const buttonSkeleton = utils.generateHTML([
      {
        type: "div",
        attrs: {
          class: "skeleton skeleton-line flex-grow-1",
          "data-lines": "1",
          "data-l-h": "24px",
          "data-c-w": "100%",
          "data-c-p": "0px",
          "data-bg": "var(--bg-skeleton)",
        },
      },
    ]);
    const skeletonChild = buttonSkeleton.firstElementChild;
    buttonSkeletonContainer.children[0].append(skeletonChild || buttonSkeleton);
  }
  // Apply CSS custom properties from data attributes (CSP-compliant via setProperty)
  applySkeletonStyles(buttonSkeletonContainer);

  _$("#user-buttons").empty().append(buttonSkeletonContainer);
};

const handleToggleFiles = (fileElements, isChecked) => {
  const fileIds = fileElements.reduce((accumulator, currentValue) => {
    const id = currentValue.getAttribute("data-uid");
    if (isChecked) {
      currentValue.classList.remove("focused");
      currentValue.classList.add("selected");
    } else {
      currentValue.classList.remove("selected");
    }
    _$(currentValue).find('input[type="checkbox"]')[0].checked = isChecked;
    return {
      ...accumulator,
      [id]: isChecked,
    };
  }, {});
  store.dispatch("handleToggleFileFromIDs", fileIds);
};

const getFocusedFilesByActiveView = () => {
  const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;

  if (gridType === filesViewTypes.LIST) {
    return _$("#dashboard-files-section .table-tr.focused").sel();
  }
  return _$("#dashboard-files-section .grid-item.focused").sel();
};

const getSelectedFilesByActiveView = () => {
  const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;

  if (gridType === filesViewTypes.LIST) {
    return _$("#dashboard-files-section .table-tr.selected").sel();
  }
  return _$("#dashboard-files-section .grid-item.selected").sel();
};

/* START HandleFooterSelectionInfo */

const filterFilesByGridType = (files, gridType, curPath) => {
  const isSearchFilterActive = store?.searchFilterDetails?.isSearchFilterActive;

  if (gridType === filesViewTypes.LIST || isSearchFilterActive) {
    return files;
  } else {
    return files.filter((file) => file.root_dir === curPath);
  }
};

const updateFileSelection = (files) => {
  const elements = _$("#dashboard-files-section").find("[data-uid]");
  Array.from(elements).forEach((element) => {
    const id = element.getAttribute("data-uid");
    const file = files.find((file) => file.id === id);

    if (file) {
      const checkbox = _$(element).find('input[type="checkbox"]').el();
      if (checkbox) {
        if (file.isChecked) {
          element.classList.add("selected");
          checkbox.checked = true;
        } else {
          element.classList.remove("selected");
          checkbox.checked = false;
        }
      }
    }
  });
};

const updateCheckAllCheckbox = (files) => {
  const checkAll = _$("#checkAll").el();
  if (checkAll) {
    const totalFilesFolder = files.length;
    const totalSelectedFilesFolderLength = files.filter(
      (file) => file.isChecked
    ).length;
    checkAll.checked =
      totalSelectedFilesFolderLength === totalFilesFolder &&
      totalFilesFolder > 0;
  }
};

const updateSelectedFilesLabel = (files) => {
  const totalFiles = files.filter((file) => file.type === fileTypes.FILE);
  const totalFolders = files.filter((file) => file.type === fileTypes.DIR);
  const selectedFiles = files.filter(
    (file) => file.isChecked && file.type === fileTypes.FILE
  );
  const selectedFolders = files.filter(
    (file) => file.isChecked && file.type === fileTypes.DIR
  );

  const selectedFoldersLength = selectedFolders.length;
  const selectedFilesLength = selectedFiles.length;
  const totalSelectedFilesFolderLength =
    selectedFoldersLength + selectedFilesLength;
  const totalFoldersLength = totalFolders.length;
  const totalFilesLength = totalFiles.length;
  const totalFilesFolder = totalFoldersLength + totalFilesLength;

  const elementToEnableOnFilesSelection = _$(".footer-selected-file-enable");
  if (totalSelectedFilesFolderLength > 0) {
    if (elementToEnableOnFilesSelection.hasClass("is-hidden"))
      elementToEnableOnFilesSelection.removeClass("is-hidden");
  } else elementToEnableOnFilesSelection.addClass("is-hidden");

  const selectedFilesLabel = _$("#footer-file-selection-info");
  const selectedFilesLabelInfo = _$("#footer-file-selected-info");

  selectedFilesLabelInfo.attr(
    "data-i18n-opt",
    JSON.stringify({
      totalSelectedFilesFolder: totalSelectedFilesFolderLength,
      selectedFolder: selectedFoldersLength,
      selectedFiles: selectedFilesLength,
    })
  );

  selectedFilesLabel.attr(
    "data-i18n-opt",
    JSON.stringify({
      totalFilesFolder: totalFilesFolder,
      totalFolder: totalFoldersLength,
      totalFiles: totalFilesLength,
    })
  );

  selectedFilesLabelInfo.text(
    t("footerSelectedFileInfo", {
      totalSelectedFilesFolder: totalSelectedFilesFolderLength,
      selectedFolder: selectedFoldersLength,
      selectedFiles: selectedFilesLength,
    })
  );

  selectedFilesLabel.text(
    t("footerFileSelectionInfo", {
      totalFilesFolder: totalFilesFolder,
      totalFolder: totalFoldersLength,
      totalFiles: totalFilesLength,
    })
  );
};

const handleFooterSelectionInfo = () => {
  const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;
  const copiedFiles = utils.deepCopy(store.files);
  const curPath = hashListener.getPath();

  const filteredFiles = filterFilesByGridType(copiedFiles, gridType, curPath);
  updateFileSelection(filteredFiles);
  updateCheckAllCheckbox(filteredFiles);
  updateSelectedFilesLabel(filteredFiles);
  updatePaginationSelectedInfo(filteredFiles);
};

/* END HandleFooterSelectionInfo */

const canPreventLogout = () => {
  const {
    isUploading,
    isDownloading,
    isFilesOnUploadQueue,
    isFilesOnDownloadQueue,
  } = store.chunkProcessingStatus;

  if (
    isUploading ||
    isDownloading ||
    isFilesOnUploadQueue ||
    isFilesOnDownloadQueue
  ) {
    return true;
  }
  return false;
};

let preventTabLevelAction = false;

const confirmExit = () => {
  if (preventTabLevelAction) return;
  preventTabLevelAction = false;

  const logoutOnPageClose =
    utils.getUserCustomizationValue("logoutOnPageClose");
  if (logoutOnPageClose && !window.redirectingToLink && !window.isLoggingOut) {
    logout(true).catch(console.error);
  }

  const {
    isUploading,
    isDownloading,
    isFilesOnUploadQueue,
    isFilesOnDownloadQueue,
  } = store.chunkProcessingStatus;
  if (
    isUploading ||
    isDownloading ||
    isFilesOnUploadQueue ||
    isFilesOnDownloadQueue
  ) {
    return true;
  }
};

const handleHotKeyPressContextMenu = (e) => {
  if (e.key?.length > 1 || !e?.key?.match(/[a-zA-Z0-9]/)) {
    return;
  }

  _$("#context-menu .context-menu-container .context-menu-item")
    .sel()
    .forEach((button) => {
      const hotkey = _$(button).find(".hotkey", true)?.innerText?.toLowerCase();
      if (!hotkey || hotkey !== e.key?.toLowerCase()) {
        return;
      }

      button.click();
      e.preventDefault();
      e.stopPropagation();
    });
};
//* End Method Collections

const setContextMenu = (folderDiv, item, fileViewType, fromBasket) => {
  const enableHotkeys = utils.getUserCustomizationValue("enableHotkeys");

  const handleDeleteHotKey = (e) => {
    if (e.code === "Delete" || e.code === "Backspace") {
      userActions.invoke({
        name: "performAction('delete');",
        curPath: item.root_dir || hashListener.getPath(),
        context: item,
      });

      contextMenu.closeMenu();
    }
  };

  folderDiv.addEventListener("contextmenu", (e) => {
    window.focus();
    document.body.focus();
    const target = e.target;
    contextMenu.init({
      contextMenuItems: contextMenu.menuForCurrentItem(item, fromBasket),
      onBeforeShow: (el) => {
        const gridType = fileViewType || filesViewTypes.GRID;
        if (gridType === filesViewTypes.LIST) {
          _$(_$(target).selfOrParent(".table-body"))
            .find(".on-context")
            .sel()
            .forEach((element) => {
              _$(element).removeClass("on-context");
            });

          const tr = _$(target).selfOrParent("tr.table-tr");
          tr.classList.add("on-context");
        }

        _$("#context-menu").addClass("context-menu-visible");

        if (enableHotkeys) {
          window.addEventListener("keydown", handleHotKeyPressContextMenu);
          window.addEventListener("keydown", handleDeleteHotKey);
        }
      },
      onClick: (btn, elem) => {
        if (btn && elem) {
          const { command, isLink } = btn;
          if (isLink === "true") {
            window.location = btn.link;
            return false;
          }
          userActions.invoke({
            name: command,
            curPath: elem.root_dir || hashListener.getPath(),
            loadedPath: hashListener.getPath(),
            context: elem,
            fromBasket,
          });
        }
      },
      onAfterShow: (el) => {},
      onBeforeHide: (el) => {
        _$(".on-context").removeClass("on-context");

        if (enableHotkeys) {
          window.removeEventListener("keydown", handleHotKeyPressContextMenu);
          window.removeEventListener("keydown", handleDeleteHotKey);
        }
      },
      onAfterHide: (el) => {
        _$("#context-menu").removeClass("context-menu-visible");
      },
    });
    contextMenu.handleContextMenu(e, item);
  });
};

const listViewColumnCustomizations = () => {
  const customizations = {
    canPathColumnEnable: utils.getUserCustomizationValue("SHOWPATH_COL"),
    canCheckboxColumnDisable: utils.getUserCustomizationValue("CHECK_COL"),
    canCreatedColumnEnable: utils.getUserCustomizationValue("CREATED_COL"),
    canNameColumnDisable: utils.getUserCustomizationValue("NAME_COL"),
    canModifiedColumnDisable: utils.getUserCustomizationValue("MODIFIED_COL"),
    canSizeColumnDisable: utils.getUserCustomizationValue("SIZE_COL"),
    canKeywordColumnDisable: utils.getUserCustomizationValue("KEYWORDS_COL"),
    listViewFontStyle: utils.getUserCustomizationValue("listTextStyle"),
    listViewFontSize: utils.getUserCustomizationValue("listTextSize"),
    canShowFullKeywords: utils.getUserCustomizationValue("showFullKeywords"),
  };

  return customizations;
};

// Sync body column widths from header so they match after layout/window resize (body rows can have different containing block)
const syncFileListingBodyColumnWidthsFromHeader = () => {
  const listContainer = _$("#dashboard-files-section .list-container");
  if (!listContainer.el()) return;
  const thead = listContainer.find("thead");
  const headerThs = thead.find("th").sel();
  headerThs.forEach((th) => {
    const id = th.id;
    const mapping = ColumnsMapping[id];
    if (!mapping?.class) return;
    const w = th.offsetWidth || th.getBoundingClientRect().width;
    if (w <= 0) return;
    _$(
      `#dashboard-files-section .list-container table tbody tr .${mapping.class}`
    )
      .sel()
      .forEach((td) => {
        _$(td).removeClass("w-full");
        _$(td).css("width", `${Math.round(w)}px`);
      });
  });
};

const listViewGetResizeAndOrderDetails = (body = false) => {
  const STORAGE_KEY = "file-listing-table-columns-arrangement";
  let columnsArrangement =
    JSON.parse(localStorage.getItem(STORAGE_KEY)) ||
    defaultFileListingColumnsOrder;

  const disableColumnResize = utils.getUserCustomizationValue(
    "disableColumnResize"
  );
  if (disableColumnResize) {
    columnsArrangement = defaultFileListingColumnsOrder;
  }

  const bodyWidth = _$("body").el()?.clientWidth || 1200;

  const nameColumnMinWidth = 400;
  const pathColumnMinWidth = 150;
  const sizeColumnMinWidth = 100;
  const modifiedColumnMinWidth = 100;
  const createdColumnMinWidth = 100;
  const keywordsColumnMinWidth = 100;

  const defaultPercents = {
    name: 40,
    path: 12,
    size: 10,
    modified: 10,
    created: 10,
    keywords: 18,
  };

  const asPercent = (width, defaultPercent) => {
    if (width == null) return defaultPercent;
    if (width > 100) return Math.round((width / bodyWidth) * 1000) / 10;
    return Math.max(1, Math.min(99, width));
  };

  const allCols = ["name", "path", "size", "modified", "created", "keywords"];
  const rawPercents = {};
  allCols.forEach((col) => {
    rawPercents[col] = asPercent(
      columnsArrangement[col]?.width,
      defaultPercents[col]
    );
  });

  // Determine which columns are currently visible so we can normalize to 100%
  const cust = listViewColumnCustomizations();
  const searchActive = store.searchFilterDetails?.isSearchFilterActive;
  const visibleCols = allCols.filter((col) => {
    if (col === "name") return !cust.canNameColumnDisable;
    if (col === "path") return cust.canPathColumnEnable || searchActive;
    if (col === "size") return !cust.canSizeColumnDisable;
    if (col === "modified") return !cust.canModifiedColumnDisable;
    if (col === "created") return cust.canCreatedColumnEnable;
    if (col === "keywords") return !cust.canKeywordColumnDisable;
    return false;
  });

  if (
    !disableColumnResize &&
    columnsArrangement !== defaultFileListingColumnsOrder
  ) {
    let visibleSum = 0;
    visibleCols.forEach((col) => (visibleSum += rawPercents[col]));
    if (visibleSum > 100.01) {
      columnsArrangement = defaultFileListingColumnsOrder;
      // reset raw percents to defaults
      visibleSum = 0;
      allCols.forEach((col) => {
        rawPercents[col] = defaultPercents[col];
      });
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }
  }

  const normalized = { ...rawPercents };
  if (visibleCols.length > 0) {
    let visibleSum = 0;
    visibleCols.forEach((col) => (visibleSum += rawPercents[col]));
    if (visibleSum > 0 && Math.abs(visibleSum - 100) > 0.01) {
      const scale = 100 / visibleSum;
      let runningSum = 0;
      visibleCols.forEach((col, i) => {
        if (i < visibleCols.length - 1) {
          normalized[col] = Math.round(rawPercents[col] * scale * 100) / 100;
          runningSum += normalized[col];
        } else {
          normalized[col] = Math.round((100 - runningSum) * 100) / 100;
        }
      });
    }
  }

  return {
    nameColumnOrder: columnsArrangement["name"]?.order ?? 0,
    sizeColumnOrder: columnsArrangement["size"]?.order ?? 0,
    modifiedColumnOrder: columnsArrangement["modified"]?.order ?? 0,
    keywordsColumnOrder: columnsArrangement["keywords"]?.order ?? 0,
    pathColumnOrder: columnsArrangement["path"]?.order ?? 0,
    createdColumnOrder: columnsArrangement["created"]?.order ?? 0,
    nameColumnMinWidth,
    pathColumnMinWidth,
    sizeColumnMinWidth,
    modifiedColumnMinWidth,
    createdColumnMinWidth,
    keywordsColumnMinWidth,
    nameColumnWidth: normalized.name,
    pathColumnWidth: normalized.path,
    sizeColumnWidth: normalized.size,
    modifiedColumnWidth: normalized.modified,
    createdColumnWidth: normalized.created,
    keywordsColumnWidth: normalized.keywords,
  };
};

const getCommonListingCustomizations = () => {
  const disableDirectoryItemCount = utils.getUserCustomizationValue(
    "disableDirectoryItemCount"
  );
  const alternatePathToProtocolIcons = utils.getUserCustomizationValue(
    "alternatePathToProtocolIcons",
    true
  );
  const disableClickToDownload = utils.getUserCustomizationValue(
    "DisableClickToDownload"
  );
  const disablePreview = utils.getUserCustomizationValue(
    "disableTreeviewHover"
  );
  const disableFileListingTooltips = utils.getUserCustomizationValue(
    "disableFileListingTooltips"
  );
  const disableThumbnailHover = utils.getUserCustomizationValue(
    "disableThumbnailHover"
  );
  const canDisableUIDragDrop =
    utils.getUserCustomizationValue("disableUIDragDrop");
  const OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB = utils.getUserCustomizationValue(
    "OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB"
  );
  const maskedEmptyFolder =
    utils.getUserCustomizationValue("maskedEmptyFolder");
  const tooltipDelayInMilliSeconds =
    (utils.getUserCustomizationValue("tooltipDelay", true) || 0) * 1000;
  const previewRealFile = utils.getUserCustomizationValue("previewRealFile");
  const canTransparent = utils.getUserCustomizationValue(
    "tooltipSemiTransparent"
  );

  const showSubscribedEventsIcon = utils.getUserCustomizationValue(
    "showSubscribedEventsIcon"
  );

  return {
    disableDirectoryItemCount,
    alternatePathToProtocolIcons,
    disableClickToDownload,
    disablePreview,
    disableFileListingTooltips,
    disableThumbnailHover,
    canDisableUIDragDrop,
    OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB,
    maskedEmptyFolder,
    tooltipDelayInMilliSeconds,
    previewRealFile,
    canTransparent,
    showSubscribedEventsIcon,
  };
};

const addTooltipFileListing = () => {
  if (!buttonsTooltip) {
    buttonsTooltip = new Tooltip();
  }

  const tooltipElements = _$("#dashboard-files-section [data-tooltip]").sel();

  tooltipElements.forEach((element) => {
    buttonsTooltip.addTooltip({
      element,
      position: "right",
    });
  });
};

const getCurrentDirectorySubscribedEventsByPath = (href_path = "/") => {
  const subscribedEvents = store.subscribedEvents;
  const currentDirectorySubscribedEvent = subscribedEvents.find(
    (event) => event?.path === href_path + "/"
  );

  return currentDirectorySubscribedEvent;
};

const getCommonCustomizationListingAndBasket = () => {
  const inlineAudio = utils.getUserCustomizationValue("inlinePlayer_visible");
  const inlineAudioWave = utils.getUserCustomizationValue(
    "inlinePlayer_graphvisible"
  );
  const inlineAudioAutonext = utils.getUserCustomizationValue(
    "inlinePlayer_playqueue"
  );

  return { inlineAudio, inlineAudioWave, inlineAudioAutonext };
};

// **** START **** Render Files In Dashboard
const renderTreeView = () => {
  const _files = utils.deepCopy(store.files);
  const { isSearchFilterActive } = store.searchFilterDetails;
  const { failed } = store.currentDirectoryInfo;

  lastFocusedElementIDTreeView = null;

  const customizations = listViewColumnCustomizations();
  const scrollTopBeforeRerender = virtualScroller?.container?.scrollTop || 0;

  renderSortIcon("list", "dashboard");

  const clickOnParentOfFileName = utils.getUserCustomizationValue(
    "clickOnParentOfFileName",
    true
  );

  const {
    disableDirectoryItemCount,
    alternatePathToProtocolIcons,
    disableClickToDownload,
    disablePreview,
    disableFileListingTooltips,
    canDisableUIDragDrop,
    OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB,
    maskedEmptyFolder,
    tooltipDelayInMilliSeconds,
    previewRealFile,
    canTransparent,
    showSubscribedEventsIcon,
  } = getCommonListingCustomizations();

  const { inlineAudio, inlineAudioWave, inlineAudioAutonext } =
    getCommonCustomizationListingAndBasket();

  const columnsResizeAndOrderDetails = listViewGetResizeAndOrderDetails(true);
  const filteredFilesForTreeView = filterPaginationFiles(_files);

  const hasSyncName = filteredFilesForTreeView.some(
    (file) => file.privs.indexOf("syncName=") !== -1
  );

  virtualScroller?.init({
    totalRows: filteredFilesForTreeView.length,
    onRender: (container) => {
      if (canDisableUIDragDrop) return;
      const draggableItems = container.querySelectorAll("tr");
      const droppableItems = [
        ...container.querySelectorAll(".folder"),
        _$("#basket_icon").el(),
        _$("#modal_UI_Basket").el(),
        _$("#dashboard-files-section").el(),
      ];
      bindDnDInteractivity(draggableItems, droppableItems, filesViewTypes.LIST);

      if (lastFocusedElementIDTreeView) {
        const ele = _$(`[data-uid='${lastFocusedElementIDTreeView}']`).sel();
        focusElement(ele[ele.length - 1], true);
      }

      const files = store.files;
      let begin = false;

      files.every((ele) => {
        if (
          ele.id === lastRangedFocusedElementIDTreeView ||
          ele.id === lastFocusedElementIDTreeView
        ) {
          if (begin) {
            return false;
          }

          begin = true;
          return true;
        }

        if (begin) {
          const element = _$(`[data-uid='${ele.id}']`);
          element.addClass("focused");
        }
        return true;
      });

      addTooltipFileListing();
    },
    generatorFn: (rowIndex) => {
      const file = filteredFilesForTreeView[rowIndex];
      const isLockedAndExpired =
        file.privs?.includes("(locked)") && file.privs?.includes("(expired)");

      // Setting Attribute Of List Items
      const divLi = _$("<tr>").el();
      divLi.classList.add("table-tr");
      if (isLockedAndExpired) {
        divLi.classList.add("is-disabled-dir-item");
      }
      divLi.setAttribute("tabindex", 0);
      divLi.setAttribute("data-index", rowIndex);
      divLi.setAttribute("data-uid", file.id);

      if (file.type === fileTypes.DIR) {
        divLi.setAttribute("data-tree", file.treeIds);
        divLi.setAttribute("aria-expanded", file.ariaExpanded);
      }
      if (file.type.toLowerCase() === "dir") {
        divLi.classList.add("folder");
      }

      if (
        maskedEmptyFolder &&
        file.type === fileTypes.DIR &&
        !parseInt(file.num_items)
      ) {
        divLi.classList.add("empty-folder");
      }

      if (file.isChecked) {
        divLi.classList.add("selected");
      } else {
        divLi.classList.remove("selected");
      }

      const currentDirectorySubscribedEvent =
        getCurrentDirectorySubscribedEventsByPath(file.href_path);

      divLi.innerHTML = ListingTemplates.TreeItem({
        checked: file.isChecked ? "checked" : "",
        rowIndex: rowIndex,
        paddingLeft: file.paddingLeft,
        image: (() => {
          return getFilePreviewList(file);
        })(),
        audio: (() => {
          return (
            inlineAudio &&
            getAudioPreviewList(file, inlineAudioWave, inlineAudioAutonext)
          );
        })(),
        protocol: file.vfs_protocol,
        protocolIcon: file.vfs_protocol
          ? getVFSIcon(file.vfs_protocol, alternatePathToProtocolIcons)
          : null,
        syncText: file.privs.indexOf("syncName=") !== -1 ? t("revisions") : "",
        showSyncIcon: hasSyncName,
        num_items: file.num_items,
        showNumItems:
          file.type === fileTypes.DIR &&
          !disableDirectoryItemCount &&
          parseInt(file.num_items),
        itemsText: t("items"),
        name: utils.textEncode(file.name),
        sizeFormatted:
          parseInt(file.size) > 10 || file.type !== fileTypes.DIR
            ? utils.formatBytes(parseInt(file.size))
            : "",
        dateFormatted: utils.formatDateForListing(file.modified, file.dateFormatted),
        createdDateFormatted: utils.formatDateForListing(file.created, file.createdDateFormatted),
        path: utils.textEncode(file.root_dir),
        keywords: utils.textEncode(utils.decodeURILocal(file.keywords)),
        isSearchFilterActive,
        ...customizations,
        ...columnsResizeAndOrderDetails,
        totalSubscribedEvents: currentDirectorySubscribedEvent
          ? utils.countSubscribedEventsTags(
              currentDirectorySubscribedEvent?.privs
            )
          : 0,
        subscribedEventsDirectoryPath: file?.href_path,
        showSubscribedEventsIcon,
        isDir: file.type === fileTypes.DIR,
      });
      applyTreeIndentation(divLi);

      // Apply column widths as % to match header (same proportion on resize)
      const bodyCells = _$(divLi).find("td").sel();
      const firstTd = bodyCells[0];
      const hasCheckCol = firstTd && _$(firstTd).hasClass("check-td");
      const fixedPx = hasCheckCol ? 38 : 0;
      bodyCells.forEach((td) => {
        const widthAttr = _$(td).attr("data-width");
        if (widthAttr) {
          const percent = parseFloat(widthAttr);
          if (!isNaN(percent) && percent > 0) {
            const p = Math.max(1, Math.min(99, percent));
            _$(td).removeClass("w-full");
            const widthVal =
              fixedPx > 0
                ? `calc((100% - ${fixedPx}px) * ${p / 100})`
                : `${p}%`;
            _$(td).css("width", widthVal);
          }
        }
      });

      if (customizations.listViewFontStyle) {
        const td = _$(divLi).find("td");
        const cssProperty =
          customizations.listViewFontStyle === "bold"
            ? "font-weight"
            : "font-style";
        // Use object form instead of cssText overload for CSP compliance
        td.css(cssProperty, customizations.listViewFontStyle);
      }

      if (customizations.listViewFontSize) {
        const td = _$(divLi).find("td p");
        td.css("fontSize", customizations.listViewFontSize);
      }

      const expandIcon = _$(divLi).find(".down-icon")[0];

      // Event Listeners Of List Items
      if (expandIcon && !isLockedAndExpired) {
        _$(expandIcon).on("click", (e) => {
          e.stopPropagation();
          file.type === fileTypes.DIR
            ? toggleFolder(e, file.id)
            : quickViewSlider.openSlider(file.id);
        });
      }

      if (!isLockedAndExpired) {
        const fileName = _$(divLi).find(".name .file-name-text");
        fileName.on("click", (e) => {
          e.stopPropagation();
          const selection = window.getSelection();
          if (selection && selection.toString().length > 0) {
            return;
          }

          if (file.type === fileTypes.FILE) {
            if (disableClickToDownload) return;

            const { userCustomizations } = store?.userInfo;
            const {
              OPEN_PREVIEW_EXTENSIONS,
              OPEN_NEW_WINDOW_EXTENSIONS,
              OPEN_SLIDESHOW_EXTENSIONS,
            } = userCustomizations;

            const includedInPreviewExtension = isExtensionIncluded(
              OPEN_PREVIEW_EXTENSIONS,
              file
            );
            const includedInSlideshowExtension = isExtensionIncluded(
              OPEN_SLIDESHOW_EXTENSIONS,
              file
            );
            const includedInNewTabExtension = isExtensionIncluded(
              OPEN_NEW_WINDOW_EXTENSIONS,
              file
            );

            let name = "download";

            if (includedInNewTabExtension) name = "newTab";
            if (includedInSlideshowExtension) {
              name = "slideshow";
            }
            if (includedInPreviewExtension) {
              if (checkFilePreviewAvailable(file)) {
                name = "quickView";
              } else {
                growl("", t("previewIsNotAvailable"), 3000, true);
                return;
              }
            }

            if (name === "newTab") {
              open(
                file.href_path,
                OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB ? "_self" : ""
              );

              return;
            }
            if (!name) {
              return;
            }

            userActions.invoke({
              name,
              curPath: file.href_path || hashListener.getPath(),
              loadedPath: hashListener.getPath(),
              context: name === "slideshow" ? null : file,
            });
          } else if (file.type === fileTypes.DIR && file.href_path) {
            tooltipForDashboardFileListing.removeTooltip(e);
            hashListener.setPath(file.href_path, file.type === fileTypes.DIR);
            expandedFolderSet.clear();
          }
        });

        const nameDiv = _$(divLi).find(".name");
        nameDiv.on("click", (e) => {
          e.stopPropagation();
          if (
            clickOnParentOfFileName === "false" &&
            file.type === fileTypes.FILE
          ) {
            return;
          }
          fileName.el().click();
        });

        nameDiv.on("dblclick", (e) => {
          console.log("-->Double Click");
        });

        _$(divLi).on("keydown", (e) => {
          if (e.code === "Enter") {
            if (file.type === fileTypes.FILE && file.preview > 0) {
              quickViewSlider.openSlider(file.id);
            } else if (file.type === fileTypes.DIR && file && file.href_path) {
              hashListener.setPath(file.href_path, file.type === fileTypes.DIR);
              expandedFolderSet.clear();
            } else if (file.type === fileTypes.FILE) {
              const event = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              divLi.querySelector(".name").dispatchEvent(event);
            }
          }
        });
      }

      // Event Listeners Of List Items
      const nameTd = _$(divLi).find(".name-td");

      if (!disablePreview && !disableFileListingTooltips && nameTd.el()) {
        let listTooltipTimeout;
        nameTd.on("mouseenter", (e) => {
          listTooltipTimeout = setTimeout(() => {
            tooltipForDashboardFileListing.showTooltip({
              event: e,
              hoverDiv: nameTd[0],
              data: file,
              previewRealFile,
              showPathInTooltip:
                isSearchFilterActive || customizations.canPathColumnEnable,
              canTransparent,
            });
            clearTimeout(listTooltipTimeout);
          }, tooltipDelayInMilliSeconds);
        });

        nameTd.on("mouseleave", (e) => {
          clearTimeout(listTooltipTimeout);
          tooltipForDashboardFileListing.removeTooltip(e);
        });
      }

      if (!isLockedAndExpired) {
        // Event Listener For Check Box In List Item
        const chkBox = _$(divLi).find(".checks", true);
        if (chkBox) {
          _$(chkBox).on("click", (e) => {
            e.stopPropagation();

            if (e.shiftKey && lastSelectedFileID) {
              chkBox.checked = true;

              store.dispatch("handleSelectFilesInRange", {
                startElementID: lastSelectedFileID,
                endElementID: file.id,
              });

              lastSelectedFileID = file.id;
            } else {
              store.dispatch("handleCheckFile", {
                selectedFile: file,
                isChecked: e.target.checked,
              });
              if (chkBox.checked) {
                lastSelectedFileID = file.id;
              }
            }
          });

          _$(divLi).on("keyup", (e) => {
            if (e.code === "Space") {
              chkBox.click();
              e.preventDefault();
              e.stopPropagation();
            }
          });
        }

        const checkTd = _$(divLi).find(".check-td", true);
        if (checkTd) {
          _$(checkTd).on("click", (e) => {
            // Just trigger the checkbox click, which handles everything
            chkBox.click();
          });

          const userOptions =
            JSON.parse(utils.storage.get("userOptions")) || {};

          if (userOptions.hideCheckboxColumn) {
            _$(checkTd).addClass("is-hidden");
          }
        }

        setContextMenu(divLi, file, filesViewTypes.LIST);
      }

      return divLi;
    },
  });

  const vList = _$(`#dashboard-virtual-list`);
  vList.html("");

  if (filteredFilesForTreeView.length === 0) {
    const listContainer = createNoFilesAvailableContainer("", failed);

    if (virtualScroller) virtualScroller.container = listContainer;

    setTimeout(() => {
      _$(".empty-list").on("contextmenu", (e) => {
        e.preventDefault();
        e.stopPropagation();
        contextMenu.init({
          contextMenuItems: defaultContextMenuItems,
          onClick: (btn, elem) => {
            const { command, isLink } = btn;
            if (isLink === "true") {
              window.location = btn.link;
              return false;
            }
            userActions.invoke({
              name: command,
              curPath: hashListener.getPath(),
              loadedPath: hashListener.getPath(),
              context: {
                type: fileTypes.DIR,
                href_path: hashListener.getPath(),
              },
            });
          },
        });
        contextMenu.handleContextMenu(e, null);
      });
    }, 100);
  }

  vList.el().append(virtualScroller?.container);
  if (virtualScroller) {
    _$(virtualScroller.container).css("height", "100%");
    virtualScroller.container.scrollTop = scrollTopBeforeRerender;
  }
  addTooltipFileListing();
};

const resetListingTableColumnWidth = () => {
  const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;
  if (gridType !== filesViewTypes.LIST) {
    return;
  }

  // The function will not work on the mobile screen
  let bodyWidth = _$("body").el().clientWidth;
  if (bodyWidth < 640) {
    return;
  }

  // getting localStorage values of column width
  const columnsArrangement =
    JSON.parse(
      localStorage.getItem("file-listing-table-columns-arrangement")
    ) || defaultFileListingColumnsOrder;

  const setPropertyWithPortion = (columnDetails, portionPx) => {
    if (columnDetails && bodyWidth > 0) {
      const { property } = columnDetails;
      const percent = Math.round(((100 * portionPx) / bodyWidth) * 10) / 10;
      columnsArrangement[property] = {
        ...columnsArrangement[property],
        width: Math.max(1, Math.min(99, percent)),
      };
    }
  };

  // table container
  const treeView = _$("#dashboard-files-section .list-container");

  let widthOccupiedByPreferredColumns = 0;
  const columnsWithNoPreferredPortions = [];

  // providing width to the columns with preferred width
  const provideWidthToPreferredColumns = (th) => {
    if (!th) {
      return;
    }

    const style = window.getComputedStyle(th);
    if (style?.display === "none") {
      return;
    }

    const id = th.id;
    const columnDetails = ColumnsMapping[id];

    const header = _$(th);

    const preferredPortion = Number(header.attr("preferredPortion"));
    const preferredPortionUnit = header.attr("preferredPortionUnit");
    let portion;

    if (preferredPortionUnit === "%") {
      portion = (bodyWidth * preferredPortion) / 100;
    }

    if (preferredPortionUnit === "px") {
      portion = preferredPortion;
    }

    widthOccupiedByPreferredColumns += portion;
    setPropertyWithPortion(columnDetails, portion);
  };

  // traversing all table headers
  const tableHeaders = treeView.find("thead th").sel();
  tableHeaders.forEach((th) => {
    const header = _$(th);
    const preferredPortion = header.attr("preferredPortion");

    if (preferredPortion) {
      // providing width to the columns with preferred width
      provideWidthToPreferredColumns(th);
    } else {
      columnsWithNoPreferredPortions.push(th);
    }
  });

  // provide width to non preferred columns
  bodyWidth = bodyWidth - widthOccupiedByPreferredColumns;

  const partitionForNonPreferredColumns =
    columnsWithNoPreferredPortions.length > 0
      ? bodyWidth / columnsWithNoPreferredPortions.length
      : 0;

  columnsWithNoPreferredPortions.forEach((th) => {
    const id = th.id;
    const columnDetails = ColumnsMapping[id];
    if (partitionForNonPreferredColumns > 0) {
      setPropertyWithPortion(columnDetails, partitionForNonPreferredColumns);
    }
  });

  // overWriting localStorage
  localStorage.setItem(
    "file-listing-table-columns-arrangement",
    JSON.stringify(columnsArrangement)
  );

  // re-render tree header
  renderTreeViewHeader(true);
};

const renderTreeViewHeader = (isColumnResized) => {
  const { isSearchFilterActive } = store.searchFilterDetails;
  const userOptions = JSON.parse(utils.storage.get("userOptions")) || {};
  const userCustomizations = store.userInfo.userCustomizations;
  const columnsResizeAndOrderDetails = listViewGetResizeAndOrderDetails();

  const treeView = _$("<div>")
    .addClass("list-container")
    .addClass("h-full")
    .html(
      ListingTemplates.TreeHeader({
        prefixId: "dashboard",
        name: userCustomizations?.NAME_COL_TEXT?.value || t("name"),
        path: t("path"),
        size: userCustomizations?.SIZE_COL_TEXT?.value || t("size"),
        lastModified:
          userCustomizations?.MODIFIED_COL_TEXT?.value || t("lastModified"),
        created: userCustomizations?.CREATED_COL_TEXT?.value || t("created"),
        keyword: userCustomizations?.KEYWORDS_COL_TEXT?.value || t("keywords"),
        isSearchFilterActive,
        ...listViewColumnCustomizations(),
        ...columnsResizeAndOrderDetails,
      })
    );

  const treeViewContainer = _$("#dashboard-files-section");
  treeViewContainer.empty().append(treeView.el());

  // Apply column widths via utility classes and fix column ordering
  const thead = treeView.find("thead tr");
  const headerCells = Array.from(thead.find("th").sel());

  // Sort columns by data-order attribute (excluding checkbox column which has no data-order)
  const cellsWithOrder = headerCells.filter((cell) => {
    const id = cell.id;
    if (id === "checkTh") return false; // Keep checkbox first
    const order = _$(cell).attr("data-order");
    return order !== null && order !== undefined;
  });

  const cellsWithoutOrder = headerCells.filter((cell) => {
    const id = cell.id;
    if (id === "checkTh") return true; // Keep checkbox first
    const order = _$(cell).attr("data-order");
    return order === null || order === undefined;
  });

  // Sort cells with order by their data-order value
  cellsWithOrder.sort((a, b) => {
    const orderA = parseInt(_$(a).attr("data-order") || "999");
    const orderB = parseInt(_$(b).attr("data-order") || "999");
    return orderA - orderB;
  });

  // Reorder DOM: checkbox first, then ordered columns
  const reorderedCells = [...cellsWithoutOrder, ...cellsWithOrder];
  reorderedCells.forEach((cell) => {
    thead.el().appendChild(cell);
  });

  // Apply column widths as % of (row minus fixed checkbox) so proportions persist on page resize
  const hasCheckTh = treeView.find("#checkTh").sel().length > 0;
  const fixedWidthPx = hasCheckTh ? 38 : 0;
  thead
    .find("th")
    .sel()
    .forEach((th) => {
      const widthAttr = _$(th).attr("data-width");
      const minAttr = _$(th).attr("data-min-width");
      if (widthAttr) {
        const percent = parseFloat(widthAttr);
        const minW = minAttr
          ? parseFloat(minAttr)
          : DEFAULT_MIN_COLUMN_WIDTH_PX;
        if (!isNaN(percent) && percent > 0) {
          _$(th).removeClass("w-full");
          const widthVal =
            fixedWidthPx > 0
              ? `calc((100% - ${fixedWidthPx}px) * ${percent / 100})`
              : `${percent}%`;
          _$(th).css({
            width: widthVal,
            minWidth: `${minW}px`,
            flex: "0 0 auto",
            boxSizing: "border-box",
          });
        }
      }
    });

  const applyColumnWidthPx = (elem, className, widthPx) => {
    const w = Math.round(widthPx);
    _$(elem).removeClass("w-full");
    _$(elem).css("width", `${w}px`);
    _$(`#dashboard-files-section .list-container table tbody tr .${className}`)
      .sel()
      .forEach((td) => {
        _$(td).removeClass("w-full");
        _$(td).css("width", `${w}px`);
      });
  };

  const applyColumnWidthPercent = (elem, className, percent) => {
    const p = Math.max(1, Math.min(99, percent));
    _$(elem).removeClass("w-full");
    _$(elem).css("width", `${p}%`);
    _$(`#dashboard-files-section .list-container table tbody tr .${className}`)
      .sel()
      .forEach((td) => {
        _$(td).removeClass("w-full");
        _$(td).css("width", `${p}%`);
      });
  };

  const disableColumnResize = utils.getUserCustomizationValue(
    "disableColumnResize"
  );

  if (!disableColumnResize) {
    treeView
      .find("thead th")
      .sel()
      .forEach((elem) => {
        const id = elem.id;
        if (id === "checkTh") return;

        const className = ColumnsMapping[id]?.class;
        const minW =
          parseFloat(_$(elem).attr("data-min-width")) ||
          DEFAULT_MIN_COLUMN_WIDTH_PX;
        const nextElem = elem.nextElementSibling;
        if (!nextElem) return; /* no handle on last column */

        const nextMinW =
          parseFloat(_$(nextElem).attr("data-min-width")) ||
          DEFAULT_MIN_COLUMN_WIDTH_PX;

        elem.classList.add("is-relative");
        elem.insertAdjacentHTML(
          "beforeend",
          resizableTemplate({ right: true })
        );
        _$(elem).find(".resizable-wrapper").addClass("always-visible");

        const handle = _$(elem).find(".resizable-right").el();
        if (!handle) return;

        let startX = 0;
        let startWidth = 0;
        let nextStartWidth = 0;

        const onMouseMove = (e) => {
          const delta = e.clientX - startX;
          let newW = startWidth + delta;
          let nextNewW = nextElem ? nextStartWidth - delta : 0;

          if (newW < minW) {
            newW = minW;
            nextNewW = nextElem ? startWidth + nextStartWidth - minW : 0;
          }
          if (nextElem && nextNewW < nextMinW) {
            nextNewW = nextMinW;
            newW = startWidth + nextStartWidth - nextMinW;
          }
          if (newW < minW) return;

          const finalW = exactColumnWidth(newW, minW);
          const finalNextW = nextElem
            ? exactColumnWidth(nextNewW, nextMinW)
            : 0;

          applyColumnWidthPx(elem, className, finalW);
          if (nextElem && ColumnsMapping[nextElem.id]?.class) {
            applyColumnWidthPx(
              nextElem,
              ColumnsMapping[nextElem.id].class,
              finalNextW
            );
          }
        };

        const onMouseUp = () => {
          _$("body").removeClass("drag-active");
          window.removeEventListener("mousemove", onMouseMove);
          window.removeEventListener("mouseup", onMouseUp);
          _$(elem).find(".resizable-corners.active").removeClass("active");

          const theadRow = elem.closest("thead tr");
          const allDataTh = theadRow
            ? Array.from(theadRow.querySelectorAll("th")).filter(
                (th) => ColumnsMapping[th.id]?.property
              )
            : [];
          const totalWidth = allDataTh.reduce(
            (sum, th) => sum + (th.offsetWidth || th.clientWidth),
            0
          );
          if (totalWidth <= 0) return;

          const columnsArrangement = JSON.parse(
            localStorage.getItem("file-listing-table-columns-arrangement")
          ) || { ...defaultFileListingColumnsOrder };

          // Convert each visible column's px share to a %, last absorbs remainder for exact 100
          let runningSum = 0;
          allDataTh.forEach((th, i) => {
            const prop = ColumnsMapping[th.id]?.property;
            if (!prop) return;
            let pct;
            if (i < allDataTh.length - 1) {
              pct =
                Math.round(
                  ((th.offsetWidth || th.clientWidth) / totalWidth) * 10000
                ) / 100;
              runningSum += pct;
            } else {
              pct = Math.round((100 - runningSum) * 100) / 100;
            }
            columnsArrangement[prop] = {
              ...columnsArrangement[prop],
              width: pct,
            };
          });

          localStorage.setItem(
            "file-listing-table-columns-arrangement",
            JSON.stringify(columnsArrangement)
          );
          store.dispatch("setFileListing", store.files);
        };

        handle.addEventListener("mousedown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          _$("body").addClass("drag-active");
          _$(elem).find(".resizable-right").addClass("active");
          startX = e.clientX;
          startWidth = elem.offsetWidth || elem.clientWidth;
          nextStartWidth = nextElem
            ? nextElem.offsetWidth || nextElem.clientWidth
            : 0;
          window.addEventListener("mousemove", onMouseMove);
          window.addEventListener("mouseup", onMouseUp);
        });
      });
  }

  const dashboardGridIconWrapper = _$("#dashboard-grid-icon-wrapper");
  dashboardGridIconWrapper.html('<i class="icon-th-list"></i>');

  const checkAll = _$("#checkAll");
  const tableRows = _$("#dashboard-files-section .table-tr");
  const checkTh = _$("#checkTh");

  checkAll.on("click", (e) => {
    const isChecked = e.target.checked;
    tableRows.toggleClass("selected", isChecked);
    store.dispatch("handleSelectFiles", isChecked ? "checkAll" : "uncheckAll");
  });

  if (userOptions.hideCheckboxColumn) {
    checkTh.addClass("is-hidden");
  }

  checkTh.on("click", (e) => {
    if (e.target.id !== "checkAll") {
      checkAll.el().click();
    }
  });

  applyUserCustomizationOption(userCustomizations?.listHeaderTextStyle);
  applyUserCustomizationOption(userCustomizations?.listHeaderTextSize);

  bindSortEventsForList();
  renderTreeView();

  let totalWidth = 0;
  let totalWidthInPercentage = 0;

  const tableHeaders = treeView.find("thead th").sel();

  tableHeaders.forEach((th) => {
    const extractNumberFromPercentage = (percentage) => {
      if (!percentage.includes("%")) {
        return 0;
      }
      return parseFloat(percentage.replace("%", ""));
    };

    // Use getComputedStyle instead of inline style for CSP compliance
    const computedStyle = window.getComputedStyle(th);
    totalWidthInPercentage += extractNumberFromPercentage(computedStyle.width);

    const { width } = th.getBoundingClientRect();
    totalWidth += width;
  });

  const bodyWidth = _$("body").el().clientWidth;
  const tableOverflowWidth = totalWidth - bodyWidth;

  if (
    (tableOverflowWidth > 30 || tableOverflowWidth < -30) &&
    !isColumnResized &&
    bodyWidth >= 1200
  ) {
    resetListingTableColumnWidth();
  }
};

const renderGridView = (type) => {
  const _files = utils.deepCopy(store.files);
  const canThumbsViewSingleClick = utils.getUserCustomizationValue(
    "thumbsViewSingleClick"
  );
  const canPathColumnEnable = utils.getUserCustomizationValue("SHOWPATH_COL");
  const { failed } = store.currentDirectoryInfo;

  const {
    disableDirectoryItemCount,
    alternatePathToProtocolIcons,
    disableClickToDownload,
    disableFileListingTooltips,
    disableThumbnailHover,
    canDisableUIDragDrop,
    OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB,
    maskedEmptyFolder,
    tooltipDelayInMilliSeconds,
    previewRealFile,
    canTransparent,
    showSubscribedEventsIcon,
  } = getCommonListingCustomizations();

  const { inlineAudio, inlineAudioWave, inlineAudioAutonext } =
    getCommonCustomizationListingAndBasket();

  renderSortIcon("grid", "dashboard");

  const gridIconWrapper = _$("#dashboard-grid-icon-wrapper");
  if (type === filesViewTypes.GRID) {
    gridIconWrapper.html('<i class="icon-th"></i>');
  } else if (type === filesViewTypes.MEDIUM_GRID) {
    gridIconWrapper.html('<i class="icon-table"></i>');
  } else if (type === filesViewTypes.LARGE_GRID) {
    gridIconWrapper.html('<i class="icon-th-large"></i>');
  }

  let filteredFilesForGrid = _files;
  const isSearchFilterActive = store?.searchFilterDetails?.isSearchFilterActive;

  if (!isSearchFilterActive) {
    const curPath = hashListener.getPath();
    const viewType = filesViewTypes.GRID;
    filteredFilesForGrid = filterFilesByGridType(_files, viewType, curPath);
  }

  const listContainer =
    type === filesViewTypes.GRID
      ? _$("<div>")
          .addClass("grid-container")
          .addClass("is-absolute")
          .addClass("w-full")
          .el()
      : type === filesViewTypes.MEDIUM_GRID
        ? _$("<div>")
            .addClass("grid-container")
            .addClass("medium-grid-container")
            .addClass("is-absolute")
            .addClass("w-full")
            .el()
        : _$("<div>")
            .addClass("grid-container")
            .addClass("large-grid-container")
            .addClass("is-absolute")
            .addClass("w-full")
            .el();

  filteredFilesForGrid = filterPaginationFiles(filteredFilesForGrid);

  if (filteredFilesForGrid.length > 0) {
    filteredFilesForGrid.forEach((file) => {
      const gridItem = _$("<div>").el();
      gridItem.tabIndex = 0;
      gridItem.classList.add("grid-item");
      const isLockedAndExpired =
        file.privs?.includes("(locked)") && file.privs?.includes("(expired)");

      if (isLockedAndExpired) {
        gridItem.classList.add("is-disabled-dir-item");
      }
      if (file.type.toLowerCase() === "dir") gridItem.classList.add("folder");
      gridItem.setAttribute("data-uid", file.id);

      const checkbox = _$("<input>").el();
      checkbox.type = "checkbox";
      checkbox.tabIndex = "-1";

      if (
        maskedEmptyFolder &&
        file.type === fileTypes.DIR &&
        !parseInt(file.num_items)
      ) {
        gridItem.classList.add("empty-folder");
      }

      if (!isLockedAndExpired) {
        _$(checkbox).on("click", (e) => {
          e.stopPropagation();
          store.dispatch("handleCheckFile", {
            selectedFile: file,
            isChecked: e.target.checked,
          });
        });

        const handleGridItemClick = (e) => {
          if (file.type === fileTypes.FILE) {
            if (disableClickToDownload) return;

            const { userCustomizations } = store?.userInfo;
            const {
              OPEN_PREVIEW_EXTENSIONS,
              OPEN_NEW_WINDOW_EXTENSIONS,
              OPEN_SLIDESHOW_EXTENSIONS,
            } = userCustomizations;

            const includedInPreviewExtension = isExtensionIncluded(
              OPEN_PREVIEW_EXTENSIONS,
              file
            );
            const includedInSlideshowExtension = isExtensionIncluded(
              OPEN_SLIDESHOW_EXTENSIONS,
              file
            );
            const includedInNewTabExtension = isExtensionIncluded(
              OPEN_NEW_WINDOW_EXTENSIONS,
              file
            );

            let name = "download";

            if (includedInNewTabExtension) name = "newTab";
            if (includedInSlideshowExtension) {
              name = "slideshow";
            }
            if (includedInPreviewExtension) {
              if (checkFilePreviewAvailable(file)) {
                name = "quickView";
              } else {
                growl("", t("previewIsNotAvailable"), 3000, true);
                return;
              }
            }

            if (name === "newTab") {
              open(
                file.href_path,
                OPEN_NEW_WINDOW_EXTENSIONS_SAMETAB ? "_self" : ""
              );

              return;
            }

            if (!name) {
              return;
            }

            userActions.invoke({
              name,
              curPath: file.href_path || hashListener.getPath(),
              loadedPath: hashListener.getPath(),
              context: name === "slideshow" ? null : file,
            });
          } else if (file.type === fileTypes.DIR && file.href_path) {
            tooltipForDashboardFileListing.removeTooltip(e);
            hashListener.setPath(file.href_path, file.type === fileTypes.DIR);
          }
        };

        const handleGridItemSingleClick = (e) => {
          if (canThumbsViewSingleClick) {
            handleGridItemClick(e);
            return;
          }
          if (checkbox) {
            if (e.shiftKey) {
              const startElement = _$(".grid-item.last-selected").el();
              const endElement = gridItem;
              const elements = _$(".grid-item").sel();

              const elementsInRange = utils.getElementsInRange({
                startElement,
                endElement,
                elements,
              });
              elementsInRange.forEach((ele) => {
                const curCheckBox = ele.querySelector("input[type='checkbox']");

                if (!curCheckBox.checked) {
                  curCheckBox.click();
                }
              });
            }

            _$(
              "#dashboard-files-section .grid-container .grid-item"
            ).removeClass("last-selected");

            checkbox.click();
            if (checkbox.checked) {
              _$(gridItem).addClass("last-selected");
            }
          }
        };

        const handleGridItemDoubleClick = (e) => {
          if (canThumbsViewSingleClick) return;
          handleGridItemClick(e);
        };

        _$(gridItem).on("click", handleGridItemSingleClick);
        _$(gridItem).on("dblclick", handleGridItemDoubleClick);
      }

      if (file.isChecked) {
        gridItem.classList.add("selected");
      } else {
        gridItem.classList.remove("selected");
      }

      const currentDirectorySubscribedEvent =
        getCurrentDirectorySubscribedEventsByPath(file.href_path);

      gridItem.innerHTML = ListingTemplates.GridItem({
        name: file.name,
        image: getFilePreviewGrid(file),
        audio:
          inlineAudio &&
          getAudioPreviewGrid(file, inlineAudioWave, inlineAudioAutonext),
        itemsText: t("items"),
        protocol: file.vfs_protocol,
        protocolIcon: file.vfs_protocol
          ? getVFSIcon(file.vfs_protocol, alternatePathToProtocolIcons)
          : null,
        syncText: t("revisions"),
        showSyncIcon: file.privs.indexOf("syncName=") !== -1,
        num_items: file.num_items,
        showNumItems:
          file.type === fileTypes.DIR &&
          !disableDirectoryItemCount &&
          parseInt(file.num_items),
        totalSubscribedEvents: currentDirectorySubscribedEvent
          ? utils.countSubscribedEventsTags(
              currentDirectorySubscribedEvent?.privs
            )
          : 0,
        subscribedEventsDirectoryPath: file?.href_path,
        showSubscribedEventsIcon,
      });

      if (!disableFileListingTooltips && !disableThumbnailHover) {
        let gridTooltipTimeout;
        _$(gridItem).on("mouseenter", (e) => {
          gridTooltipTimeout = setTimeout(() => {
            tooltipForDashboardFileListing.showTooltip({
              event: e,
              hoverDiv: gridItem,
              data: file,
              previewRealFile,
              showPathInTooltip: isSearchFilterActive || canPathColumnEnable,
              canTransparent,
            });
            clearTimeout(gridTooltipTimeout);
          }, tooltipDelayInMilliSeconds);
        });

        _$(gridItem).on("mouseleave", (e) => {
          clearTimeout(gridTooltipTimeout);
          tooltipForDashboardFileListing.removeTooltip(e);
        });
      }

      if (!isLockedAndExpired) {
        setContextMenu(gridItem, file, filesViewTypes.GRID);

        _$(gridItem).on("keydown", (e) => {
          if (e.code === "Space") {
            gridItem.getElementsByTagName("input")[0].click();
            e.preventDefault();
            e.stopPropagation();
          }

          if (e.code === "Enter") {
            if (file.type === fileTypes.FILE && file.preview > 0) {
              let name;

              name =
                file.mediaInfo && file.preview > 0
                  ? "quickView"
                  : !disableClickToDownload
                    ? "download"
                    : null;

              if (name) {
                userActions.invoke({
                  name: name,
                  curPath: file.href_path || hashListener.getPath(),
                  loadedPath: hashListener.getPath(),
                  context: file,
                });
              }
            } else if (file.type === fileTypes.DIR && file.href_path) {
              hashListener.setPath(file.href_path, file.type === fileTypes.DIR);
            } else if (file.type === fileTypes.FILE) {
              const event = new MouseEvent("dblclick", {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              gridItem.dispatchEvent(event);
            }
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      gridItem.append(checkbox);
      listContainer.append(gridItem);
    });

    _$("#dashboard-files-section").empty().el().append(listContainer);
    addTooltipFileListing();

    if (!canDisableUIDragDrop) {
      const draggableItems = listContainer.querySelectorAll(".grid-item");
      const droppableItems = [
        ...listContainer.querySelectorAll(".folder"),
        _$("#basket_icon").el(),
        _$("#modal_UI_Basket").el(),
        _$("#dashboard-files-section").el(),
      ];
      bindDnDInteractivity(draggableItems, droppableItems, type);
    }

    const selectionContainer = _$(
      `#dashboard-files-section .grid-container,
      #dashboard-files-section .grid-container.medium-grid-container,
      #dashboard-files-section .grid-container.large-grid-container`
    ).el();
    const selectableFiles = selectionContainer.querySelectorAll(
      ".grid-item:not(.is-disabled-dir-item)"
    );

    const selected = (file, e) => {
      file.classList.add("focused");
      tooltipForDashboardFileListing.removeTooltip(e);
    };

    const unSelected = (file) => {
      file.classList.remove("focused");
    };

    const onBeforeStart = () => {
      canRemoveFocusedFiles = false;
      const selectedElements = getSelectedFilesByActiveView();
      handleToggleFiles(selectedElements, false);
    };

    const onBeforeEnd = () => {
      const focusedElements = getFocusedFilesByActiveView();
      handleToggleFiles(focusedElements, true);
      setTimeout(() => {
        canRemoveFocusedFiles = true;
      }, 0);
    };

    new MouseSelection({
      selectableFiles,
      selectionContainer: _$("#dashboard-files-section").el(),
      selected,
      unSelected,
      onBeforeStart,
      onBeforeEnd,
    });
  } else {
    const listContainer = createNoFilesAvailableContainer("", failed);
    _$("#dashboard-files-section").empty().el().append(listContainer);

    setTimeout(() => {
      _$(".empty-list").on("contextmenu", (e) => {
        e.preventDefault();
        e.stopPropagation();
        contextMenu.init({
          contextMenuItems: defaultContextMenuItems,
          onClick: (btn, elem) => {
            const { command, isLink } = btn;
            if (isLink === "true") {
              window.location = btn.link;
              return false;
            }
            userActions.invoke({
              name: command,
              curPath: hashListener.getPath(),
              loadedPath: hashListener.getPath(),
              context: {
                type: fileTypes.DIR,
                href_path: hashListener.getPath(),
              },
            });
          },
        });
        contextMenu.handleContextMenu(e, null);
      });
    }, 100);
  }
};

// Handling Grid-Type
const renderFiles = ({
  hasUpdates = false,
  gridType = utils.storage.get("activeView") || filesViewTypes.LIST,
}) => {
  const columnCustomization = listViewColumnCustomizations();
  utils.storage.set("activeView", gridType);

  const gridSortingDropdown = _$("#dashboard-grid-sorting-dropdown");
  const filterSelectDropdown = _$("#dashboard-filter-select-dropdown");
  const fileListingExpandCollapseMenu = _$(".listing-expand-collapse-menu");

  if (
    gridType === filesViewTypes.GRID ||
    gridType === filesViewTypes.MEDIUM_GRID ||
    gridType === filesViewTypes.LARGE_GRID
  ) {
    fileListingExpandCollapseMenu.addClass("is-hidden");
    gridSortingDropdown.removeClass("is-hidden");
    renderGridView(gridType);

    if (columnCustomization.canCheckboxColumnDisable) {
      if (filterSelectDropdown.el()) {
        filterSelectDropdown.removeClass("is-hidden");
      }
    }
  } else {
    gridSortingDropdown.addClass("is-hidden");
    fileListingExpandCollapseMenu.removeClass("is-hidden");
    lastSelectedFileID = null;

    if (hasUpdates) {
      renderTreeView();
    } else {
      renderTreeViewHeader();
    }

    handleFooterSelectionInfo();

    if (columnCustomization.canCheckboxColumnDisable) {
      if (filterSelectDropdown.el()) {
        filterSelectDropdown.addClass("is-hidden");
      }
      store.dispatch("handleSelectFiles", "uncheckAll");
    }
  }

  setTimeout(() => {
    handleFooterSelectionInfo();
  }, 0);
};

const listViewColumnCustomizationsBasket = () => {
  const customizations = {
    canCheckboxColumnDisable: utils.getUserCustomizationValue(
      "basket_HideCheckbox"
    ),
  };

  return customizations;
};

// **** START **** Render Files In Basket
const renderTreeViewHeaderBasket = () => {
  const treeView = _$("<div>")
    .addClass("list-container")
    .addClass("h-full")
    .html(
      ListingTemplatesBasket.TreeHeader({
        prefixId: "basket",
        name: t("name"),
        size: t("size"),
        lastModified: t("lastModified"),
        path: t("path"),
        keyword: t("keywords"),
        ...listViewColumnCustomizationsBasket(),
      })
    );

  const treeViewContainer = _$("#basket-grid-container");
  treeViewContainer.empty().append(treeView.el());

  const basketGridIconWrapper = _$("#basket-grid-icon-wrapper");
  basketGridIconWrapper.html('<i class="icon-th-list"></i>');

  const checkAllBasket = _$("#checkAllBasket");

  checkAllBasket.on("click", (e) => {
    const { basketDetails } = store;
    const isChecked = e.target.checked;
    const _files = basketDetails.files.map((element) => ({
      ...element,
      isChecked,
    }));

    _$("#basket-grid-container .table-tr").toggleClass("selected", isChecked);

    const checkboxInputs = _$(
      "#basket-grid-container .table-tr input[type='checkbox']"
    );
    checkboxInputs.prop("checked", isChecked);

    store.dispatch("setFilesInBasket", _files);
  });

  const checkThBasket = _$("#checkThBasket");
  checkThBasket.on("click", (e) => {
    if (e.target.id !== "checkAllBasket") {
      checkAllBasket.el().click();
    }
  });

  bindSortEventsBasket();
  renderTreeViewBasket();
};

const renderTreeViewBasket = () => {
  const { basketDetails } = store;
  const _files = [...basketDetails.files];

  const { inlineAudio, inlineAudioWave, inlineAudioAutonext } =
    getCommonCustomizationListingAndBasket();
  renderSortIcon("list", "basket");

  const scrollTopBeforeRerender =
    virtualScrollerBasket?.container?.scrollTop || 0;

  const checkbox = _$("#checkAllBasket").el();

  if (checkbox) {
    const checkedFilteredFile = _files.filter((file) => !file.isChecked);
    if (checkedFilteredFile.length === 0 && _files.length > 0) {
      checkbox.checked = true;
    } else {
      checkbox.checked = false;
    }
  }

  virtualScrollerBasket.init({
    totalRows: _files.length,
    generatorFn: (rowIndex) => {
      const { basketDetails } = store;
      const file = basketDetails.files[rowIndex];
      // Setting Attribute Of List Items
      const divLi = _$("<tr>").el();
      divLi.classList.add("table-tr");
      divLi.setAttribute("data-index", rowIndex);
      divLi.setAttribute("data-uid", file.id);
      if (file.type === fileTypes.DIR) {
        divLi.setAttribute("data-tree", file.treeIds);
        divLi.setAttribute("aria-expanded", file.ariaExpanded);
      }

      if (file.isChecked) {
        divLi.classList.add("selected");
      } else {
        divLi.classList.remove("selected");
      }

      // Displaying Item According To File Type
      divLi.innerHTML = ListingTemplatesBasket.TreeItem({
        rowIndex: rowIndex,
        checked: file.isChecked ? "checked" : "",
        paddingLeft: file.paddingLeft,
        image: getFilePreviewList(file),
        audio:
          inlineAudio &&
          getAudioPreviewList(file, inlineAudioWave, inlineAudioAutonext),
        name: file.name,
        path: file.root_dir,
        sizeFormatted: file.sizeFormatted,
        dateFormatted: utils.formatDateForListing(file.modified, file.dateFormatted),
        keywords: utils.decodeURILocal(file.keywords),
        ...listViewColumnCustomizationsBasket(),
      });
      applyTreeIndentation(divLi);

      const expandIcon = _$(divLi).find(".down-icon", true);
      expandIcon?.remove();

      // Event Listener For Check Box In List Item
      const chkBox = _$(divLi).find(".checks", true);
      if (chkBox) {
        _$(chkBox).on("click", (e) => {
          e.stopPropagation();
          if (e.target.checked) {
            divLi.classList.add("selected");
          } else {
            divLi.classList.remove("selected");
          }
          store.dispatch("handleCheckFileBasket", {
            selectedFile: file,
            isChecked: e.target.checked,
          });
        });
      }

      _$(divLi.children[2]).on("mouseenter", (e) => {
        tooltipForBasketFileListing.showTooltip({
          event: e,
          hoverDiv: divLi.children[1],
          data: file,
        });
      });
      _$(divLi.children[2]).on("mouseleave", (e) => {
        tooltipForBasketFileListing.removeTooltip(e);
      });

      _$(divLi)
        .find(".check-td")
        .on("click", (e) => {
          chkBox.click();
        });

      const noContextMenu = utils.getUserCustomizationValue(
        "basket_NoContextMenu"
      );

      if (!noContextMenu) {
        setContextMenu(divLi, file, filesViewTypes.LIST, true);
      }

      const removeButton = _$(divLi).find(".remove-item", true);
      _$(removeButton).on("click", (e) => {
        _$("#basket-grid-container").findByAttr("data-uid", file.id).remove();
        store.dispatch("handleRemoveFileBasket", {
          selectedFileId: file.id,
        });
      });

      return divLi;
    },
  });

  const vList = _$(`#basket-virtual-list`);
  vList.html("");

  if (_files.length === 0) {
    const listContainer = createNoFilesAvailableContainer();
    virtualScrollerBasket.container = listContainer;
  }

  vList.el().append(virtualScrollerBasket.container);
  _$(virtualScrollerBasket.container).css("height", "100%");
  virtualScrollerBasket.container.scrollTop = scrollTopBeforeRerender;
};

const renderGridViewBasket = (type) => {
  const { basketDetails } = store;
  let _files = [...basketDetails.files];

  const { inlineAudio, inlineAudioWave, inlineAudioAutonext } =
    getCommonCustomizationListingAndBasket();

  renderSortIcon("grid", "basket");

  const gridIconWrapper = _$("#basket-grid-icon-wrapper");
  if (type === filesViewTypes.GRID) {
    gridIconWrapper.html('<i class="icon-th"></i>');
  } else if (type === filesViewTypes.MEDIUM_GRID) {
    gridIconWrapper.html('<i class="icon-table"></i>');
  } else if (type === filesViewTypes.LARGE_GRID) {
    gridIconWrapper.html('<i class="icon-th-large"></i>');
  }

  const listContainer =
    type === filesViewTypes.GRID
      ? _$("<div>").addClass("grid-container").el()
      : type === filesViewTypes.MEDIUM_GRID
        ? _$("<div>")
            .addClass("grid-container")
            .addClass("medium-grid-container")
            .el()
        : _$("<div>")
            .addClass("grid-container")
            .addClass("large-grid-container")
            .el();

  if (_files.length > 0) {
    _files.forEach((file) => {
      const listItem = _$("<div>").el();
      listItem.classList.add("grid-item");
      if (file.type.toLowerCase() === "dir") listItem.classList.add("folder");
      listItem.setAttribute("data-uid", file.id);

      let checkbox = _$("<input>").el();
      checkbox.type = "checkbox";
      checkbox.tabIndex = -1;
      checkbox.checked = file.isChecked;

      _$(checkbox).on("click", (e) => {
        e.stopPropagation();
        if (e.target.checked) {
          listItem.classList.add("selected");
        } else {
          listItem.classList.remove("selected");
        }
        store.dispatch("handleCheckFileBasket", {
          selectedFile: file,
          isChecked: e.target.checked,
        });
      });

      _$(listItem).on("mouseenter", (e) => {
        tooltipForBasketFileListing.showTooltip({
          event: e,
          hoverDiv: listItem,
          data: file,
        });
      });
      _$(listItem).on("mouseleave", (e) => {
        tooltipForBasketFileListing.removeTooltip(e);
      });

      _$(listItem).on("click", (e) => {
        checkbox.click();
      });

      if (file.isChecked) {
        listItem.classList.add("selected");
      } else {
        listItem.classList.remove("selected");
      }

      listItem.innerHTML = ListingTemplates.GridItem({
        name: file.name,
        image: getFilePreviewGrid(file),
        audio:
          inlineAudio &&
          getAudioPreviewGrid(file, inlineAudioWave, inlineAudioAutonext),
      });

      const noContextMenu = utils.getUserCustomizationValue(
        "basket_NoContextMenu"
      );

      if (!noContextMenu) {
        setContextMenu(listItem, file, filesViewTypes.GRID, true);
      }

      let removeButton = _$("<i>").el();
      removeButton.classList.add("icon-remove-sign");
      removeButton.tabIndex = -1;

      _$(removeButton).on("click", (e) => {
        e.stopPropagation();
        _$("#basket-grid-container").findByAttr("data-uid", file.id).remove();
        tooltipForBasketFileListing.removeTooltip(e);
        store.dispatch("handleRemoveFileBasket", {
          selectedFileId: file.id,
        });
      });

      listItem.append(removeButton);
      listItem.append(checkbox);

      listContainer.append(listItem);
    });

    _$("#basket-grid-container").empty().el().append(listContainer);

    const selectionContainer = _$("#basket-grid-container").el();
    const selectableFiles = selectionContainer.querySelectorAll(
      ".grid-item:not(.is-disabled-dir-item)"
    );
    const selected = (file, e) => {
      file.classList.add("focused");
      tooltipForBasketFileListing.removeTooltip(e);
    };
    const unSelected = (file) => {
      file.classList.remove("focused");
    };
    new MouseSelection({
      selectableFiles,
      selectionContainer,
      selected,
      unSelected,
      onBeforeStart: () => {},
      onBeforeEnd: () => {},
    });
  } else {
    const listContainer = createNoFilesAvailableContainer();
    _$("#basket-grid-container").empty().el().append(listContainer);
  }
};

// Handling Grid-Type
const renderFilesInBasket = ({
  hasUpdates = false,
  gridType = store.basketDetails.activeView || filesViewTypes.LIST,
}) => {
  store.dispatch("handleChangeBasketView", gridType);

  if (
    gridType === filesViewTypes.GRID ||
    gridType === filesViewTypes.MEDIUM_GRID ||
    gridType === filesViewTypes.LARGE_GRID
  ) {
    _$("#basket-grid-sorting-dropdown").removeClass("is-hidden");
    renderGridViewBasket(gridType);
  } else {
    _$("#basket-grid-sorting-dropdown").addClass("is-hidden");
    if (hasUpdates) {
      renderTreeViewBasket();
      return;
    }
    renderTreeViewHeaderBasket();
  }
  setTimeout(() => {
    resizeBasket();
  }, 50);
};
// **** END **** Render Files In Basket

// Expand Click Function For List View
const toggleFolder = (event, currentElementId) => {
  const { files } = store;
  let _files = utils.deepCopy(files);

  event.preventDefault();
  event.stopPropagation();

  const isCurrentFile = (file) => {
    return file.id === currentElementId;
  };

  const currentClickedItem = _files.find(isCurrentFile);
  const selectedFileIndex = _files.findIndex(isCurrentFile);

  const path = currentClickedItem.href_path;
  const currentPath = path.endsWith("/") ? path : path + "/";
  if (currentClickedItem.ariaExpanded) {
    _files[selectedFileIndex].ariaExpanded = false;

    removeExpandedFolderAndChildren(currentPath);

    const filterData = (item) => {
      const splittedValue = item.treeIds.split("-");
      if (
        splittedValue?.includes(_files[selectedFileIndex].id) &&
        splittedValue[0] !== _files[selectedFileIndex].id
      ) {
        return false;
      }
      return true;
    };

    const filter = _files.filter((file) => filterData(file));

    _files.length = 0;
    filter.forEach((element) => {
      _files.push(element);
    });

    store.dispatch("updateFileListing", _files);
  } else {
    checkAndToggleExpandedFolder(currentPath, currentElementId);
  }
};

const logout = async (noconfirm) => {
  const logoutRedirectPath =
    store.userInfo.userCustomizations?.LogoutCustomRedirectPath?.value ||
    "/WebInterface/login.html";
  const logoutCustomAPICall =
    store.userInfo.userCustomizations?.LogoutCustomAPICall?.value || "";
  const continueLogout = async () => {
    const logoutLoader = new Loader({});

    try {
      // If custom logout API call is configured, make the cross-site call first
      if (logoutCustomAPICall && logoutCustomAPICall.trim() !== "") {
        try {
          // Make the custom OAuth logout call using window.open and wait for response
          await makeCrossSiteCall(logoutCustomAPICall);
        } catch (error) {
          // Ignore errors from custom API call - continue with logout regardless
          console.log("Custom logout API call failed:", error);
        }
      }

      // Proceed with normal logout flow
      await doLogout(logoutRedirectPath);
    } finally {
      logoutLoader.deleteLoader();
      utils.cookie.remove("currentAuth");
      window.location = logoutRedirectPath;
    }
  };

  // Helper function to make cross-site OAuth logout calls using window.open
  const makeCrossSiteCall = (url) => {
    return new Promise((resolve, reject) => {
      try {
        // Open the OAuth logout URL in a new window/tab
        const logoutWindow = window.open(
          url,
          "_blank",
          "width=600,height=400,scrollbars=yes,resizable=yes,menubar=no,toolbar=no,location=no,status=no"
        );

        if (!logoutWindow) {
          // If popup was blocked, try to navigate directly
          console.log("Popup blocked, attempting direct navigation");
          window.location.href = url;
          // Still resolve after timeout to continue logout
          setTimeout(() => {
            resolve();
          }, 5000);
          return;
        }

        let resolved = false;
        const cleanupAndResolve = () => {
          if (resolved) return;
          resolved = true;
          try {
            if (logoutWindow && !logoutWindow.closed) {
              logoutWindow.close();
            }
            resolve(); // Resolve regardless of success/failure
          } catch (error) {
            console.log("Error closing logout window:", error);
            resolve(); // Still resolve to continue logout
          }
        };

        // Listen for the window load event
        let checkCount = 0;
        const checkWindowState = () => {
          try {
            checkCount++;

            if (logoutWindow.closed) {
              cleanupAndResolve();
              return;
            }

            // Give the OAuth process more time to complete
            // Only start checking after 2 seconds and at least 20 checks
            if (checkCount < 20) {
              setTimeout(checkWindowState, 100);
              return;
            }

            // Check if the window's document is ready
            if (
              logoutWindow.document &&
              logoutWindow.document.readyState === "complete"
            ) {
              // Add a small delay to ensure the OAuth redirect has completed
              setTimeout(() => {
                cleanupAndResolve();
              }, 1000);
              return;
            }

            // Check if we can access the window's location (indicates it has loaded)
            try {
              const currentUrl = logoutWindow.location.href;
              if (currentUrl && currentUrl !== "about:blank") {
                // If we can access the URL and it's not blank, the page has loaded
                // Add a small delay to ensure the OAuth redirect has completed
                setTimeout(() => {
                  cleanupAndResolve();
                }, 1000);
                return;
              }
            } catch (e) {
              // Cross-origin access denied, but window is still open
              // Continue checking
            }

            // Continue checking every 500ms (slower than before)
            setTimeout(checkWindowState, 500);
          } catch (error) {
            // Window might be closed or inaccessible
            cleanupAndResolve();
          }
        };

        // Start checking the window state after 1 second delay
        setTimeout(checkWindowState, 1000);

        // Fallback timeout in case load event never fires
        setTimeout(() => {
          if (!resolved) {
            console.log("OAuth logout timeout reached, continuing with logout");
            cleanupAndResolve();
          }
        }, 15000); // 15 second fallback timeout
      } catch (error) {
        console.log("Error opening logout window:", error);
        resolve(); // Still resolve to continue logout
      }
    });
  };
  if (!noconfirm && !utils.storage.get("dontConfirmLogout")) {
    Confirm({
      title: t("confirm"),
      body: t("areYouSureYouWantToLogOut"),
      confirm: t("yes"),
      cancel: t("no"),
      prependFooter: utils.generateHTML([
        {
          type: "div.field.confirm-footer-field",
          children: [
            {
              type: "div.control",
              children: [
                {
                  type: "label.is-cursor-pointer",
                  children: [
                    {
                      type: "input@dontConfirmLogout",
                      attrs: { type: "checkbox" },
                    },
                  ],
                  textAfter: ` ${t("doNotShowThisAgain")}`,
                },
              ],
            },
          ],
        },
      ]),
    }).then(async (res) => {
      if (res) {
        if (res.dontConfirmLogout) {
          utils.storage.set("dontConfirmLogout", true);
        }
        if (canPreventLogout()) {
          Confirm({
            title: t("confirm"),
            body: "Are you sure you want to cancel ongoing process?",
            confirm: t("yes"),
            cancel: t("no"),
            closable: true,
          }).then(async (res) => {
            if (res) {
              preventTabLevelAction = true;
              await continueLogout();
            }
          });
        } else {
          await continueLogout();
        }
      }
    });
  } else {
    // When noconfirm is true (e.g., inactivity logout), skip all confirmations
    // including the "cancel ongoing process" confirmation and proceed directly
    preventTabLevelAction = true;
    await continueLogout();
  }
};

const getButtonsToShowOnDownloadFileCard = (status) => {
  const cardButtons = {
    queued: {
      cancelButton: true,
      waitingButton: true,
    },
    downloading: {
      pauseButton: true,
      cancelButton: true,
    },
    downloaded: {
      removeButton: true,
    },
    pausing: {
      pausingButton: true,
      cancelButton: true,
    },
    paused: {
      resumeButton: true,
      cancelButton: true,
    },
    failed: {
      removeButton: true,
    },
    canceled: {
      removeButton: true,
    },
    compressing: {
      compressingButton: true,
    },
    sandboxDownloading: {
      sandBoxDownloadMessage: true,
    },
    canceling: {
      cancelingButton: true,
    },
  };

  return cardButtons[status] || {};
};

const getProgressBarStatusDownload = (file) => {
  const { status, progressStatus } = file;
  const { bytesDownloaded, fileSize } = progressStatus;

  const calculatePercentage = Math.min(
    parseInt((bytesDownloaded / fileSize) * 100),
    99
  );
  const downloadedBytesFormatted = utils.formatBytes(bytesDownloaded);

  const progressBarStatus = {
    downloadedBytesFormatted,
    downloadedBytes: bytesDownloaded,
    sizeInBytes: fileSize,
    completedPercentage: `${calculatePercentage || 0} %`,
    showProgressBar:
      status === "downloading" ||
      status === "paused" ||
      status === "pausing" ||
      status === "compressing",
  };

  return progressBarStatus;
};

const getTimeStatusDownload = (file) => {
  const { timeStatus } = file;

  if (!timeStatus) return {};

  const { speed, elapsedTime, timeRemaining, avg10SecSpeed } = timeStatus;

  const downloadingAvg10SecSpeed = utils.formatBytes(avg10SecSpeed || 0);
  const downloadingSpeed = utils.formatBytes(speed);
  const _elapsedTime = utils.formatTime({
    secs: elapsedTime,
    minLabel: "m",
    secondsLabel: "s",
  });
  const _timeRemaining = timeRemaining
    ? utils.formatTime({
        secs: timeRemaining,
        minLabel: "m",
        secondsLabel: "s",
      })
    : "-";

  return {
    last10SecAvgSpeed: `${downloadingAvg10SecSpeed}/s`,
    speed: `${downloadingSpeed}/s`,
    elapsedTime: _elapsedTime,
    timeRemaining: `${_timeRemaining}`,
  };
};

const getCompletionMessage = (file) => {
  const { status, timeTakenToComplete, size } = file;

  if (status !== "downloaded") {
    return false;
  }

  const timeInSec = timeTakenToComplete / 1000;
  const timeTaken =
    timeInSec < 1
      ? `${timeInSec.toFixed(1)} s`
      : utils.formatTime({
          secs: timeInSec,
          minLabel: "m",
          secondsLabel: "s",
        });

  const averageSpeed = parseInt(size) / timeInSec;
  const averageDownloadingSpeed = utils.formatBytes(averageSpeed);

  return {
    timeTaken,
    speed: `${averageDownloadingSpeed}/s`,
    message: t("downloadedInSecAtAnAverageSpeed", {
      time: timeTaken,
      speed: `${averageDownloadingSpeed}/s`,
    }),
  };
};

const getErrorMessage = (file) => {
  const { downloadingError } = file;

  return downloadingError || ``;
};

const downloadButtonListeners = (card, file) => {
  const { id, name } = file;
  const downloadFileCard = card;

  const pauseButton = downloadFileCard.querySelector(".pause-button");
  const cancelButton = downloadFileCard.querySelector(".cancel-button");
  const resumeButton = downloadFileCard.querySelector(".resume-button");
  const removeButton = downloadFileCard.querySelector(".remove-button");

  pauseButton?.addEventListener("click", () => {
    console.log("pause-button-clicked", id);
    downloadingQueue.pause();
  });
  cancelButton?.addEventListener("click", () => {
    console.log("cancel-button-clicked", id);

    const doCancel = window.confirm(
      `Are you sure you want to cancel (${name}) file from downloading?`
    );

    if (!doCancel) {
      return;
    }

    const curDownloadingFile = downloadingQueue.getCurrentDownloadingFile();

    if (id && curDownloadingFile?.id === id) {
      downloadingQueue.cancel();
    } else {
      downloadingQueue.remove(id, false);

      store.dispatch("updateFileStatusDownload", {
        fileId: id,
        updates: {
          status: "canceled",
          downloadingError: "canceled",
        },
      });
    }
  });
  resumeButton?.addEventListener("click", () => {
    console.log("resume-button-clicked", id);
    downloadingQueue.resume();
  });
  removeButton?.addEventListener("click", () => {
    console.log("remove-button-clicked", id);
    downloadingQueue.remove(id);
  });
};

const renderDownloadFiles = () => {
  const downloadFileSection = _$("#downloadFileSection").el();
  const fileList = Object.values(store.downloadFilesDetails.files);

  const { inlineAudio, inlineAudioWave, inlineAudioAutonext } =
    getCommonCustomizationListingAndBasket();

  const scrollTopBeforeRerender =
    virtualScrollerDownload?.container?.scrollTop || 0;

  downloadFileSection.innerHTML = "";

  if (fileList.length === 0) {
    downloadFileSection.insertAdjacentHTML(
      "beforeend",
      noFilesAvailableTemplate({})
    );
    _$("#remove-all-button-advanced-download").addClass("is-hidden");
    return;
  }

  _$("#remove-all-button-advanced-download").removeClass("is-hidden");

  virtualScrollerDownload.init({
    totalRows: fileList.length,
    generatorFn: (rowIndex) => {
      const { id } = fileList[rowIndex];

      const filesObj = store.downloadFilesDetails.files;
      const file = filesObj[id];

      const downloadFileCardWrapper = _$("<div>").el();
      downloadFileCardWrapper.id = file.id;
      downloadFileCardWrapper.classList.add("download-file-card-wrapper");

      const buttonsToShow = getButtonsToShowOnDownloadFileCard(file.status);
      const progressBarStatus = getProgressBarStatusDownload(file);
      const timeStatus = getTimeStatusDownload(file);
      const completionDetails = getCompletionMessage(file);
      const downloadingError = getErrorMessage(file);

      let lastModifiedF = utils.formatDateForListing(
        file.modified,
        file.dateFormatted
      );

      downloadFileCardWrapper.insertAdjacentHTML(
        "beforeend",
        downloadFileCardTemplate({
          image: getFilePreviewGrid(file),
          audio:
            inlineAudio &&
            getAudioPreviewGrid(file, inlineAudioWave, inlineAudioAutonext),
          name: file.name,
          size: utils.formatBytes(parseInt(file.size)),
          lastModifiedF,
          downloadType: file?.downloadType,
          bytesWritten: file?.bytesWritten,
          approxWritingTime: utils.formatTime({
            secs: Math.floor(file?.size / 20000000),
          }),
          ...buttonsToShow,
          ...progressBarStatus,
          ...timeStatus,
          completionMessage: completionDetails?.message,
          timeTaken: completionDetails?.timeTaken,
          averageDownloadSpeed: completionDetails?.speed,
          downloadingError,
          ...DownloadFileCardTemplateTexts(),
        })
      );

      downloadButtonListeners(downloadFileCardWrapper, file);
      return downloadFileCardWrapper;
    },
  });

  downloadFileSection.append(virtualScrollerDownload.container);
  virtualScrollerDownload.container.scrollTop = scrollTopBeforeRerender;
};
//

const tripleClickHandler = (element, callback, threshold = 300) => {
  let clickCount = 0;
  let lastClickTime = 0;

  element.addEventListener("click", (event) => {
    const currentTime = new Date().getTime();

    if (currentTime - lastClickTime < threshold) {
      clickCount++;

      if (clickCount === 3) {
        callback(event);
        clickCount = 0;
      }
    } else {
      clickCount = 1;
    }

    lastClickTime = currentTime;
  });
};

// Subscribe to file actions
const subscribe = () => {
  const fileActions = [
    {
      eventName: "handleSetUserOptions",
      callback: (action, payload) => {
        const { preferenceData, userOptions } = payload;

        // hide filter section
        const filterSortingSection = _$(".filter-sorting-section");
        const filterInputContainer = filterSortingSection.el()
          ? filterSortingSection.find(".filter-input-wrapper", true)
          : null;
        const searchAndFilterDivider = filterSortingSection.el()
          ? filterSortingSection.find("#searchAndFilterDivider")
          : null;

        if (filterInputContainer && searchAndFilterDivider) {
          if (preferenceData.hideFilterSection) {
            _$(filterInputContainer).addClass("is-hidden");
            searchAndFilterDivider.addClass("is-hidden");
          } else {
            _$(filterInputContainer).removeClass("is-hidden");
            searchAndFilterDivider.removeClass("is-hidden");
          }
        }

        // hide dot items
        if (
          (preferenceData.hideDotItems && !userOptions.hideDotItems) ||
          (!preferenceData.hideDotItems && userOptions.hideDotItems)
        ) {
          store.dispatch("refreshListing");
          return;
        }

        // hide checkbox column
        if (
          preferenceData.hideCheckboxColumn &&
          !userOptions.hideCheckboxColumn
        ) {
          store.dispatch("handleSelectFiles", "uncheckAll");

          const allCheckboxInput = _$(
            "#dashboard-files-section .table-tr .table-td.check-td,#dashboard-files-section #checkTh"
          ).sel();
          allCheckboxInput.forEach((elem) => {
            const checkboxInput = _$(elem).find(
              "input[type = 'checkbox']",
              true
            );
            checkboxInput.checked = false;
            elem.classList.add("is-hidden");
          });
        } else if (
          !preferenceData.hideCheckboxColumn &&
          userOptions.hideCheckboxColumn
        ) {
          const allCheckboxInput = _$(
            "#dashboard-files-section .table-tr .table-td.check-td,#dashboard-files-section #checkTh"
          ).sel();
          allCheckboxInput.forEach((elem) => {
            elem.classList.remove("is-hidden");
          });
        }
      },
    },
    {
      eventName: "handleSelectFiles",
      callback: () => {
        handleFooterSelectionInfo();
        if (utils.storage.get("activeView") === filesViewTypes.LIST) {
          renderTreeView();
        }
      },
    },
    {
      eventName: "handleCheckFile",
      callback: () => {
        handleFooterSelectionInfo();
        if (utils.storage.get("activeView") === filesViewTypes.LIST) {
          renderTreeView();
        }
      },
    },
    {
      eventName: "handleSelectFilesInRange",
      callback: () => {
        handleFooterSelectionInfo();
        if (utils.storage.get("activeView") === filesViewTypes.LIST) {
          renderTreeView();
        }
      },
    },
    {
      eventName: "refreshListing",
      callback: () => {
        refreshListing();
        handleFooterSelectionInfo();
      },
    },
    {
      eventName: "setFileListing",
      callback: () => {
        renderFiles({});
        const filterValue = _$("#dashboard-filter-input").val();
        store.dispatch("searchFilesByValue", filterValue);
      },
    },
    {
      eventName: "handleToggleFileFromIDs",
      callback: handleFooterSelectionInfo,
    },
    {
      eventName:
        "updateFileListing, sortListing, keepDirectoryOnTop, setFileListingOnSort",
      callback: () => {
        renderFiles({ hasUpdates: true });
      },
    },
    {
      eventName: "searchFilesByValue",
      callback: (action, payload) => {
        if (payload.length > 0) {
          renderFiles({ hasUpdates: true });
          _$("#dashboard-filterResultNotification").html(
            searchFilterResultTemplate({
              clearText: t("clear"),
              prefixId: "dashboard",
              filterApplied: t("filterApplied"),
            })
          );
          _$("#dashboard-clear-filter").on("click", () => {
            _$("#dashboard-filter-input").val("");
            _$("#dashboard-filterResultNotification").html("");
            const isApplied = applyFilterInputCustomization();
            if (isApplied) return;
            store.dispatch("searchFilesByValue");
          });
        } else {
          renderFiles({ hasUpdates: true });
          _$("#dashboard-filterResultNotification").html("");
        }
      },
    },
    {
      eventName: "navigateToDir",
      callback: (action, payload) => {
        const path = payload?.path || "";
        const type = payload?.type || "";
        if (path) {
          hashListener.setPath(path, type === fileTypes.DIR);
        }
      },
    },
    {
      eventName: "setCurrentDirInfo",
      callback: () => {
        const { currentDirectoryInfo } = store;

        if (
          currentDirectoryInfo &&
          currentDirectoryInfo.privs &&
          currentDirectoryInfo.privs.includes("(locked)") &&
          currentDirectoryInfo.privs.includes("(expired)")
        ) {
          _$(".user-buttons-section").remove();
          return;
        }

        const topBarButtonsIconsOnly = utils.getUserCustomizationValue(
          "topBarButtonsIconsOnly"
        );

        menubar.render({
          onclick: (evt, btn) => {
            const isLink = btn.getAttribute("data-link");
            if (isLink === "true") {
              window.redirectingToLink = true;
              return true;
            }
            evt.preventDefault();
            evt.stopPropagation();
            const curPath = hashListener.getPath();
            userActions.invoke({
              name: btn.getAttribute("data-command"),
              curPath,
            });
          },
        });

        const searchOnRoot = utils.getUserCustomizationValue(
          "searchOnRoot",
          true
        );
        if (searchOnRoot === "false" && hashListener.getPath() === "/") {
          _$(`#user-buttons [meta^="(search)"]`).remove();
        }

        if (topBarButtonsIconsOnly) {
          const userButtons = _$("#user-buttons");
          userButtons.addClass("top-bar-icons-only");
          if (!buttonsTooltip) {
            buttonsTooltip = new Tooltip();
          }
          userButtons
            .find("[data-tooltip]")
            .sel()
            .forEach((button) => {
              buttonsTooltip.addTooltip({ element: button });
            });
        }
        const iframe = _$("#fileUploadIframe").el();
        iframe?.contentWindow?.postMessage({
          key: "refreshUploadList",
        });

        const hideQuotaForSubdirs = utils.getUserCustomizationValue(
          "hideQuotaForSubdirs"
        );
        const quota = currentDirectoryInfo?.quota;
        const hideQuotaForSubDirectories =
          hideQuotaForSubdirs && hashListener.getPath() !== "/";

        if (quota && !hideQuotaForSubDirectories) {
          _$("#quota-available-for-directory").removeClass("is-hidden");
          _$("#quota-available-for-directory .quota").text(quota);
        } else {
          _$("#quota-available-for-directory").addClass("is-hidden");
        }
      },
    },
    {
      eventName: "handleClearBasket",
      callback: () => {
        renderFilesInBasket({});
      },
    },
    {
      eventName:
        "handleRemoveFileBasket, addFilesToBasket, showBasket, setBasketItemsOnSort, setBasketItemsOnDirectorySort",
      callback: (action) => {
        if (action === "addFilesToBasket" || action === "showBasket") {
          if (!basket.visible()) basket.show();
          renderFilesInBasket({});
          return;
        }
        renderFilesInBasket({ hasUpdates: true });
      },
    },
    {
      eventName: "filterBasketItems",
      callback: (action, payload) => {
        if (action === "addFilesToBasket" || action === "showBasket") {
          if (!basket.visible()) basket.show();
          renderFilesInBasket({});
          return;
        }
        if (
          action === "handleRemoveFileBasket" &&
          store.basketDetails.activeView !== filesViewTypes.LIST
        ) {
          return;
        }
        renderFilesInBasket({ hasUpdates: true });

        if (payload.length > 0) {
          _$("#basket-filterResultAnimation").remove();
          _$("#basket-filterResultNotification").html(
            searchFilterResultTemplate({
              clearText: t("clear"),
              prefixId: "basket",
              filterApplied: t("filterApplied"),
            })
          );
          _$("#basket-filterResultAnimation").on("animationend", (e) => {
            e.target.remove();
          });
          _$("#basket-clear-filter").on("click", () => {
            _$("#basket-filter-input").val("");
            store.dispatch("filterBasketItems");
          });
        } else _$("#basket-filterResultNotification").html("");
      },
    },
    {
      eventName: "setUserInfo",
      callback: (action, payload) => {
        if (Object.keys(payload).length > 0) {
          const { username, server_time, app_version } = payload;
          const loggedInDetailsTriggerButton = _$(
            "#logged-in-dropdown-trigger"
          ).el();
          const loggedInDetailsDropdown = _$("#profileHeaderDropdown").el();

          loggedInDetailsTriggerButton.innerHTML =
            LoggedInInfoTriggerButtonTemplate({
              username,
            });

          const loginTime = utils.formatDateForListing(server_time, "");

          const enableUserInformation = utils.getUserCustomizationValue(
            "enableUserInformationPopup"
          );

          const userPrivOptions = store?.userInfo?.user_priv_options;
          const isAdminUser = userPrivOptions
            ?.toLowerCase()
            .includes("(connect)");

          const canUseWebSocketForUploading = utils.getUserCustomizationValue(
            "useWSForAdvancedUploads"
          );

          const canUseWebSocketForDownloading = utils.getUserCustomizationValue(
            "useWSForAdvancedDownloads"
          );

          const uploadTypeCustomization = utils.getUserCustomizationValue(
            "uploadTypeCustomization",
            true
          );
          const downloadTypeCustomization = utils.getUserCustomizationValue(
            "downloadTypeCustomization",
            true
          );

          if (username?.toLowerCase() !== "anonymous") {
            loggedInDetailsDropdown.innerHTML = LoggedInInfoTemplate({
              username,
              loginTime,
              sessionTimeout: "",
              browserName: utils.getBrowserName(),
              browserVersion: "",
              browserInfo: navigator.appVersion,
              hostURL: location.href,
              hostName: location.hostname,
              version: `${app_version} (${versionData.version})`,
              recentActions: "",
              enableUserInformation,
              canShowCustomThemeOption: isAdminUser,
              canUseWebSocketForUploading: canUseWebSocketForUploading
                ? "<span data-i18n-key='enabled'>Enabled</span>"
                : "<span data-i18n-key='disabled'>Disabled</span>",
              canUseWebSocketForDownloading: canUseWebSocketForDownloading
                ? "<span data-i18n-key='enabled'>Enabled</span>"
                : "<span data-i18n-key='disabled'>Disabled</span>",
              uploadTypeCustomization: uploadTypeCustomization
                ? uploadTypeCustomization
                    ?.split("\n")
                    ?.map((line) => utils.textEncode(line))
                    ?.join(",<br>")
                : "<span data-i18n-key='disabled'>Disabled</span>",
              downloadTypeCustomization: downloadTypeCustomization
                ? downloadTypeCustomization
                    ?.split("\n")
                    ?.map((line) => utils.textEncode(line))
                    ?.join(",<br>")
                : "<span data-i18n-key='disabled'>Disabled</span>",
              ...LoggedInInfoTexts(),
            });
          }

          tripleClickHandler(_$("#logged-in-dropdown-trigger")[0], () => {
            C.log("Tripple clicked downloading logs");
            C.downloadLogs();
          });

          _$("#logout").on("click", (e) => {
            logout().catch(console.error);
            e.preventDefault();
            return false;
          });

          if (isAdminUser) {
            _$("#custom-theme").on("click", async (e) => {
              _$("#logged-in-details-dropdown").removeClass("is-active");

              const renderCustomThemeModal = () => {
                const applyTheme = () => {
                  _customThemePreviewActive = true;
                  applyCustomThemePreview();
                };

                const CSSThemeVariables = store.CSSThemeVariables;

                const resetTheme = () => {
                  updateVariablesSnippet(CSSThemeVariables);
                };

                const resetThemeToDefault = () => {
                  updateVariablesSnippet(defaultThemeColors);
                };

                new Modal({
                  uniqueId: "custom_theme",
                  body: CustomThemeTemplate({}),
                  onAfterShow: () => {
                    const customTheme = _$("#customTheme").el();

                    Object.keys(_defaultThemeColors).forEach((key) => {
                      const inputElement = customTheme.querySelector(`#${key}`);
                      if (inputElement) {
                        inputElement.value = _defaultThemeColors[key];
                      }
                    });
                  },
                  title: "customTheme",
                  animate: false,
                  backdrop: false,
                  movable: true,
                  closable: false,
                  minWidth: "800px",
                  minHeight: "700px",
                  buttons: [
                    {
                      label: "reset",
                      classes: ["primary-button", "is-bordered"],
                      onClick: resetTheme,
                    },
                    {
                      label: "resetToDefaults",
                      classes: ["primary-button", "is-bordered", "ml-3"],
                      onClick: resetThemeToDefault,
                    },
                    {
                      label: "close",
                      close: true,
                      classes: ["primary-button", "ml-3"],
                      onClick: () => {},
                    },
                  ],
                });

                const customTheme = _$("#customTheme").el();
                const customThemeForm = _$("#customTheme form").el();
                const variablesSnippet =
                  customTheme.querySelector("#variablesSnippet");

                const updateVariablesSnippet = (data) => {
                  _defaultThemeColors = data;

                  Object.entries(data).forEach(([key, value]) => {
                    _$(`#${key}`).val(value);
                  });

                  variablesSnippet.value = generateCSSThemeSnippet(data);
                  applyTheme();
                };

                const handleFormData = () => {
                  const data = utils.serializeInputs(customThemeForm);
                  variablesSnippet.value = "";
                  updateVariablesSnippet(data);
                };

                const addInputEventListeners = () => {
                  const inputFields = customThemeForm.querySelectorAll("input");
                  inputFields.forEach((input) => {
                    input.addEventListener("input", handleFormData);
                  });
                };

                const copyVariablesToClipboard = () => {
                  navigator.clipboard.writeText(
                    utils.decodeURILocal(variablesSnippet.value)
                  );
                  growl(t("linkCopiedToClipboard"), "", 5000);
                };

                _$("#copyVariableSnippetToClipboard").on(
                  "click",
                  copyVariablesToClipboard
                );

                updateVariablesSnippet(CSSThemeVariables);
                addInputEventListeners();
              };

              if (store?.CSSThemeVariables) {
                renderCustomThemeModal();
                return;
              }

              try {
                const c2f = utils.cookie.get("currentAuth");

                const customCSS = await ajax.call({
                  method: "GET",
                  url: "/WebInterface/custom.css",
                  data: {
                    c2f,
                  },
                  urlEncoded: true,
                });

                const customThemeVariables =
                  utils.extractCSSVariables(customCSS);
                store.dispatch("setCSSThemeVariables", customThemeVariables);
              } catch (error) {
                store.dispatch("setCSSThemeVariables", defaultThemeColors);
              } finally {
                renderCustomThemeModal();
              }
            });
          }

          applyCustomizations();
          if (server_time) {
            sessionChecker.updateTimer();

            if (payload.account_expire?.length > 0) {
              console.log(payload.account_expire);
            }
          }

          const overrideFontFamily = utils.getUserCustomizationValue(
            "fontFace",
            true
          );
          if (overrideFontFamily) {
            // NOTE: CSS custom properties via setProperty are still inline styles and violate CSP.
            // For strict CSP compliance, consider using data attributes with CSS attr() or pre-defined theme classes.
            document.documentElement.style.setProperty(
              "--font-family",
              overrideFontFamily
            );
          }
        }
      },
    },
    {
      eventName: "setCopiedItems",
      callback: (action, payload) => {
        const selectedPaths = payload?.selectedPaths || [];
        if (selectedPaths.length > 0) {
          menubar.highlightPaste();
        } else {
          menubar.highlightPaste(true);
        }
      },
    },
    {
      eventName: "pasteInProgress",
      callback: (action, payload) => {
        console.log({ store });
        const { pastedItems } = store;
        console.log(pastedItems);

        pastedItems.forEach((item) => {
          const activityId = item.uiActivityId || item.id;
          const prevStatus = activityTracking.getStatusById(activityId);
          const totalCount =
            item.totalItemsCount ||
            item.items?.length ||
            item.batchItemsCount ||
            0;
          const batchInfo =
            item.totalBatches > 1
              ? ` Batch ${item.batchNumber || 1} of ${item.totalBatches}.`
              : "";
          const statusDetail = (item.response || "")
            .replace(/^COMPLETED:OK\s*/i, "")
            .replace(/^ERROR:OK\s*/i, "")
            .replace(/^COMPLETED:\s*/i, "")
            .replace(/^ERROR:\s*/i, "")
            .trim();
          const statusLabel =
            item.status === operationStatus.COMPLETED
              ? "Completed."
              : item.status === operationStatus.FAILED
                ? "Failed."
                : item.status === operationStatus.CANCELED
                  ? "Canceled."
                  : "";
          const detailText = [statusLabel, statusDetail]
            .filter(Boolean)
            .join(" ");
          const id = activityTracking.createOrUpdate({
            id: activityId,
            type: "Paste",
            message: `Copying ${totalCount} item(s) to ${
              item.curPath
            }.${batchInfo}${detailText ? ` ${detailText}` : ""}`,
            // hasProgressBar: false,
            hasInfiniteLoader:
              item.status === operationStatus.WAITING ||
              item.status === operationStatus.ONGOING ||
              false,
            onCancel: (activity) => {
              if (
                item.status === operationStatus.WAITING ||
                item.status === operationStatus.ONGOING
              ) {
                Confirm({
                  title: t("confirm"),
                  body: t("areYouSureYouWantToCancelThePasteAction"),
                  confirm: t("yes"),
                  cancel: t("no"),
                  closable: true,
                }).then((res) => {
                  if (res) {
                    apiCall("paste_cancel", { id: item.id })
                      .then((result) => {
                        console.log(result);
                      })
                      .catch((ex) => {});
                  }
                });
              } else {
                store.dispatch("pasteInProgress", {
                  id: activity.id,
                  action: "remove",
                });
                activityTracking.remove(activity.id);
              }
            },
            status: item.status,
          });

          if (!prevStatus) {
            activityTracking.show();
          }
        });

        const updatedItem = pastedItems.find((item) => item.id === payload.id);
        if (updatedItem) {
          const operationId = updatedItem.uiActivityId || updatedItem.copy_id;
          const sameOperationItems = pastedItems.filter(
            (item) => (item.uiActivityId || item.copy_id) === operationId
          );

          const hasFailure = sameOperationItems.some(
            (item) => item.status === operationStatus.FAILED
          );
          const hasActive = sameOperationItems.some(
            (item) =>
              item.status === operationStatus.WAITING ||
              item.status === operationStatus.ONGOING
          );
          const isFinalBatchCompleted = sameOperationItems.some(
            (item) =>
              (item.batchNumber || 1) === (item.totalBatches || 1) &&
              item.status === operationStatus.COMPLETED
          );

          if (hasFailure || (isFinalBatchCompleted && !hasActive)) {
            refreshListing();
          }
        }
      },
    },
    {
      eventName: "startQuickView",
      callback: (action, payload) => {
        const files = payload?.files || [];
        if (files.length > 0) {
          quickViewSlider.updateSliderMediaArray({
            files: files,
          });
          quickViewSlider.openSlider(payload.activeFileId);
        } else {
          toast({
            type: "warning",
            title: "No items available, or problem while fetching records.",
            autoClose: true,
            delay: 5000,
          });
        }
      },
    },
    {
      eventName: "startSlideShow",
      callback: (action, payload) => {
        const files = payload?.files || [];
        if (files.length > 0) {
          const slideshow = new Slideshow(files);
          slideshow.openSlideShow(payload.activeFileId);
        } else {
          toast({
            type: "warning",
            title: "No items available, or problem while fetching records.",
            autoClose: true,
            delay: 5000,
          });
        }
      },
    },
    {
      eventName: "logoutRequested",
      callback: logout,
    },
    {
      eventName: "setSearchFilterDetails",
      callback: (action, payload) => {
        const searchResultNotification = _$(
          "#dashboard-searchResultNotification"
        );
        const filterInput = _$("#dashboard-filter-input");

        if (!payload.isSearchFilterActive) {
          searchResultNotification.removeClass("is-flex").addClass("is-hidden");

          if (filterInput.el()) {
            filterInput.val("");
          }
        } else {
          searchResultNotification.removeClass("is-hidden").addClass("is-flex");
        }
      },
    },
    {
      eventName: "setFilesInDownload",
      callback: (action, payload) => {
        renderDownloadFiles();
      },
    },
    {
      eventName: "removeAllDownloadFiles",
      callback: () => {
        renderDownloadFiles();
      },
    },
    ...advancedDownloadSubscribeEvents,
    {
      eventName: "updateFileStatusDownload",
      callback: (action, payload) => {
        const { fileId } = payload;

        if (!_$(`#${fileId}`).el()) return;

        store.dispatch("enableGlobalDownload");

        const file = store.downloadFilesDetails.files[fileId];

        const buttonsToShow = getButtonsToShowOnDownloadFileCard(file.status);
        const progressBarStatus = getProgressBarStatusDownload(file);
        const timeStatus = getTimeStatusDownload(file);
        const completionDetails = getCompletionMessage(file);
        const downloadingError = getErrorMessage(file);

        const { inlineAudio, inlineAudioWave, inlineAudioAutonext } =
          getCommonCustomizationListingAndBasket();

        let lastModifiedF = utils.formatDateForListing(
          file.modified,
          file.dateFormatted
        );

        _$(`#${fileId}`).html(
          downloadFileCardTemplate({
            image: getFilePreviewGrid(file),
            audio:
              inlineAudio &&
              getAudioPreviewGrid(file, inlineAudioWave, inlineAudioAutonext),
            name: file.name,
            bytesWritten: file?.bytesWritten,
            size: utils.formatBytes(parseInt(file.size)),
            lastModifiedF,
            approxWritingTime: utils.formatTime({
              secs: Math.floor(file?.size / 20000000),
            }),
            downloadType: file?.downloadType,
            ...buttonsToShow,
            ...progressBarStatus,
            ...timeStatus,
            completionMessage: completionDetails?.message,
            timeTaken: completionDetails?.timeTaken,
            averageDownloadSpeed: completionDetails?.speed,
            downloadingError,
            ...DownloadFileCardTemplateTexts(),
          })
        );

        downloadButtonListeners(_$(`#${fileId}`).el(), file);
      },
    },
    {
      eventName: "deleteFileInDownload",
      callback: (action, payload) => {
        renderDownloadFiles();
      },
    },
    {
      eventName: "handleExpandAllDashboardListing",
      callback: async (action, payload) => {
        async function expandAndFetchFiles(file) {
          const { treeIds: dataTreeId, isChecked, href_path: path } = file;
          const paddingLeft = file.paddingLeft
            ? parseInt(file.paddingLeft, 10) + 20
            : 12;

          const data = await getListingFromPath(
            utils.encodeURILocal(path.endsWith("/") ? path : path + "/")
          );
          const { listing, privs } = data;

          if (listing) {
            const expandedFiles = [];

            for (const item of listing) {
              const id = utils.getUId();
              const newItem = {
                ...item,
                privs: item.privs || privs,
                preview: parseInt(item.preview),
                mediaInfo: utils.isMedia(item.name),
                id: `${id}`,
                treeIds: `${id}-${dataTreeId}`,
                paddingLeft,
                ariaExpanded: item.type === fileTypes.DIR,
                isChecked,
              };

              expandedFiles.push(newItem);

              if (newItem.type === fileTypes.DIR) {
                const subExpandedFiles = await expandAndFetchFiles(newItem);
                expandedFiles.push(...subExpandedFiles);
              }
            }

            return expandedFiles;
          }

          return [];
        }

        const loading = new Loader({
          parentElement: "#dashboard-files-section",
        });
        const _files = store.files;
        const finalFilesListAfterExpand = [];

        for (const file of _files) {
          finalFilesListAfterExpand.push({
            ...file,
            ariaExpanded: file.type === fileTypes.DIR,
          });

          if (file.type === fileTypes.DIR && !file.ariaExpanded) {
            const expandedFiles = await expandAndFetchFiles(file);
            finalFilesListAfterExpand.push(...expandedFiles);
          }
        }

        store.dispatch(
          "updateFileListingOnExpandOrCollapse",
          finalFilesListAfterExpand
        );
        loading.deleteLoader();
      },
    },
    {
      eventName: "handleCollapseAllDashboardListing",
      callback: (action, payload) => {
        const _files = store.files;
        const curPath = hashListener.getPath();

        const filteredFilesForCurrentPath = _files.filter((file) => {
          if (file.root_dir === curPath) {
            delete file.ariaExpanded;
            delete file.isDataAdded;
            return file;
          }
        });

        store.dispatch(
          "updateFileListingOnExpandOrCollapse",
          filteredFilesForCurrentPath
        );
      },
    },
    {
      eventName: "updateFileListingOnExpandOrCollapse",
      callback: () => {
        renderFiles({ hasUpdates: true });
      },
    },
    {
      eventName: "keepSessionAlive",
      callback: () => {
        clearInterval(sessionReviveIntervalId);

        sessionReviveIntervalId = setInterval(() => {
          sessionChecker.makeReviveCall();
        }, 10000);
      },
    },
    {
      eventName: "stopAliveSession",
      callback: () => {
        clearInterval(sessionReviveIntervalId);
      },
    },
    {
      eventName: "scrollToCurrentDownloadFile",
      callback: (action, payload) => {
        const scrollWithActivityDownload = _$("#scrollWithActivityDownload");
        const scrollWithActivityDownloadWrapper = _$(
          "#scrollWithActivityDownloadWrapper"
        );

        const { file } = payload;

        if (scrollWithActivityDownloadWrapper.hasClass("is-hidden")) {
          scrollWithActivityDownloadWrapper.removeClass("is-hidden");
        }

        const canScrollUploadList = scrollWithActivityDownload.el().checked;
        if (!canScrollUploadList || !file) {
          return;
        }

        const { id } = file;

        const fileList = Object.values(store.downloadFilesDetails.files);
        const index = fileList.findIndex((file) => file.id === id);

        if (index > -1) {
          virtualScrollerDownload.scrollToIndex(index);
        }
      },
    },
    {
      eventName: "downloadingQueueFinished",
      callback: (action, payload) => {
        const scrollWithActivityDownloadWrapper = _$(
          "#scrollWithActivityDownloadWrapper"
        );
        scrollWithActivityDownloadWrapper.addClass("is-hidden");
      },
    },
    {
      eventName: "disableGlobalDownload",
      callback: () => {
        _$("#globalDownloads").html("");
        _$("#globalDownloads").addClass("is-hidden");
      },
    },
    {
      eventName: "enableGlobalDownload",
      callback: (action, payload) => {
        const currentDownloadingFile =
          downloadingQueue.getCurrentDownloadingFile();
        const downloadingFiles = downloadingQueue.getGlobalDownloadedFiles();
        const completedFiles = downloadingQueue.getCompletedFiles();

        if (downloadingFiles.length === 0) {
          return;
        }

        const curFile =
          store.downloadFilesDetails.files[currentDownloadingFile.id];

        if (!curFile) {
          return;
        }

        let elapsedTime = curFile.timeStatus.elapsedTime;
        let totalBytesToDownload = 0;
        let totalBytesDownloaded = curFile.progressStatus.bytesDownloaded || 0;

        downloadingFiles.forEach((file) => {
          const _file = store.downloadFilesDetails.files[file.id];
          totalBytesToDownload += Number(_file?.size) || 0;
        });

        completedFiles.forEach((file) => {
          const _file = store.downloadFilesDetails.files[file.id];
          elapsedTime += _file?.timeStatus?.elapsedTime || 0;
          totalBytesDownloaded += Number(_file?.size) || 0;
        });

        const { downloadedBytesFormatted, completedPercentage } =
          getProgressBarStatusGlobal({
            downloadedBytes: totalBytesDownloaded,
            size: totalBytesToDownload,
          });

        const size = utils.formatBytes(totalBytesToDownload);
        const status =
          store.downloadFilesDetails.files[currentDownloadingFile.id].status;
        const showCardButtons = getButtonsToShowOnFileCardGlobal(status);

        const formattedElapsedTime = utils.formatTime({
          secs: elapsedTime,
          minLabel: "m",
          secondsLabel: "s",
        });

        const averageSpeed = parseInt(totalBytesDownloaded / elapsedTime);
        const formattedAverageSpeed = utils.formatBytes(
          Number.isFinite(averageSpeed) ? averageSpeed : 0
        );

        const timeRemaining =
          (totalBytesToDownload - totalBytesDownloaded) / averageSpeed;

        const formattedTimeRemaining =
          timeRemaining && averageSpeed
            ? utils.formatTime({
                secs: timeRemaining,
                minLabel: "m",
                secondsLabel: "s",
              })
            : "-";

        _$("#globalDownloads").html(
          globalFileCardTemplate({
            name: currentDownloadingFile.name,
            currentDownloadingFileNumber: completedFiles.length + 1,
            totalDownloadingFiles: downloadingFiles.length,
            totalBytesToDownload,
            totalBytesDownloaded,
            showProgressBar: true,
            remainingText: t("remaining"),
            downloadingText: t("downloading"),
            speedText: t("speed"),
            cancelText: t("cancel"),
            resumeText: t("resume"),
            pauseText: t("pause"),
            pausingText: t("pausing"),
            cancelingText: t("canceling"),
            averageSpeedText: t("averageSpeed"),
            elapsedText: t("elapsed"),
            skipText: t("skip"),
            completedPercentage,
            downloadedBytesFormatted,
            size,
            elapsedTime: formattedElapsedTime,
            timeRemaining: formattedTimeRemaining,
            overAllSpeed: formattedAverageSpeed,
            ...showCardButtons,
          })
        );

        _$("#globalDownloads #skip-button").on("click", () => {
          const canceled = window.confirm(
            `Are you sure you want to cancel (${currentDownloadingFile.name}) file from downloading?`
          );

          if (canceled) {
            downloadingQueue.cancel();
          }
        });

        _$("#globalDownloads #cancel-button").on("click", () => {
          if (downloadingQueue.queue.length < 1) return;

          const canceled = window.confirm(
            "Are you sure you want to cancel downloading?"
          );

          if (canceled) {
            downloadingQueue.cancel(true);
          }
        });

        _$("#globalDownloads #pause-button").on("click", () => {
          downloadingQueue.pause();
        });

        _$("#globalDownloads #resume-pause-button").on("click", () => {
          downloadingQueue.resume();
        });

        _$("#globalDownloads").removeClass("is-hidden");
      },
    },
    {
      eventName: "updateGlobalDownloadTime",
      callback: () => {
        const currentDownloadingFile =
          downloadingQueue.getCurrentDownloadingFile();
        const downloadingFiles = downloadingQueue.getGlobalDownloadedFiles();
        const completedFiles = downloadingQueue.getCompletedFiles();

        const curFile =
          store.downloadFilesDetails.files[currentDownloadingFile.id];

        let elapsedTime = curFile.timeStatus.elapsedTime;
        let totalBytesToDownload = 0;
        let bytesDownloaded = curFile.progressStatus.bytesDownloaded || 0;

        downloadingFiles.forEach((file) => {
          const _file = store.downloadFilesDetails.files[file.id];
          totalBytesToDownload += Number(_file?.size) || 0;
        });

        completedFiles.forEach((file) => {
          const _file = store.downloadFilesDetails.files[file.id];
          bytesDownloaded += Number(_file?.size) || 0;
          elapsedTime += _file?.timeStatus?.elapsedTime || 0;
        });

        const formattedElapsedTime = utils.formatTime({
          secs: elapsedTime,
          minLabel: "m",
          secondsLabel: "s",
        });

        const averageSpeed = parseInt(bytesDownloaded / elapsedTime);
        const formattedAverageSpeed = utils.formatBytes(
          Number.isFinite(averageSpeed) ? averageSpeed : 0
        );

        const timeRemaining =
          (totalBytesToDownload - bytesDownloaded) / averageSpeed;

        const formattedTimeRemaining =
          timeRemaining && averageSpeed
            ? utils.formatTime({
                secs: timeRemaining,
                minLabel: "m",
                secondsLabel: "s",
              })
            : "-";

        _$("#globalDownloads #elapsedTime").text(formattedElapsedTime);
        _$("#globalDownloads #downloadingAverageSpeed").text(
          `${formattedAverageSpeed}/s`
        );
        _$("#globalDownloads #remainingTime").text(formattedTimeRemaining);
      },
    },
    ...manageSubscribedEventsStoreSubscribeEvents,
  ];

  fileActions.forEach((fileAction) => {
    store.subscribe(fileAction.eventName, fileAction.callback);
  });
};

const getButtonsToShowOnFileCardGlobal = (status) => {
  let button = {
    skipButton: true,
    cancelButton: true,
  };

  const cardButtons = {
    downloading: {
      pauseButton: true,
    },
    pausing: {
      pausingButton: true,
    },
    canceling: {
      skipButton: false,
      cancelButton: false,
      cancelingButton: true,
    },
    paused: {
      resumePauseButton: true,
    },
  };
  const dynamicButtons = cardButtons[status] || { pauseButton: true };
  return { ...button, ...dynamicButtons };
};

const getProgressBarStatusGlobal = (file) => {
  const { downloadedBytes = 0, size } = file;
  let progressBarStatus = {};

  const updatedValue = parseInt(downloadedBytes);

  progressBarStatus.downloadedBytesFormatted = utils.formatBytes(updatedValue);
  progressBarStatus.downloadedBytes = updatedValue;
  progressBarStatus.completedPercentage = `${Math.ceil(
    (updatedValue / size) * 100
  )} %`;

  return progressBarStatus;
};

const removeFilesFocused = () => {
  const gridItemFocused = _$(".grid-item.focused").el();
  const tableTrFocused = _$(".table-tr.focused").el();

  if (gridItemFocused) {
    _$(gridItemFocused).removeClass("focused");
  }

  if (tableTrFocused) {
    _$(tableTrFocused).removeClass("focused");
  }
};

const keyPressListenerForWindowTyping = () => {
  let typedValue = "";
  let clearValueTimer;

  const handleDebounce = utils.debounce((value) => {
    clearTimeout(clearValueTimer);
    clearValueTimer = setTimeout(() => {
      typedValue = "";
    }, 2000);
    value = value.trim();
    if (!value) return;

    const { files } = store;

    let searchedFile = null;

    files.every((file) => {
      const indexMatched = file.name.toLowerCase().indexOf(value.toLowerCase());
      if (indexMatched < 0) return true;

      if (!searchedFile || indexMatched < searchedFile?.indexMatched) {
        searchedFile = { file, indexMatched };
      }

      if (indexMatched === 0) return false;
      return true;
    });

    const findFile = searchedFile?.file;

    if (!findFile) {
      // typedValue = "";
      return;
    }

    removeFilesFocused();

    const findElement = _$(
      ".grid-container,.grid-container.medium-grid-container,.grid-container.large-grid-container,.list-container"
    ).findByAttr("data-uid", findFile.treeIds);

    setTimeout(() => {
      findElement.focus();
      _$(findElement).addClass("focused");
      findElement.scrollIntoView({
        behavior: "smooth",
      });
    }, 0);

    clearTimeout(clearValueTimer);
    clearValueTimer = setTimeout(() => {
      typedValue = "";
    }, 2000);

    utils.debounce();
  }, 0);

  window.addEventListener("keypress", (e) => {
    const element = document.activeElement;

    if (
      element.tagName === "INPUT" &&
      (element.type === "text" || element.type === "email")
    ) {
      return;
    }

    if (_$(document.documentElement).hasClass("crushftp-opened-modal")) {
      return;
    }

    if (utils.lettersOnlyFromEvent(e)) {
      typedValue += e.key;
    }

    handleDebounce(typedValue);
  });
};

const handleHotKeyPress = (e) => {
  if (_$(document.documentElement).hasClass("crushftp-opened-modal")) return;

  const key = e?.code?.substring(e?.code?.length - 1);

  if (key?.length > 1 || !key?.match(/[A-Z0-9]/)) {
    return;
  }

  _$("#user-buttons a")
    .sel()
    .forEach((button) => {
      const hotkey = _$(button).find(".hotkey", true)?.innerText?.toLowerCase();

      if (!hotkey || hotkey !== key?.toLowerCase()) {
        return;
      }

      button.click();
    });
};

const handleHotKeyCancel = (e) => {
  if (e.altKey || e.key === "Alt") {
    if (_$("html").attr("lang") !== "en") return;

    _$("#user-buttons a")
      .sel()
      .forEach((button) => {
        const headerButtonLabel = _$(button).find(".header-button-label");
        const headerButtonLabelText = _$(button)
          .find(".hotkey-template")
          .attr("label");

        headerButtonLabel.text(headerButtonLabelText);
      });

    window.removeEventListener("keydown", handleHotKeyPress);
    window.removeEventListener("keyup", handleHotKeyCancel);
  }
};

/* Move this to a separate file, keyboard actions */
const bindKeyboardEvents = () => {
  keyPressListenerForWindowTyping();

  const handleArrowUp = (e) => {
    if (_$(document.documentElement).hasClass("crushftp-opened-modal")) return;
    const path = hashListener.getPath().split("/");
    path.splice(-2);
    const targetPath = path.join("/") + "/";
    hashListener.setPath(targetPath);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleArrowDown = () => {
    const focusedElementID =
      getFocusedFilesByActiveView()[0]?.getAttribute("data-uid");
    const file = getFileByID(focusedElementID);

    if (file && file.href_path && file.type === fileTypes.DIR) {
      hashListener.setPath(file.href_path, file.type === fileTypes.DIR);
    }
  };

  const handleSelectAllFiles = () => {
    if (_$(document.documentElement).hasClass("crushftp-opened-modal")) return;
    store.dispatch("handleSelectFiles", "checkAll");
    handleFooterSelectionInfo();
  };

  const handleCheckFocusedFiles = () => {
    if (_$(document.documentElement).hasClass("crushftp-opened-modal")) return;
    const focusedElements = getFocusedFilesByActiveView();
    if (focusedElements.length > 2) {
      handleToggleFiles(focusedElements, true);
      handleFooterSelectionInfo();
    }
  };

  window.addEventListener("click", () => {
    if (_$(document.documentElement).hasClass("crushftp-opened-modal")) return;
    if (canRemoveFocusedFiles) {
      removeFilesFocused();
      canRemoveFocusedFiles = false;
    }

    const dragAndDropNotification = _$("#dragTopInfo-notification");
    if (!dragAndDropNotification.hasClass("is-hidden")) {
      dragAndDropNotification.addClass("is-hidden");
    }

    const dragAndDropTooltip = _$("#dndTooltip");
    if (!dragAndDropTooltip.hasClass("is-hidden")) {
      dragAndDropTooltip.addClass("is-hidden");
    }
  });

  //

  const removeAllFocus = () => {
    _$("#dashboard-files-section .table-tr.focused").removeClass("focused");
    _$("#dashboard-files-section .grid-item.focused").removeClass("focused");
  };

  const getFocusedElement = () => {
    const { activeElement } = document;
    if (_$(activeElement).hasClass("focused")) {
      return activeElement;
    }
    return;
  };

  const checkReverseDirection = (from, to) => {
    if (!from || !to) return;

    if (_$(to).hasClass("focused")) {
      _$(from).removeClass("focused");
    }
  };

  const focusFirstElement = () => {
    removeAllFocus();
    const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;

    let firstElement;

    if (gridType === filesViewTypes.LIST) {
      firstElement = _$("#dashboard-files-section .table-tr").sel()[0];
    } else firstElement = _$("#dashboard-files-section .grid-item").sel()[0];

    focusElement(firstElement);
  };

  const hasNextFocusElement = (nextElement) => {
    if (!nextElement) return;

    if (
      _$(nextElement).hasClass("table-tr") ||
      _$(nextElement).hasClass("grid-item")
    ) {
      return true;
    }

    return false;
  };

  const handleRightFileSelect = (e) => {
    const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;
    if (gridType === filesViewTypes.LIST) return;

    const focusedElement = getFocusedElement();

    if (!focusedElement) {
      focusFirstElement();
      return;
    }

    const nextElement = focusedElement.nextElementSibling;
    if (!hasNextFocusElement(nextElement)) return;

    if (!e.shiftKey) {
      removeAllFocus();
    }

    checkReverseDirection(focusedElement, nextElement);
    focusElement(nextElement);
  };

  const handleLeftFileSelect = (e) => {
    const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;
    if (gridType === filesViewTypes.LIST) return;

    const focusedElement = getFocusedElement();

    if (!focusedElement) {
      focusFirstElement();
      return;
    }

    const previousElement = focusedElement.previousElementSibling;
    if (!hasNextFocusElement(previousElement)) return;

    if (!e.shiftKey) {
      removeAllFocus();
    }

    checkReverseDirection(focusedElement, previousElement);
    focusElement(previousElement);
  };

  const handleFileSelectInDirection = (e, direction) => {
    const focusedElement = getFocusedElement();

    if (!focusedElement) {
      focusFirstElement();
      return;
    }

    const gridType = utils.storage.get("activeView") || filesViewTypes.LIST;
    if (gridType === filesViewTypes.LIST) {
      const fileId = _$(focusedElement).attr("data-uid");
      const index = store.files.findIndex((file) => file.id === fileId);
      const file = store.files[index + direction];

      if (!e.shiftKey) {
        lastRangedFocusedElementIDTreeView = null;
      }

      if (!file) {
        return;
      }

      lastFocusedElementIDTreeView = file.id;

      const isItemInView = virtualScroller.isItemInView(index + direction);
      if (!isItemInView) {
        virtualScroller.scrollToIndex(index + direction);
      }

      if (e.shiftKey && lastRangedFocusedElementIDTreeView === null) {
        lastRangedFocusedElementIDTreeView = fileId;
      }
    }

    const { left: leftOfFocusedElement } =
      focusedElement.getBoundingClientRect();

    let targetElement = focusedElement;
    const siblingProperty =
      direction === -1 ? "previousElementSibling" : "nextElementSibling";

    if (targetElement[siblingProperty]) {
      checkReverseDirection(targetElement, targetElement[siblingProperty]);
    }

    while (targetElement) {
      targetElement = targetElement[siblingProperty];
      if (!hasNextFocusElement(targetElement)) return;

      const { left } = targetElement.getBoundingClientRect();

      if (!e.shiftKey) removeAllFocus();
      if (left === leftOfFocusedElement) break;

      focusElement(targetElement);
      if (targetElement[siblingProperty]) {
        checkReverseDirection(targetElement, targetElement[siblingProperty]);
      }
    }
    focusElement(targetElement);
  };

  const handleUpFileSelect = (e) => {
    handleFileSelectInDirection(e, -1);
  };

  const handleDownFileSelect = (e) => {
    handleFileSelectInDirection(e, 1);
  };

  window.addEventListener("keydown", (e) => {
    if (_$(document.documentElement).hasClass("crushftp-opened-modal")) return;

    if ((e.ctrlKey || e.metaKey) && e.key === "ArrowUp") {
      handleArrowUp(e);
      e.preventDefault();
    }

    if ((e.ctrlKey || e.metaKey) && e.key === "ArrowDown") {
      handleArrowDown();
      e.preventDefault();
    }

    if ((e.ctrlKey || e.metaKey) && e.key === "a") {
      handleSelectAllFiles();
      e.preventDefault();
    }

    if (e.ctrlKey && (e.key === " " || e.code === "Space")) {
      handleCheckFocusedFiles();
      e.preventDefault();
    }

    if (e.altKey) {
      const enableHotkeys = utils.getUserCustomizationValue("enableHotkeys");
      if (!enableHotkeys) {
        return;
      }

      e.preventDefault();

      if (e.code === "Digit1") {
        renderFiles({ gridType: filesViewTypes.GRID });
        return;
      } else if (e.code === "Digit2") {
        renderFiles({ gridType: filesViewTypes.MEDIUM_GRID });
        return;
      } else if (e.code === "Digit3") {
        renderFiles({ gridType: filesViewTypes.LARGE_GRID });
        return;
      } else if (e.code === "Digit4") {
        renderFiles({ gridType: filesViewTypes.LIST });
        return;
      }

      if (e.code === "Delete") {
        const curPath = hashListener.getPath();

        userActions.invoke({
          name: "performAction('delete');",
          curPath,
        });
        return;
      }

      if (_$("html").attr("lang") !== "en") return;
      _$("#user-buttons a")
        .sel()
        .forEach((button) => {
          const hotkey = _$(button)
            .find(".hotkey-template span")
            .el()?.innerText;
          const headerButtonLabel = _$(button).find(".header-button-label");
          const headerButtonLabelText = headerButtonLabel.el()?.innerText;

          if (headerButtonLabelText && headerButtonLabelText.includes(hotkey)) {
            const hotkeyTemplate = _$(button)
              .find(".hotkey-template")
              .el()?.innerHTML;
            headerButtonLabel.html(hotkeyTemplate);
          }
        });

      window.addEventListener("keyup", handleHotKeyCancel);
      window.addEventListener("keydown", handleHotKeyPress);
    }

    switch (e.key) {
      case "ArrowUp":
        handleUpFileSelect(e);
        e.preventDefault();
        break;
      case "ArrowLeft":
        handleLeftFileSelect(e);
        e.preventDefault();
        break;
      case "ArrowRight":
        handleRightFileSelect(e);
        e.preventDefault();
        break;
      case "ArrowDown":
        handleDownFileSelect(e);
        e.preventDefault();
        break;
    }
  });
};

const listSearchResults = (response, isSearchFilterActive) => {
  const { listing, privs } = response;
  if (listing) {
    const manipulatedList = listing.map((item) => {
      const id = utils.getUId();
      return {
        ...item,
        privs: item.privs || privs,
        preview: parseInt(item.preview),
        mediaInfo: utils.isMedia(item.name),
        id: `${id}`,
        treeIds: `${id}`,
        paddingLeft: 12,
        ariaExpanded: false,
        isChecked: false,
        canPreventExpand: isSearchFilterActive,
      };
    });

    store.dispatch("setSearchFilterDetails", {
      isSearchFilterActive,
    });
    store.dispatch("setFileListing", manipulatedList);
  }
};

const getRecursiveFilterListing = async (searchValue) => {
  if (!searchValue || searchValue.length === 0) {
    refreshListing();
    return;
  }

  searchFilterRequest?.abort();

  const loader = new Loader({ parentElement: "#dashboard-files-section" });
  const basePath = hashListener.getPath();
  const depthInput = _$("#dashboard-search-depth").el();
  const maxDepth = depthInput
    ? Math.max(1, parseInt(depthInput.value, 10) || 5)
    : 5;

  const fetchListing = (path) => {
    const encodedPath = utils.encodeURILocal(
      path.endsWith("/") ? path : path + "/"
    );
    const c2f = utils.cookie.get("currentAuth");
    return new Promise((resolve) => {
      ajax
        .call({
          data: {
            command: "getXMLListing",
            format: "JSONOBJ",
            path: encodedPath,
          },
          timeout: 30000,
        })
        .then((data) => {
          if (data && data.listing) {
            resolve(data);
          } else {
            resolve({ listing: [], privs: "(view)" });
          }
        })
        .catch(() => {
          resolve({ listing: [], privs: "(view)" });
        });
    });
  };

  try {
    const allItems = [];
    const queue = [{ path: basePath, depth: 0 }];

    while (queue.length > 0) {
      const batch = queue.splice(0, queue.length);
      const promises = batch.map((entry) =>
        fetchListing(entry.path).then((data) => ({ data, depth: entry.depth }))
      );
      const results = await Promise.all(promises);

      for (const { data, depth } of results) {
        const { listing, privs } = data;
        if (!listing) continue;

        for (const item of listing) {
          allItems.push({ ...item, privs: item.privs || privs });

          if (item.type === "DIR" && depth < maxDepth) {
            queue.push({
              path: item.root_dir + item.name + "/",
              depth: depth + 1,
            });
          }
        }
      }
    }

    const filteredItems = utils.filterFiles(allItems, searchValue);

    const manipulatedList = filteredItems.map((item) => {
      const id = utils.getUId();
      return {
        ...item,
        preview: parseInt(item.preview),
        mediaInfo: utils.isMedia(item.name),
        id: `${id}`,
        treeIds: `${id}`,
        paddingLeft: 12,
        ariaExpanded: false,
        isChecked: false,
        canPreventExpand: true,
      };
    });

    store.dispatch("setSearchFilterDetails", {
      isSearchFilterActive: true,
    });
    store.dispatch("setFileListing", manipulatedList);
  } catch (error) {
    console.log(error);
    growl("", t("somethingWentWrongWithFileListing"), 5000, true);
  } finally {
    loader.deleteLoader();
  }
};

const applyFilterInputCustomization = (value = "") => {
  const canUseFilterForSearch =
    utils.getUserCustomizationValue("useFilterForSearch");

  if (!canUseFilterForSearch) return false;

  getRecursiveFilterListing(value);
  return true;
};

const bindEvents = () => {
  tooltipForDashboardFileListing = new FileTooltip({
    parent: _$("#dashboard-files-section").el(),
  });

  tooltipForBasketFileListing = new FileTooltip({
    parent: _$("#basket-files-section").el(),
  });

  quickViewSlider = new QuickViewSlider();

  // Activity Tracking Example
  const createActivityTracking = () =>
    new ActivityTracking({
      activityCountId: "activity-count",
      activityDropDownId: "activity-dropdown",
    });

  activityTracking = createActivityTracking();

  _$("#activitiesContent").el().append(activityTracking.activityModal);

  contextMenu = new ContextMenu({
    contextElementId: "context-menu",
  });

  // Virtual Scroller For List View
  virtualScroller = new VirtualScroller({
    width: "100%",
    height: 500,
    itemHeight: 38,
    maxRowsToShow: 100,
    topOffset: 5,
  });

  // Virtual Scroller For Basket View
  virtualScrollerBasket = new VirtualScroller({
    width: "100%",
    height: 370,
    itemHeight: 38,
    maxRowsToShow: 100,
    topOffset: 5,
  });

  // Virtual Scroller For Download
  virtualScrollerDownload = new VirtualScroller({
    width: "100%",
    itemHeight: 80,
    maxRowsToShow: 10,
    topOffset: 0,
  });

  bindSortEventsGrid();

  _$("#show-mobile-menu").on("click", handleMobileMenu);
  _$("#dashboard-handle-grid-btn").on("click", () => {
    renderFiles({ gridType: filesViewTypes.GRID });
  });
  _$("#dashboard-handle-medium-grid-btn").on("click", () => {
    renderFiles({ gridType: filesViewTypes.MEDIUM_GRID });
  });
  _$("#dashboard-handle-large-grid-btn").on("click", () => {
    renderFiles({ gridType: filesViewTypes.LARGE_GRID });
  });
  _$("#dashboard-handle-grid-list-btn").on("click", () => {
    renderFiles({ gridType: filesViewTypes.LIST });
  });
  _$("#basket_icon").on("click", () => {
    userActions.invoke({
      name: "showBasket",
    });
  });

  const handleSearchValue = utils.debounce((value) => {
    const isApplied = applyFilterInputCustomization(value);
    if (isApplied) return;

    const subfoldersCheckbox = _$("#dashboard-search-in-subfolders").el();
    if (subfoldersCheckbox && subfoldersCheckbox.checked) {
      getRecursiveFilterListing(value);
    } else {
      store.dispatch("searchFilesByValue", value);
    }
  }, 500);

  _$("#dashboard-filter-input").on("input", (e) => {
    const startFileFilterOnlyAfterThisChars = utils.getUserCustomizationValue(
      "startFileFilterOnlyAfterThisChars",
      true
    );
    const inputValue = e.target.value.trim();
    if (startFileFilterOnlyAfterThisChars) {
      if (
        inputValue.length >= startFileFilterOnlyAfterThisChars ||
        inputValue.length === 0
      ) {
        handleSearchValue(inputValue);
      }
    } else {
      handleSearchValue(inputValue);
    }
  });
  _$("#dashboard-directory-sorting").on("click", (e) => {
    utils.storage.set("keepDirectoryOnTop", e.target.checked);
    store.dispatch("setFileListingOnSort");
  });

  bindPaginationListener();
};

//* API Methods

const getCustomRootName = () => {
  const customRootName = utils.getUserCustomizationValue(
    "homeCustomTextFormat",
    true
  );
  if (!customRootName) {
    return null;
  }

  return Object.entries(store.userInfo).reduce((text, [key, value]) => {
    const regex = new RegExp(`{${key}}`, "g");
    return text.replace(regex, value);
  }, customRootName);
};

const renderBreadCrumbs = () => {
  const customRootName = getCustomRootName();
  breadcrumbs.render(hashListener, t, refreshListing, customRootName);

  applyUserCustomizationOption(store.userInfo.userCustomizations?.pathTextSize);
  applyUserCustomizationOption(
    store.userInfo.userCustomizations?.pathTextStyle
  );
};

const enableShowUploadOnlySystem = (manipulatedList, isReload) => {
  const isElectronUploadOnlyApp = utils.isElectron();

  if (isReload) {
    loadNewUploadIFrameMiddleWare();

    const disableUploadBarAnimation = utils.getUserCustomizationValue(
      "disableUploadBarAnimation",
      false
    );
    if (!disableUploadBarAnimation && !isElectronUploadOnlyApp) {
      toast({
        type: "warning",
        position: "top-right",
        message: t("nowAddFilesFromUploadBar"),
        title: t(
          "useUploadBarToAddFilesToUploadClickOnAddFilesButtonToAddFiles"
        ),
        autoClose: true,
        delay: 5000,
      });
    }
  }

  _$("#dashboard-files-section").html("");
  _$("#user-buttons").html(`
        <a id="uploadOnlyButton" tabindex="0" class="navbar-item-label">
          <i class="icon-upload"></i>
          <span data-i18n-key="addFiles">${t("addFiles")}</span>
        </a>
    `);

  _$("#uploadOnlyButton").on("click", (e) => {
    const curPath = hashListener.getPath();
    userActions.invoke({
      name: "upload",
      curPath,
    });
  });

  const elementsToHide = [
    "#basket_icon",
    "#activity-dropdown",
    "body main > div.breadcrumb-container",
    "#dashboard-filter-container",
    "#footer-file-selection-info",
    "#uploadBarSection",
  ];

  elementsToHide.forEach((ele) => {
    _$(ele).remove();
  });
  store.dispatch("setFileListingForUploadOnly", manipulatedList);
};

const getListingHtmlPageName = () => {
  const name = window.listingHTMLPage;
  return typeof name === "string" && name.length > 0 ? name : null;
};

const isListingHtmlPageRedirectBlocked = () => {
  return utils.getUserCustomizationValue("uploadOnly") || utils.isElectron();
};

const normalizeVfsPath = (path) => {
  let p = utils.decodeURILocal(path || "/");
  if (!p.startsWith("/")) p = "/" + p;
  return p;
};

const LISTING_HTML_FILE_NAMES = ["index.html", "index.htm"];

const LISTING_HTML_EXIT_STORAGE_KEY = "crushListingWebHtmlExit";

const normListingDirPath = (path) => {
  let x = normalizeVfsPath(path || "/");
  if (!x.endsWith("/")) x += "/";
  return x;
};

const getListingHtmlParentHashPathForVfsDir = (vfsPath) => {
  let dir = normalizeVfsPath(vfsPath);
  if (!dir.endsWith("/")) dir += "/";
  let parentHashPath = "/";
  if (dir !== "/") {
    const noTrail = dir.replace(/\/+$/, "");
    const i = noTrail.lastIndexOf("/");
    parentHashPath = i <= 0 ? "/" : noTrail.slice(0, i + 1);
  }
  return parentHashPath;
};

const buildSpaUrlWithHashPath = (hashPath) => {
  return window.location.pathname + window.location.search + "#" + hashPath;
};

const listingWebHtmlPersistExitSnapshot = (vfsPath) => {
  const parent = getListingHtmlParentHashPathForVfsDir(vfsPath);
  const vfsKey = normListingDirPath(vfsPath);
  try {
    sessionStorage.setItem(
      LISTING_HTML_EXIT_STORAGE_KEY,
      JSON.stringify({ vfs: vfsKey, parent })
    );
  } catch (e) {}
};

const pathPointsToListingHtmlPage = (path, htmlPage) => {
  const p = normalizeVfsPath(path).toLowerCase();
  const names = new Set(
    [htmlPage, ...LISTING_HTML_FILE_NAMES]
      .filter(Boolean)
      .map((n) => n.toLowerCase())
  );
  for (const file of names) {
    if (p === file || p.endsWith("/" + file)) return true;
  }
  return false;
};

const stripListingHtmlFileFromPath = (path, htmlPage) => {
  let p = normalizeVfsPath(path);
  const lower = p.toLowerCase();
  const names = new Set(
    [htmlPage, ...LISTING_HTML_FILE_NAMES]
      .filter(Boolean)
      .map((n) => n.toLowerCase())
  );
  for (const file of names) {
    const suffix = "/" + file;
    if (lower === file || lower.endsWith(suffix)) {
      const idx = lower.lastIndexOf(suffix);
      if (idx === 0) return "/";
      if (idx > 0) return p.substring(0, idx + 1);
    }
  }
  if (!p.endsWith("/")) p += "/";
  return p;
};

const buildVfsAbsoluteUrl = (vfsPath, fileName) => {
  const dirPath = stripListingHtmlFileFromPath(vfsPath, fileName);
  return window.location.origin + dirPath + fileName;
};

const replaceSpaHistoryWithParentHashThenNavigateToListingHtml = (
  vfsPath,
  htmlPage
) => {
  listingWebHtmlPersistExitSnapshot(vfsPath);
  const parentHashPath = getListingHtmlParentHashPathForVfsDir(vfsPath);
  const nextUrl = buildSpaUrlWithHashPath(parentHashPath);
  try {
    history.replaceState(null, document.title, nextUrl);
  } catch (e) {
    console.log(e);
  }
  window.redirectingToLink = true;
  window.location.replace(buildVfsAbsoluteUrl(vfsPath, htmlPage));
};

const shouldRedirectPathToListingHtml = (path, htmlPage) => {
  const normalized = normalizeVfsPath(path);
  if (pathPointsToListingHtmlPage(normalized, htmlPage)) return true;
  const lastSegment = normalized.replace(/\/$/, "").split("/").pop() || "";
  const ext = utils.getFileExtension(lastSegment);
  return !ext;
};

const tryRedirectToListingHtmlPage = (path) => {
  const htmlPage = getListingHtmlPageName();
  if (!htmlPage || isListingHtmlPageRedirectBlocked()) return false;
  if (!shouldRedirectPathToListingHtml(path, htmlPage)) return false;
  replaceSpaHistoryWithParentHashThenNavigateToListingHtml(path, htmlPage);
  return true;
};

const handleWebServerModeRedirect = (vfsPath) => {
  const htmlPage = getListingHtmlPageName() || "index.html";
  replaceSpaHistoryWithParentHashThenNavigateToListingHtml(vfsPath, htmlPage);
};

const fetchListingFromPath = (
  path = "/",
  isReload = false,
  scrollTopBeforeRerender = 0
) => {
  if (tryRedirectToListingHtmlPage(path)) return;

  showSkeleton();
  _$("#listing-pagination-wrapper").addClass("is-hidden");

  const listingLoader = new Loader({
    parentElement: "#dashboard-files-section",
  });

  getListingFromPath(path)
    .then(async (data) => {
      if (data?.web_server_mode === "true" || data?.web_server_mode === true) {
        handleWebServerModeRedirect(path);
        return;
      }

      const error_msg = data?.error_msg;

      if (error_msg) {
        growl(
          "",
          error_msg === "string"
            ? error_msg
            : t("somethingWentWrongWithFileListing"),
          5000,
          true
        );
      }

      // set current directory info into store
      const folderInfo = { ...data };
      delete folderInfo.listing;
      store.dispatch("setCurrentDirInfo", { ...folderInfo });
      // set current directory info into store
      const { listing = [], privs = "(view)" } = data;
      if (listing) {
        const manipulatedList = listing.map((item) => {
          const id = utils.getUId();
          return {
            ...item,
            privs: item.privs || privs,
            preview: parseInt(item.preview),
            mediaInfo: utils.isMedia(item.name),
            id: `${id}`,
            treeIds: `${id}`,
            paddingLeft: 12,
            ariaExpanded: false,
            isChecked: false,
          };
        });
        if (isReload) {
          initFilters();
          bindEvents();
          bindKeyboardEvents();
          initBasket();
          const showSubscribedEventsIcon = utils.getUserCustomizationValue(
            "showSubscribedEventsIcon"
          );
          if (showSubscribedEventsIcon) {
            await fetchReverseNotificationDataAndStoreInRedux();
          }
        }

        // Enables show upload only system
        const showUploadOnly = utils.getUserCustomizationValue("uploadOnly");
        const isElectronUploadOnlyApp = utils.isElectron();

        if (showUploadOnly || isElectronUploadOnlyApp) {
          enableShowUploadOnlySystem(manipulatedList, isReload);
          return;
        }
        const showReadOnlyBanner =
          utils.getUserCustomizationValue("showReadOnlyBanner");
        if (showReadOnlyBanner && privs.indexOf("write") < 0) {
          _$("#readonly-banner").removeClass("is-hidden");
        } else {
          _$("#readonly-banner").addClass("is-hidden");
        }
        try {
          const comment = privs.match(/\(comment(.*?)\)/)?.[1];
          if (comment) {
            const decodeComment = (text) => {
              const decoded = decodeURIComponent(text);
              if (decoded === text) {
                return text;
              }
              return decodeComment(decoded);
            };

            _$("#vfs-comments").html(
              utils.sanitizePure(decodeComment(comment))
            );
          } else {
            _$("#vfs-comments").html("");
          }
        } catch (error) {
          console.log(error);
        }
        applyFilterFromQueryStringIfPresent();
        store.dispatch("setFileListing", manipulatedList);
        try {
          onReloadPageCustomizations();
        } catch (error) {
          console.log(error);
        }
      }

      const filesViewType =
        utils.storage.get("activeView") || filesViewTypes.LIST;
      if (filesViewType === filesViewTypes.LIST) {
        for (const path of expandedFolderSet) {
          await checkAndToggleExpandedFolder(path, null);
        }
        if (virtualScroller?.container) {
          virtualScroller.container.scrollTop = scrollTopBeforeRerender;
        }
      } else {
        expandedFolderSet.clear();
      }
    })
    .catch((error) => {
      console.log(error);

      if (isReload) {
        initFilters();
        bindEvents();
        bindKeyboardEvents();
        initBasket();
      }
      store.dispatch("setCurrentDirInfo", {});
      growl("", t("somethingWentWrongWithFileListing"), 5000, true);
      applyFilterFromQueryStringIfPresent();
      store.dispatch("setFileListing", []);
    })
    .finally(() => {
      if (isReload) {
        initAdvancedDownload();
        loadNewUploadIFrameMiddleWare();

        const autoPreviewMediaOnLoad = utils.getUserCustomizationValue(
          "autoPreviewMediaOnLoad"
        );

        if (autoPreviewMediaOnLoad) {
          userActions.invoke({
            name: "quickView",
            loadedPath: hashListener.getPath(),
            curPath: hashListener.getPath(),
          });
        }
      }

      listingLoader.deleteLoader();
      renderBreadCrumbs();
      initUploadBarSection();
    });
};

const applyListingWebHtmlStaleHashRepairIfNeeded = (path) => {
  let snap;
  try {
    const raw = sessionStorage.getItem(LISTING_HTML_EXIT_STORAGE_KEY);
    if (!raw) return false;
    snap = JSON.parse(raw);
  } catch (e) {
    try {
      sessionStorage.removeItem(LISTING_HTML_EXIT_STORAGE_KEY);
    } catch (e2) {}
    return false;
  }
  if (
    !snap ||
    typeof snap.vfs !== "string" ||
    typeof snap.parent !== "string"
  ) {
    try {
      sessionStorage.removeItem(LISTING_HTML_EXIT_STORAGE_KEY);
    } catch (e) {}
    return false;
  }
  const cur = normListingDirPath(path || "/");
  const vfs = normListingDirPath(snap.vfs);
  if (cur === vfs) {
    try {
      sessionStorage.removeItem(LISTING_HTML_EXIT_STORAGE_KEY);
    } catch (e) {}
    const nextUrl = buildSpaUrlWithHashPath(snap.parent);
    try {
      history.replaceState(null, document.title, nextUrl);
    } catch (e) {
      console.log(e);
    }
    fetchListingFromPath(snap.parent, true);
    return true;
  }
  try {
    sessionStorage.removeItem(LISTING_HTML_EXIT_STORAGE_KEY);
  } catch (e) {}
  return false;
};

const checkUserStatus = async (suppressRedirect = false) => {
  const sessionInfoDiv = _$("#session-info");
  await isLoggedIn()
    .then((res) => {
      init();
      utils.storage.set("loggedUsername", res.username);
      sessionChecker = new SessionChecker({
        hashListener,
        events: (evt) => {
          if (evt === "loggedout") {
            logout(true).catch(console.error);
          }

          if (evt === "redirectOnLogout") {
            const url = utils.getUserCustomizationValue(
              "LogoutCustomRedirectPath",
              true
            );

            const noRedirectToLoginAfterAutoLogout =
              utils.getUserCustomizationValue(
                "noRedirectToLoginAfterAutoLogout"
              );
            if (!noRedirectToLoginAfterAutoLogout || url) {
              logout(true).catch(console.error);
            }
          }
        },
        update: (txt) => {
          sessionInfoDiv.text(txt);
          _$("#profileSessionInfo").text(txt);
        },
      });
    })
    .catch((ex) => {
      console.log(ex);
      // Always redirect to login page instead of showing modal
      // This prevents showing modal while uploads/downloads continue
      logout(true).catch(console.error);
    });
};

//* End API Methods
const onReloadPageCustomizations = () => {
  const files = store.files;
  const maxListItemsBeforeShowingWarning = utils.getUserCustomizationValue(
    "maxListItemsBeforeShowingWarning",
    true
  );

  if (parseInt(maxListItemsBeforeShowingWarning) < files.length) {
    const maxListItemsWarningMessage = utils.getUserCustomizationValue(
      "maxListItemsWarningMessage",
      true
    );

    growl(
      maxListItemsWarningMessage || t("largeDirListingDefaultWarning"),
      t("warning"),
      null,
      true
    );
  }

  const userOptionsPreference =
    JSON.parse(localStorage.getItem("userOptions")) || {};
  store.dispatch("handleSetUserOptions", {
    preferenceData: userOptionsPreference,
    userOptions: userOptionsPreference,
  });
};

const initUploadBarSection = () => {
  const hideUploadBar = utils.getUserCustomizationValue("hideUploadBar");
  const hideDNDUploadInfoText = utils.getUserCustomizationValue(
    "hideDNDUploadInfoText"
  );

  const { privs } = store?.currentDirectoryInfo;
  let hasDirectoryUploadPermission = privs?.includes("(write)");

  if (privs?.includes("(locked)") && privs?.includes("(expired)")) {
    hasDirectoryUploadPermission = false;
  }

  if (hideUploadBar || !hasDirectoryUploadPermission) {
    _$("#uploadBarSectionWrapper").html("");
    return;
  }

  _$("#uploadBarSectionWrapper").html(
    uploadBarSectionTemplate({
      hideDNDUploadInfoText,
      addFilesText: t("addFiles"),
      dragAndDropFileAndFoldersHereToUploadText: t(
        "dragAndDropFileAndFoldersHereToUpload",
        {},
        "Drag & Drop Files and Folders Here To Upload"
      ),
    })
  );

  _$("#fileInputGlobal").on("change", (e) => {
    const fileObj = e.target.files;
    showUploadModalAndListFiles(fileObj);

    //Remove file selection as its no longer required
    _$("#fileInputUploadModal").val("");
  });

  _$("#globalAddFilesButton").on("click", () => {
    _$("#fileInputGlobal").el().click();
  });
};

const FILTER_ON_LOAD_STORAGE_KEY = "crushListingFilterOnLoad";

const getFilterFromHashQuery = () => {
  const hash = window.location.hash || "";
  const raw = hash.replace(/^#/, "");
  let decoded = raw;
  try {
    decoded = utils.decodeURILocal(raw);
  } catch (e) {
    try {
      decoded = decodeURIComponent(raw.replace(/\+/g, " "));
    } catch (err) {
      decoded = raw;
    }
  }
  const match = /\/\?filter=([^&]*)$/i.exec(decoded);
  if (!match) return { keyword: "", path: decoded || "/" };
  let keyword = match[1] || "";
  try {
    keyword = decodeURIComponent(keyword.replace(/\+/g, " ")).trim();
  } catch (e) {
    keyword = keyword.trim();
  }
  return {
    keyword,
    path: decoded.slice(0, match.index + 1) || "/",
  };
};

const applyFilterFromQueryStringIfPresent = () => {
  if (appliedFilterFromQuery) return;
  let keyword = (utils.queryString("filter") || "").trim();
  const hashFilter = getFilterFromHashQuery();
  let storedFilter = "";
  try {
    storedFilter = (
      sessionStorage.getItem(FILTER_ON_LOAD_STORAGE_KEY) || ""
    ).trim();
  } catch (e) {}
  if (!keyword) {
    keyword = hashFilter.keyword;
  }
  if (!keyword) {
    keyword = storedFilter;
  }
  if (!keyword) return;
  const filterInput = _$("#dashboard-filter-input");
  if (!filterInput.el()) return;
  appliedFilterFromQuery = true;
  filterInput.val(keyword);
  try {
    sessionStorage.removeItem(FILTER_ON_LOAD_STORAGE_KEY);
  } catch (e) {}
  try {
    const url = new URL(window.location.href);
    let changed = false;
    if (url.searchParams.has("filter")) {
      url.searchParams.delete("filter");
      changed = true;
    }
    if (hashFilter.keyword) {
      url.hash = hashFilter.path.startsWith("#")
        ? hashFilter.path
        : `#${hashFilter.path}`;
      changed = true;
      if (hashListener) {
        hashListener.hash = url.hash;
      }
    }
    if (changed) {
      history.replaceState(
        null,
        document.title,
        url.pathname + url.search + url.hash
      );
    }
  } catch (e) {
    console.log(e);
  }
};

const initFilters = () => {
  const enableColumnArrangement = utils.getUserCustomizationValue(
    "enableColumnArrangement"
  );

  const showExpandCollapseAllForTreeView = utils.getUserCustomizationValue(
    "showExpandCollapseAllForTreeView"
  );

  const hideKeepDirectoryOnTop = utils.getUserCustomizationValue(
    "hideKeepDirectoryOnTop"
  );

  _$("#dashboard-filter-container").html(
    FilterSectionTemplate({
      prefixId: "dashboard",
      ...FilterSectionTexts(),
      enableColumnArrangement,
      showExpandCollapseAllForTreeView,
      hideKeepDirectoryOnTop,
    })
  );

  _$("#arrangeFileListingTableColumns").on("click", () => {
    initListingColumnArrangement();
  });

  _$("#dashboard-more-filters-toggle").on("click", () => {
    const panel = _$("#dashboard-advanced-filter-panel");
    const toggleBtn = _$("#dashboard-more-filters-toggle");
    if (panel.el()) {
      panel.toggleClass("is-hidden");
      toggleBtn.toggleClass("is-active");
    }
  });

  _$("#dashboard-search-in-subfolders").on("change", (e) => {
    const depthInput = _$("#dashboard-search-depth").el();
    if (depthInput) {
      depthInput.disabled = !e.target.checked;
    }

    const filterValue = _$("#dashboard-filter-input").val();
    if (filterValue && filterValue.trim().length > 0) {
      if (e.target.checked) {
        getRecursiveFilterListing(filterValue.trim());
      } else {
        refreshListing();
        store.dispatch("setSearchFilterDetails", {
          ...store.searchFilterDetails,
          isSearchFilterActive: false,
        });
        setTimeout(() => {
          _$("#dashboard-filter-input").val(filterValue);
          store.dispatch("searchFilesByValue", filterValue.trim());
        }, 500);
      }
    }
  });

  _$("#dashboard-clear-search-filter").on("click", () => {
    refreshListing();

    const subfoldersCheckbox = _$("#dashboard-search-in-subfolders").el();
    if (subfoldersCheckbox) {
      subfoldersCheckbox.checked = false;
      const depthInput = _$("#dashboard-search-depth").el();
      if (depthInput) depthInput.disabled = true;
    }

    store.dispatch("setSearchFilterDetails", {
      ...store.searchFilterDetails,
      isSearchFilterActive: false,
    });
  });

  const keepDirectoriesOnTopWhileSorting = utils.getUserCustomizationValue(
    "keepDirectoriesOnTopWhileSorting",
    true
  );

  if (keepDirectoriesOnTopWhileSorting) {
    utils.storage.set("keepDirectoryOnTop", keepDirectoriesOnTopWhileSorting);
  }

  const isKeepDirectoryOnTop = JSON.parse(
    utils.storage.get("keepDirectoryOnTop")
  );

  if (_$("#dashboard-directory-sorting").el()) {
    _$("#dashboard-directory-sorting").el().checked = isKeepDirectoryOnTop;
  }

  // Listener for select menu
  selectFileTypes.forEach((selectType) => {
    _$(`#dashboard-${selectType}`).on("click", () => {
      store.dispatch("handleSelectFiles", selectType);
    });
  });

  _$("#expandAllFolderListing").on("click", () => {
    const { expandingOrCollapsingInProcess } =
      store?.expandAllAndCollapseAllDetails;

    if (expandingOrCollapsingInProcess) return;

    store.dispatch("handleExpandAllDashboardListing");
  });

  _$("#collapseAllFolderListing").on("click", () => {
    const { expandingOrCollapsingInProcess } =
      store?.expandAllAndCollapseAllDetails;

    if (expandingOrCollapsingInProcess) return;

    store.dispatch("handleCollapseAllDashboardListing");
  });

  applyUserCustomizationOption(
    store.userInfo.userCustomizations.hideFilterPanel
  );

  applyUserCustomizationOption(
    store.userInfo.userCustomizations.hideSelectionLink
  );

  applyUserCustomizationOption(
    store.userInfo.userCustomizations.hideViewSelector
  );
};

function initBasket() {
  const basketDiv = utils.createElement("div", [
    "w-full",
    "h-full",
    "basket-files-section",
  ]);
  basketDiv.innerHTML = ListingTemplatesBasket.Container({});

  const isFullScreen = utils.getUserCustomizationValue("basket_Maximized");

  basket = new Modal({
    title: "filesInTheBasket",
    body: basketDiv,
    animate: false,
    show: false,
    backdrop: false,
    movable: true,
    closable: false,
    hasResizeOption: true,
    destroyOnClose: false,
    isFullScreen,
    uniqueId: "UI_Basket",
    extraClasses: ["basket-resizable-dialog"],
    minWidth: "800px",
    minHeight: "575px",
    onAfterShow: () => {
      applyUserCustomizationOption(
        store.userInfo.userCustomizations?.basket_HideDownload
      );
      applyUserCustomizationOption(
        store.userInfo.userCustomizations?.basket_HideShare
      );
    },
    onAfterResize: () => resizeBasket(),
    onAfterFullscreen: () => resizeBasket(),
    buttons: [
      {
        label: "shareItems",
        leftIconClasses: ["icon-share"],
        classes: [
          "primary-button",
          "is-bg-none",
          "py-0",
          "share-basket-button",
        ],
        onClick: () => {
          userActions.invoke({
            name: "share",
            fromBasket: true,
          });
        },
      },
      {
        label: "downloadBasket",
        leftIconClasses: ["icon-download-alt"],
        classes: [
          "primary-button",
          "is-bg-none",
          "py-0",
          "download-basket-button",
        ],
        onClick: () => {
          const { files } = store.basketDetails;
          let shouldBeZip = true;
          if (files.length === 1 && files[0].type === fileTypes.FILE) {
            shouldBeZip = false;
          }
          userActions.invoke({
            name: "download",
            zip: shouldBeZip,
            fromBasket: true,
          });
        },
      },
      {
        label: "clearAll",
        leftIconClasses: ["icon-remove-sign", "text-error"],
        classes: ["primary-button", "is-bg-none", "py-0"],
        onClick: () => {
          store.dispatch("handleClearBasket");
        },
      },
    ],
  });

  _$("#basket-filter-container").html(
    FilterSectionTemplate({
      prefixId: "basket",
      dropdownParent: "#modal_UI_Basket",
      ...FilterSectionTexts(),
    })
  );

  applyUserCustomizationOption(
    store.userInfo.userCustomizations?.basket_NoViewChange
  );
  applyUserCustomizationOption(
    store.userInfo.userCustomizations?.basket_HideFilter
  );

  _$("#basket-filter-select-dropdown").addClass("is-hidden");
  _$("#basket-handle-grid-btn").on("click", () => {
    renderFilesInBasket({ gridType: filesViewTypes.GRID });
  });
  _$("#basket-handle-medium-grid-btn").on("click", () => {
    renderFilesInBasket({ gridType: filesViewTypes.MEDIUM_GRID });
  });
  _$("#basket-handle-large-grid-btn").on("click", () => {
    renderFilesInBasket({ gridType: filesViewTypes.LARGE_GRID });
  });
  _$("#basket-handle-grid-list-btn").on("click", () => {
    renderFilesInBasket({ gridType: filesViewTypes.LIST });
  });
  _$("#basket-directory-sorting").on("click", (e) => {
    store.dispatch("setBasketItemsOnDirectorySort");
  });

  bindSortEventsBasketGrid();
  renderFilesInBasket({});

  _$("#basket-filter-input").on(
    "input",
    utils.debounce((e) => {
      store.dispatch("filterBasketItems", e.target.value);
    }, 350)
  );

  // new Dropdown({ parent: "#modal_UI_Basket" });
}

const handleDownloadFromPath = (path) => {
  welcomFormSubmitCallback = () => {
    const fileToDownload = path;
    const pathToLoad = path.substring(0, path.lastIndexOf("/") + 1);
    ajax.iframeSubmit({
      "#command": "download",
      "#path": utils.encodeURILocal(fileToDownload),
    });
    setTimeout(() => {
      hashListener.setPath(pathToLoad);
    }, 100);
  };
  const waitFormSubmitForDownload = utils.getUserCustomizationValue(
    "waitFormSubmitForDownload"
  );
  if (!waitFormSubmitForDownload) {
    welcomFormSubmitCallback();
    welcomFormSubmitCallback = () => {};
  }
};

const isBase64CrushHashPath = (path) => {
  return (
    typeof path === "string" &&
    (path.startsWith("BASE64CRUSH_") || path.startsWith("/BASE64CRUSH_"))
  );
};

const shouldTreatPathAsFile = (path, response) => {
  if (typeof response === "string" && response.includes("type=FILE")) {
    return true;
  }
  if (typeof response === "string" && response.includes("type=DIR")) {
    return false;
  }
  if (
    !path ||
    path === "/" ||
    path.endsWith("/") ||
    isBase64CrushHashPath(path)
  ) {
    return false;
  }
  const lastSegment = path.replace(/\/$/, "").split("/").pop() || "";
  return Boolean(utils.getFileExtension(lastSegment));
};

const downloadFilePathUnlessListingHtml = (path) => {
  const htmlPage = getListingHtmlPageName();
  if (
    htmlPage &&
    !isListingHtmlPageRedirectBlocked() &&
    pathPointsToListingHtmlPage(path, htmlPage)
  ) {
    tryRedirectToListingHtmlPage(path);
    return;
  }
  handleDownloadFromPath(path);
};

const initHashListener = () => {
  let isRefreshEnable = false;
  hashListener = new HashListener({
    onInit: (path) => {
      if (applyListingWebHtmlStaleHashRepairIfNeeded(path)) return;
      if (isBase64CrushHashPath(path)) return;
      if (tryRedirectToListingHtmlPage(path)) return;
      if (path && path != "/" && !path.endsWith("/")) {
        apiCall("stat", {
          path: utils.encodeURILocal(path),
          format: "stat_dmz",
        })
          .then((result) => {
            const response = result?.commandResult?.response;
            if (shouldTreatPathAsFile(path, response)) {
              downloadFilePathUnlessListingHtml(path);
              isRefreshEnable = true;
            } else {
              fetchListingFromPath(path, true);
            }
          })
          .catch((error) => {
            console.log(error);
            if (shouldTreatPathAsFile(path, "")) {
              downloadFilePathUnlessListingHtml(path);
              isRefreshEnable = true;
            } else {
              fetchListingFromPath(path, true);
            }
          });
      } else {
        fetchListingFromPath(path, true);
      }
    },
    onChange: (path, base64) => {
      appliedFilterFromQuery = false;
      if (
        store.searchFilterDetails &&
        store.searchFilterDetails.isSearchFilterActive
      ) {
        store.dispatch("setSearchFilterDetails", {
          ...store.searchFilterDetails,
          isSearchFilterActive: false,
        });
      }
      _$("#dashboard-filter-input").val("");

      if (applyListingWebHtmlStaleHashRepairIfNeeded(path)) return;
      if (isBase64CrushHashPath(path)) return;
      if (tryRedirectToListingHtmlPage(path)) return;

      if (path && path != "/" && !path.endsWith("/")) {
        apiCall("stat", {
          path: utils.encodeURILocal(path),
          format: "stat_dmz",
        })
          .then((result) => {
            const response = result?.commandResult?.response;
            if (shouldTreatPathAsFile(path, response)) {
              downloadFilePathUnlessListingHtml(path);
              isRefreshEnable = true;
            } else {
              fetchListingFromPath(path, isRefreshEnable || base64);
              isRefreshEnable = false;
            }
          })
          .catch((error) => {
            console.log(error);
            if (shouldTreatPathAsFile(path, "")) {
              downloadFilePathUnlessListingHtml(path);
              isRefreshEnable = true;
            } else {
              fetchListingFromPath(path, isRefreshEnable || base64);
              isRefreshEnable = false;
            }
          });
      } else {
        fetchListingFromPath(path, isRefreshEnable || base64);
      }
    },
  });
  window.addEventListener("pageshow", (e) => {
    if (!e.persisted || !hashListener) {
      return;
    }
    applyListingWebHtmlStaleHashRepairIfNeeded(hashListener.getPath());
  });
};

const selectLanguageForListingPage = () => {
  const canSaveLanguageSelectionInCookie = utils.getUserCustomizationValue(
    "saveLanguageSelectionInCookie"
  );
  const selectedLanguage = localStorage.getItem("selected-language");

  if (canSaveLanguageSelectionInCookie && selectedLanguage) {
    return;
  }

  if (selectedLanguage) {
    localStorage.removeItem("selected-language");
  }

  const detectBrowserLanguage = utils.getUserCustomizationValue(
    "detectBrowserLanguage"
  );

  if (detectBrowserLanguage) {
    const browserLanguage = navigator.language || navigator.userLanguage;
    const isSupportedFull = utils.doWeSupportThisLanguage(browserLanguage);
    if (isSupportedFull) {
      setLanguage(browserLanguage);
    } else if (browserLanguage.indexOf("-") >= 0) {
      const language = browserLanguage.split("-")[0];
      const isSupportedBase = utils.doWeSupportThisLanguage(language);
      if (isSupportedBase) {
        setLanguage(language);
      }
    }
    return;
  }

  const defaultWILanguage = utils.getUserCustomizationValue(
    "defaultWILanguage",
    true
  );

  if (defaultWILanguage) {
    setLanguage(defaultWILanguage);
    return;
  }

  setLanguage("en");
};

const enableForceTwoFactorAuth = () => {
  initTwoFactorAuthForceModal();
  _$("#dashboard-files-section").html("");
  _$("#user-buttons").html("");

  const elmentsToRemove = [
    "#basket_icon",
    "#activity-dropdown",
    "#localization-languages",
  ];
  elmentsToRemove.forEach((ele) => {
    _$(ele).remove();
  });
};

const handleBase64URL = () => {
  const hashLocation = utils.decodeURILocal(
    hashListener.getHash().toString().replace("#", "")
  );
  if (
    hashLocation.indexOf("/BASE64CRUSH_") == 0 ||
    hashLocation.indexOf("BASE64CRUSH_") == 0
  ) {
    if (hashLocation.indexOf("/") == 0) {
      hashListener.setPath(hashLocation.replace("/", ""), true, true);
    }

    if (hashLocation.lastIndexOf("/") == hashLocation.length - 1) {
      hashListener.setPath(
        hashLocation.substring(0, hashLocation.length - 1),
        false,
        true
      );
    }
    const path = decodeURIComponent(
      escape(atob(hashLocation.replace("BASE64CRUSH_", "")))
    );
    hashListener.setPath(path, false, true);
    return path;
  }
};

function init() {
  subscribe();
  profileInfo();

  const headerLoader = new Loader({ parentElement: ".user-buttons-section" });

  // Get user info
  getUserInfo()
    .then((res) => {
      // Creates customizations array for listing page and put it in store
      const { customizations_subitem } = res.customizations;
      const userCustomizations = {};

      if (Array.isArray(customizations_subitem)) {
        customizations_subitem.forEach((item) => {
          userCustomizations[item.key] = { ...item };
        });
      }

      store.dispatch("setUserInfo", { ...res, userCustomizations });

      // Select language for listing page
      selectLanguageForListingPage();
      initHashListener();
      const base64Path = handleBase64URL();

      RenderWelcomeForm(() => {
        if (welcomFormSubmitCallback) {
          welcomFormSubmitCallback();
          welcomFormSubmitCallback = () => {};
        }
      });

      // stores user options modal data into store
      let userOptions = store.userOptions;
      if (userOptions.phoneNumber) {
        userOptions.phoneNumber.phoneNo =
          typeof res.phone === "string" ? res.phone : "";
      }

      const userOptionsPreference =
        JSON.parse(localStorage.getItem("userOptions")) || null;
      if (userOptionsPreference) {
        userOptions.preference = userOptionsPreference;
      }

      store.dispatch("setUserOptions", userOptions);

      // Enables force two factor auth system
      const { twofactor_secret_confirmed } = res;
      const forceTwoFactorAuth = utils.getUserCustomizationValue(
        "twofactor_force_google_enrollment"
      );

      if (twofactor_secret_confirmed !== "true" && forceTwoFactorAuth) {
        enableForceTwoFactorAuth();
        headerLoader.deleteLoader();
        return;
      }

      _$("#logo-container .skeleton").remove();
      _$("#logo-container .logo").removeClass("is-hidden");

      //Load dirs
      const curPath = hashListener.getPath();
      if (!base64Path && !shouldTreatPathAsFile(curPath, "")) {
        fetchListingFromPath(curPath, true);
      }
      headerLoader.deleteLoader();

      const redirectRoot = utils.getUserCustomizationValue(
        "redirectRoot",
        true
      );
      if (redirectRoot && curPath === "/") document.location = redirectRoot;
    })
    .catch((error) => {
      store.dispatch("setUserInfo", {});
      console.error("getUserInfo failed:", error);

      // Show error modal with detailed debug information
      showGetUserInfoErrorModal(error, {
        onReload: () => {
          window.location.reload();
        },
        onLogout: () => {
          const logoutRedirectPath = "/WebInterface/login.html";
          doLogout(logoutRedirectPath).finally(() => {
            utils.cookie.remove("currentAuth");
            window.location = logoutRedirectPath;
          });
        },
      });
    });
}

let c2fWatcherId = null;
let lastC2fValue = null;
const startC2fWatcher = () => {
  const normalize = (val) => (val && val !== "null" ? val : "");
  lastC2fValue = normalize(utils.cookie.get("currentAuth"));
  console.log("[c2fWatcher] init lastC2fValue:", lastC2fValue || "<empty>");
  if (c2fWatcherId) return;
  c2fWatcherId = setInterval(() => {
    const current = normalize(utils.cookie.get("currentAuth"));
    if (current !== lastC2fValue) {
      console.log("[c2fWatcher] detected change", {
        prev: lastC2fValue || "<empty>",
        next: current || "<empty>",
      });
      lastC2fValue = current;
      console.log("[c2fWatcher] calling checkUserStatus()...");
      checkUserStatus(true)
        .then(() => {
          console.log("[c2fWatcher] checkUserStatus() completed");
        })
        .catch((error) => {
          console.log("[c2fWatcher] checkUserStatus() error:", error);
        });
    }
  }, 1000);
};

window.onbeforeunload = confirmExit;

//On DOM Ready
_$("body").ready(() => {
  checkUserStatus();
  startC2fWatcher();

  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var isIOS =
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  var chrome = navigator.userAgent.match("CriOS");

  if (isSafari && isIOS && !chrome) {
    document.body.classList.add("safari-ios");
  }
  function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }
  ``;
  if (isMobileDevice()) {
    document.body.classList.add("is-mobile");
  }

  new Dropdown({});
});

// Common method to create no files available container
const createNoFilesAvailableContainer = (
  additionalClasses = "",
  failed = false
) => {
  const listContainer = _$("<div>").el();
  listContainer.className =
    `h-full is-flex is-align-items-center is-justify-content-center is-flex-direction-column empty-list ${additionalClasses}`.trim();
  if (failed) {
    listContainer.innerHTML = `<p class="text-base text-primaryMain has-text-weight-semibold mb-2" data-i18n-key="somethingWentWrongWithFileListing">${t(
      "somethingWentWrongWithFileListing"
    )}</p>${utils.getWebInterfaceImageTag("error-listing.png", {
      alt: "somethingWentWrongWithFileListing",
    })}`;
  } else {
    listContainer.innerHTML = `<p class="text-base text-primaryMain has-text-weight-semibold mb-2" data-i18n-key="noFilesAvailable">${t(
      "noFilesAvailable"
    )}</p>${utils.getWebInterfaceImageTag("no-file-found.png", {
      alt: "noFilesAvailable",
    })}`;
  }
  return listContainer;
};
